const translations = {
  es: {
    // Navbar
    nav_features: "Características",
    nav_how_it_works: "Cómo funciona",
    nav_pricing: "Planes",
    nav_login: "Iniciar sesión",
    nav_login_short: "Entrar",
    nav_register: "Empieza ahora",
    nav_register_short: "Empezar",
    nav_history: "Historial",
    nav_improve: "Mejorar",
    nav_compare: "Comparar",
    nav_back: "Volver",
    nav_plans: "Planes",

    // Hero
    landing_badge: "Tu guía inteligente para decidir mejor",
    landing_h1_1: "Deja de dudar, ",
    landing_h1_2: "comienza a tomar decisiones seguras",
    landing_p: "Con FUTURA, resolver decisiones importantes y cotidianas con IA es mas facil, y ademas puedes descubrir como tus emociones influyen en cada eleccion. Decide y avanza.",
    landing_cta: "Empieza ahora",
    landing_cta_plans: "Ver planes",
    landing_cta_plans_hint: "desde 5,99€/mes",
    landing_trust_free: "0€ sin tarjeta",
    landing_trust_cancel: "Cancela cuando quieras",
    landing_trust_secure: "Pago seguro · Stripe",
    landing_social_proof: "+2,500 decisiones simuladas",
    landing_social_sub: "En los últimos 30 días",

    // Features
    features_title: "Todo lo que necesitas para decidir con más claridad",
    features_subtitle: "Orientación práctica con IA para tus decisiones del día a día, complementada con herramientas de bienestar emocional",
    feat_ai: "Orientación con IA",
    feat_ai_desc: "Recibe recomendaciones contextualizadas y personalizadas para resolver tus decisiones cotidianas con más seguridad",
    feat_prob: "Recomendaciones claras",
    feat_prob_desc: "Visualiza escenarios y probabilidades basados en tu situación específica para elegir con más confianza",
    feat_risk: "Contexto y riesgos",
    feat_risk_desc: "Identifica potenciales obstáculos y factores clave antes de tomar cualquier decisión",
    feat_time: "Claridad emocional",
    feat_time_desc: "Entiende cómo tu energía, estrés o estado emocional pueden influir en tus decisiones diarias",
    feat_rec: "Insights personalizados",
    feat_rec_desc: "Recibe observaciones basadas en tus patrones para tomar decisiones con más conciencia",
    feat_impact: "Bienestar complementario",
    feat_impact_desc: "Herramientas guiadas y recursos prácticos para acompañar tu día a día con más equilibrio",

    // How it Works
    how_title: "Así funciona",
    how_subtitle: "En tres pasos, obtendrás orientación práctica y claridad para decidir mejor",
    how_step1_title: "Plantea tu decisión",
    how_step1_desc: "Recibe ayuda práctica y contextual para resolver decisiones cotidianas como qué ponerte, qué elegir o cómo actuar en situaciones del día a día.",
    how_step2_title: "Obtén una recomendación inteligente",
    how_step2_desc: "FUTURA analiza tu contexto y te ofrece orientación útil, rápida y personalizada para decidir con más seguridad.",
    how_step3_title: "Decide con más claridad",
    how_step3_desc: "Con la capa de seguimiento emocional, también puedes entender cómo tu energía, estrés o estado emocional pueden influir en tus decisiones.",

    // Decide mejor section
    dm_title: "Decide mejor por dentro y por fuera",
    dm_subtitle: "Tus decisiones no dependen solo del contexto. También dependen de cómo te sientes. FUTURA une orientación práctica + claridad emocional para ayudarte a decidir con más conciencia.",
    dm_card1_title: "Decisiones cotidianas con IA",
    dm_card1_desc: "La esencia de FUTURA: ayuda práctica para resolver elecciones reales del día a día, desde pequeñas dudas hasta decisiones cotidianas con más contexto y menos ruido mental.",
    dm_card1_b1: "Recomendaciones contextualizadas",
    dm_card1_b2: "Simulaciones del día a día",
    dm_card1_b3: "Ayuda práctica e inmediata",
    dm_card1_b4: "Menos sobrepensar",
    dm_card1_b5: "Más claridad para elegir",
    dm_card2_title: "Claridad emocional complementaria",
    dm_card2_desc: "Una capa de seguimiento emocional no clínico que te ayuda a entender cómo tu energía, estrés o estado emocional pueden influir en tus decisiones y en tu bienestar diario.",
    dm_card2_b1: "Check-ins diarios",
    dm_card2_b2: "Patrones personales",
    dm_card2_b3: "Insights orientativos",
    dm_card2_b4: "Más autoconocimiento",
    dm_card2_b5: "Decisiones más conscientes",

    // Trust section
    trust_title: "Diseñado para ayudarte con claridad y responsabilidad",
    trust1_title: "Decisiones cotidianas, orientación práctica",
    trust1_desc: "FUTURA está diseñada para ayudarte en decisiones del día a día y ofrecer herramientas de bienestar emocional orientativo y no clínico.",
    trust2_title: "IA orientativa y transparente",
    trust2_desc: "Las recomendaciones y los insights están pensados para aportar claridad, contexto y autoconocimiento, no para sustituir una evaluación profesional.",
    trust3_title: "Uso responsable",
    trust3_desc: "Si necesitas ayuda especializada, te recomendamos siempre acudir a un profesional cualificado. FUTURA es un complemento, no un sustituto.",

    // CTA
    cta_title: "¿Listo para tomar mejores decisiones?",
    cta_subtitle: "Prueba FUTURA gratis y descubre cómo la IA puede ayudarte a decidir con más claridad cada día.",
    cta_button: "Empieza ahora",

    // Modules section
    mod_badge: "Descubre lo que incluye FUTURA",
    mod_title: "Más que decisiones: tu bienestar también cuenta",
    mod_subtitle: "FUTURA va más allá de las decisiones. Integra herramientas de bienestar emocional para ayudarte a decidir con más claridad y sentirte mejor en tu día a día.",
    mod1_tag: "Módulo 1",
    mod1_name: "Herramientas interactivas",
    mod1_desc: "3 herramientas visuales diseñadas para acompañarte cuando más lo necesitas: respiración guiada, grounding 5-4-3-2-1 y desafíos para desconectar del móvil.",
    mod1_f1: "Respiración 4-7-8 visual",
    mod1_f2: "Grounding 5-4-3-2-1",
    mod1_f3: "Desafío de descanso digital",
    mod1_f4: "Totalmente sin audio",
    mod1_plans: "Disponible en los planes Decide y Avanza",
    mod2_tag: "Módulo 2",
    mod2_name: "Seguimiento Emocional Inteligente",
    mod2_desc: "Registra tu estado emocional diario, descubre patrones que influyen en tus decisiones y cuenta con tu Diario IA personal como acompañamiento empático.",
    mod2_f1: "Check-in emocional diario",
    mod2_f2: "Gráficas semanales e insights con IA",
    mod2_f3: "Diario IA personal",
    mod2_f4: "Patrones y resumen emocional",
    mod2_plans: "Exclusivo del plan Avanza",



    // Terms & Conditions
    terms_title: "Términos y Condiciones",
    terms_updated: "Última actualización: Abril 2026",
    terms_s1_title: "1. Naturaleza del servicio",
    terms_s1_text: "FUTURA es una plataforma de inteligencia artificial diseñada para acompañar al usuario en su crecimiento personal, emocional y en la toma de decisiones cotidianas. FUTURA no es un servicio médico, psicológico, psiquiátrico ni terapéutico. No realizamos diagnósticos clínicos, no prescribimos tratamientos y no sustituimos la atención profesional de ningún tipo.",
    terms_s2_title: "2. Alcance de las recomendaciones",
    terms_s2_text: "Las recomendaciones, insights y contenidos generados por FUTURA son orientativos y están pensados para aportar claridad, contexto y autoconocimiento en decisiones del día a día. No constituyen asesoramiento médico, legal, financiero ni psicológico profesional. El usuario es siempre el responsable final de sus propias decisiones.",
    terms_s3_title: "3. Seguimiento emocional (Módulo 1)",
    terms_s3_text: "El módulo de Seguimiento Emocional permite al usuario registrar su estado de ánimo, energía y estrés de forma voluntaria. Los datos recogidos se utilizan exclusivamente para generar insights orientativos y personalizados. Este seguimiento no es un instrumento clínico de medición ni un sustituto de una evaluación psicológica profesional. Los insights generados son observaciones basadas en patrones, no diagnósticos.",
    terms_s4_title: "4. Biblioteca Premium (Módulo 2)",
    terms_s4_text: "Los audios guiados, programas y rutinas disponibles en la Biblioteca Premium son herramientas de apoyo al bienestar general del usuario. Están diseñados para acompañar el crecimiento personal y emocional mediante técnicas de respiración, relajación y mindfulness. No sustituyen terapia, tratamiento médico ni intervención psicológica de ningún tipo.",
    terms_s5_title: "5. Recomendación de ayuda profesional",
    terms_s5_text: "Si el usuario experimenta malestar emocional significativo, crisis de ansiedad, pensamientos negativos persistentes o cualquier situación que requiera atención especializada, le recomendamos encarecidamente acudir a un profesional de la salud mental cualificado. FUTURA es un complemento para el día a día, no un sustituto de atención profesional.",
    terms_s6_title: "6. Uso de IA y datos",
    terms_s6_text: "FUTURA utiliza modelos de inteligencia artificial para generar recomendaciones e insights. Los datos del usuario se almacenan de forma segura y se utilizan exclusivamente para mejorar la experiencia personalizada dentro de la plataforma. No compartimos datos personales con terceros. El usuario puede solicitar la eliminación de sus datos en cualquier momento.",
    terms_s7_title: "7. Planes y suscripciones",
    terms_s7_text: "FUTURA ofrece planes gratuitos y de pago. Las suscripciones se gestionan a través de Stripe y pueden cancelarse en cualquier momento. Al cancelar una suscripción, el usuario conserva el acceso hasta el final del período ya pagado. Los precios pueden variar y se comunicarán previamente al usuario.",
    terms_s8_title: "8. Aceptación",
    terms_s8_text: "Al utilizar FUTURA, el usuario acepta estos términos y condiciones. FUTURA se reserva el derecho de modificar estos términos, notificando los cambios al usuario con antelación razonable.",

    // Forgot Password
    login_forgot_password: "¿Has olvidado tu contraseña?",
    forgot_title: "Recupera tu cuenta",
    forgot_subtitle_email: "Introduce tu correo electronico y te enviaremos un enlace para restablecer tu contrasena.",
    forgot_email_label: "Correo electronico",
    forgot_send_link: "Enviar enlace",
    forgot_sent_title: "¡Email enviado!",
    forgot_sent_text: "Hemos enviado un enlace para restablecer tu contrasena a:",
    forgot_sent_check_spam: "Revisa la carpeta de spam si no lo encuentras.",
    forgot_min_password: "La contrasena debe tener al menos 6 caracteres",
    forgot_passwords_mismatch: "Las contrasenas no coinciden",
    forgot_confirm_password: "Confirmar contrasena",

    // Reset Password
    reset_title: "Nueva contrasena",
    reset_subtitle: "Elige una contrasena segura de al menos 6 caracteres.",
    reset_new_password: "Nueva contrasena",
    reset_new_placeholder: "Minimo 6 caracteres",
    reset_confirm_password: "Confirmar contrasena",
    reset_confirm_placeholder: "Repite la contrasena",
    reset_btn: "Cambiar contrasena",
    reset_done_title: "¡Contrasena actualizada!",
    reset_done_subtitle: "Tu contrasena se ha cambiado correctamente. Ya puedes iniciar sesion.",
    reset_go_login: "Iniciar sesion",
    reset_invalid_link: "Enlace invalido",
    reset_invalid_desc: "Este enlace de recuperacion no es valido o ha expirado.",
    reset_request_new: "Solicitar nuevo enlace",

    // Verify Email
    verify_title: "Verifica tu email",
    verify_subtitle: "Hemos enviado un codigo de verificacion a:",
    verify_code_label: "Codigo de verificacion",
    verify_btn: "Verificar",
    verify_resend: "Reenviar codigo",
    verify_resent: "Codigo reenviado correctamente",
    verify_back_login: "Volver al inicio de sesion",

    // GDPR Registration
    register_gdpr_required: "Debes aceptar los terminos y la politica de privacidad",
    register_gdpr_text: "Acepto los",
    register_gdpr_terms: "Terminos y Condiciones",
    register_gdpr_and: "y la",
    register_gdpr_privacy: "Politica de Privacidad",
    sq_pet: "¿Cual es el nombre de tu primera mascota?",
    sq_city: "¿En que ciudad naciste?",
    sq_teacher: "¿Cual es el nombre de tu profesor/a favorito/a?",
    sq_food: "¿Cual es tu comida favorita?",
    sq_friend: "¿Cual es el nombre de tu mejor amigo/a de la infancia?",
    register_security_question: "Pregunta de seguridad",
    register_select_question: "Selecciona una pregunta",
    register_security_answer: "Respuesta secreta",
    register_security_answer_placeholder: "Tu respuesta (no se puede cambiar)",
    register_security_required: "Debes elegir una pregunta y escribir tu respuesta secreta",
    register_security_warning: "Recuerda esta respuesta. Es la única forma de recuperar tu cuenta si olvidas la contraseña.",
    profile_security_title: "Pregunta de seguridad",
    profile_security_set: "Configurada",
    profile_security_not_set: "Sin configurar",
    profile_security_btn: "Configurar pregunta de seguridad",
    profile_security_update: "Actualizar pregunta",
    profile_security_save: "Guardar",
    security_prompt_subtitle: "Configura tu pregunta para poder recuperar tu cuenta",

    // Profile
    profile_email: "Correo electrónico",
    profile_auth_method: "Método de acceso",
    profile_auth_email: "Correo y contraseña",
    profile_plan: "Plan actual",
    profile_upgrade: "Mejorar plan",
    profile_member_since: "Miembro desde",
    profile_change_password: "Cambiar contraseña",
    profile_change_password_sub: "Actualiza tu contraseña de acceso",
    profile_current_password: "Contraseña actual",
    profile_pw_min: "La nueva contraseña debe tener al menos 6 caracteres",
    profile_pw_success: "Contraseña actualizada correctamente",
    profile_save_password: "Guardar nueva contraseña",
    profile_manage_subscription: "Gestionar suscripción",
    profile_cancel_warning: "Si cancelas tu suscripción, perderás el acceso a las funciones premium al final de tu período actual. Tu plan se revertirá a Descubre (gratuito).",
    profile_cancel_confirm_label: "Escribe CANCELAR para confirmar",
    profile_cancel_button: "Cancelar suscripción",

    // Pricing extras
    pricing_cancel_anytime: "Cancela cuando quieras",

    // Footer
    footer_terms: "Términos y Condiciones",
    footer_privacy: "Política de Privacidad",
    footer_support: "Soporte",
    footer_rights: "2026 FUTURA. Todos los derechos reservados.",
    webview_sub_managed: "Las suscripciones se gestionan desde la web",
    webview_limit_modal: "Has alcanzado el límite gratuito por hoy. Vuelve mañana o desbloquea el acceso ilimitado en nuestra web desde tu navegador.",
    webview_limit_accept: "Aceptar",
    footer_disclaimer: "FUTURA es una plataforma de apoyo a decisiones cotidianas y acompañamiento de bienestar emocional no clínico. No ofrece diagnóstico clínico, tratamiento psicológico ni atención de urgencias. Si necesitas ayuda especializada, te recomendamos acudir a un profesional cualificado.",

    // Login
    login_title: "Bienvenido de nuevo",
    login_subtitle: "Ingresa tus credenciales para continuar",
    login_email: "Email",
    login_password: "Contraseña",
    login_submit: "Iniciar sesión",
    login_remember_me: "Recordar mis datos",
    login_or: "o continua con",
    login_no_account: "No tienes cuenta?",
    login_register_link: "Regístrate gratis",
    login_right_title: "Decisiones más inteligentes",
    login_right_subtitle: "Orientación práctica con IA para tus decisiones cotidianas, complementada con claridad emocional",

    // Register
    register_title: "Crea tu cuenta",
    register_subtitle: "Comienza a decidir con más claridad hoy mismo",
    register_name: "Nombre",
    register_name_placeholder: "Tu nombre",
    register_email: "Email",
    register_password: "Contraseña",
    register_password_placeholder: "Mínimo 6 caracteres",
    register_submit: "Crear cuenta",
    register_or: "o regístrate con",
    register_has_account: "Ya tienes cuenta?",
    register_login_link: "Inicia sesión",
    register_right_title: "Tu primera consulta es gratis",
    register_right_subtitle: "Descubre cómo la IA puede ayudarte a tomar mejores decisiones en tu día a día",
    register_password_error: "La contraseña debe tener al menos 6 caracteres",
    register_password_alphanumeric: "La contraseña solo puede contener letras y números (sin símbolos ni espacios)",
    register_password_hint: "Solo letras y números. Minimo 6 caracteres.",

    // ConsultaDirecta
    consulta_h1_1: "¿Qué decisión necesitas",
    consulta_h1_2: "tomar hoy?",
    consulta_subtitle: "Te haré algunas preguntas para entender tu situación y darte la mejor recomendación.",
    consulta_placeholder: "Describe tu dilema o decisión...",
    consulta_start: "Comenzar",
    consulta_examples_title: "Ejemplos de preguntas",
    consulta_question_of: "Pregunta {current} de {total}",
    consulta_answer_placeholder: "Escribe tu respuesta...",
    consulta_generating: "Perfecto! Ya tengo toda la información. Generando tu análisis personalizado...",
    consulta_analyzing: "Analizando tu situación...",
    consulta_loading_estimate: "Estamos procesando su simulación, esto puede tardar hasta 1 minuto.",
    consulta_loading_phrase_1: "Tu simulación está en curso, esto puede tardar unos segundos.",
    consulta_loading_phrase_2: "Considerando escenarios, riesgos y oportunidades...",
    consulta_loading_phrase_3: "Revisando tus señales emocionales y racionales.",
    consulta_loading_phrase_4: "Estamos buscando lo que realmente importa para ti.",
    consulta_loading_phrase_5: "Casi listo. Vale la pena la espera.",
    consulta_footer: "FUTURA ofrece orientación práctica y complementaria para tus decisiones cotidianas. No sustituye asesoramiento profesional.",

    // Example questions
    example_q1: "¿Debería cambiar de trabajo?",
    example_q2: "¿Me compro esto o ahorro?",
    example_q3: "¿Debería mudarme a otra ciudad?",
    example_q4: "¿Qué me pongo hoy?",
    example_q5: "¿Invierto en esto o espero?",
    example_q6: "¿Estudio esto o aquello?",

    // Result labels
    result_analysis_title: "Análisis de tu decisión",
    result_success: "Probabilidad de éxito",
    result_recommendation_level: "Nivel de recomendación",
    result_stress: "Nivel de estrés",
    result_happiness: "Nivel de bienestar",
    result_recommendation: "RECOMENDACIÓN",
    result_why: "¿Por qué esta recomendación?",
    result_motives: "MOTIVOS",
    result_risks: "ASPECTOS A CONSIDERAR",
    result_alternative: "ALTERNATIVA",
    result_top3: "TOP 3 CAMINOS RECOMENDADOS",
    result_confidence: "confianza",
    result_risk: "riesgo",
    result_action_plan: "PLAN DE ACCION",
    result_premium_summary: "RESUMEN PREMIUM",
    result_premium_tag: "PREMIUM",
    result_upsell: "¿Quieres mas? Con el plan",
    result_upsell_features: "Top 3 caminos recomendados - Plan de accion - Resumen premium - Comparador",
    result_upsell_btn: "Ver plan Avanza",
    result_new_consultation: "Nueva consulta",
    result_limit_reached: "Has alcanzado el limite de consultas. Mejora tu plan para continuar.",
    result_view_plans: "Ver planes",

    // History
    history_title: "Historial de consultas",
    history_subtitle: "Revisa todas tus consultas pasadas",
    history_compare_btn: "Comparar escenarios",
    history_search: "Buscar consultas...",
    history_no_results: "Sin resultados",
    history_no_consultations: "Sin consultas aun",
    history_no_results_hint: "Intenta con otros términos de busqueda",
    history_no_consultations_hint: "Haz tu primera consulta para verla aqui",
    history_first_btn: "Hacer mi primera consulta",
    history_motives: "Motivos",
    history_risks: "Aspectos",
    history_alternative: "Alternativa",
    history_reasons: "razones",
    history_identified: "identificados",
    history_delete_title: "Eliminar consulta",
    history_delete_confirm: "¿Estás seguro de que quieres eliminar esta consulta? Esta acción no se puede deshacer.",
    history_delete_cancel: "Cancelar",
    history_delete_yes: "Eliminar",

    // Pricing
    pricing_title: "Elige tu plan",
    pricing_subtitle: "Mejores decisiones, más claridad. Elige el plan que se adapte a ti.",
    pricing_monthly: "Mensual",
    pricing_annual: "Anual",
    pricing_forever: "para siempre",
    pricing_month: "/mes",
    pricing_year: "/año",
    pricing_your_plan: "Tu plan actual",
    pricing_free: "Gratis",
    pricing_subscribe: "Elegir plan",
    pricing_secure: "Pagos seguros procesados por Stripe. Cancela cuando quieras.",
    pricing_cancel: "Cancelar mi suscripción",
    pricing_cancel_confirm: "¿Seguro que quieres cancelar tu suscripción? Volveras al plan Descubre.",

    // Plan names
    plan_descubre: "Descubre",
    plan_descubre_badge: "Gratis",
    plan_descubre_desc: "Una primera mirada a lo que FUTURA puede hacer por ti",
    plan_decide: "Decide",
    plan_decide_badge: "Popular",
    plan_decide_desc: "Deja de dudar. Empieza a vivir con mas claridad y confianza en cada decision.",
    plan_avanza: "Avanza",
    plan_avanza_badge: "Transformador",
    plan_avanza_desc: "Siente la diferencia de tomar cada decisión con total claridad, entendiendo tus emociones y con un plan de acción hecho a tu medida. Una experiencia única que transforma tu forma de vivir.",
    plan_saves: "Ahorras",
    plan_per_month: "/mes",
    plan_start_free: "Empezar gratis",
    plan_choose_decide: "Elegir Decide",
    plan_choose_avanza: "Elegir Avanza",
    pricing_popular: "Más popular",
    pricing_annual_hint: "Planes anuales disponibles con descuento — pago seguro con Stripe. Cancela cuando quieras.",
    plan_descubre_feat1: "1 simulación al día",
    plan_descubre_feat2: "Check-in emocional diario",
    plan_descubre_feat3: "Avatar personalizable",
    plan_decide_feat1: "50 simulaciones al mes",
    plan_decide_feat2: "Historial completo de decisiones",
    plan_decide_feat3: "Niveles de avatar (1-10) y logros",
    plan_decide_feat4: "Recuperar racha una vez al mes",
    plan_avanza_feat1: "Simulaciones ilimitadas",
    plan_avanza_feat2: "Diario IA personal + informe premium",
    plan_avanza_feat3: "Comparador de decisiones avanzado",
    plan_avanza_feat4: "Todo lo de Decide incluido",
    plan_intent_banner: "Estas a un paso de activar {plan} por {price}/mes. Completa tu suscripcion cuando quieras.",
    plan_intent_continue: "Activar",
    plan_intent_dismiss: "Cerrar aviso",

    // Emotional selling taglines
    plan_descubre_emotion: "Prueba gratis, sin compromiso",
    plan_decide_emotion: "La claridad que mereces, cada dia",
    plan_decide_hook: "Imagina tomar 50 decisiones al mes con la confianza de saber que cada una fue analizada a fondo. Sin mas noches en vela. Sin mas dudas paralizantes.",
    plan_avanza_emotion: "Transforma tu vida desde dentro",
    plan_avanza_hook: "Decisiones ilimitadas + tu Diario IA personal. Porque las mejores decisiones nacen cuando entiendes lo que sientes. Tu evolucion empieza aqui.",

    // Plan features - Descubre
    pf_1sim: "1 simulacion al dia",
    pf_ai_rec: "Recomendacion orientativa basica",
    pf_basic_motives: "Analisis general simplificado",

    // Plan features - Decide
    pf_50sim: "50 simulaciones al mes",
    pf_5sim: "5 simulaciones al mes",
    pf_detailed_motives: "Analisis profundo con contexto personal",
    pf_full_history: "Historial completo de decisiones",
    pf_emotional_tracking: "Seguimiento Emocional Inteligente",
    pf_checkin: "Check-in emocional diario",
    pf_mood_tracker: "Mood tracker inteligente",
    pf_journal: "Diario emocional guiado",
    pf_energy_log: "Registro de energia, descanso y estres",
    pf_weekly_charts: "Graficas semanales de bienestar",
    pf_ai_insights: "Insights personalizados con IA",
    pf_patterns: "Resumen de patrones emocionales",
    pf_smart_ai: "IA avanzada que entiende tu contexto real",

    // Plan features - Avanza
    pf_unlimited: "Simulaciones ilimitadas",
    pf_premium_ai: "IA premium: analisis profundo, empatico y transformador",
    pf_pdf: "Descarga de resultados en PDF",
    pf_comparator: "Comparador de escenarios",
    pf_premium_report: "Informe premium con recomendacion final",
    pf_top3: "Top 3 caminos recomendados",
    pf_confidence: "Nivel de confianza / riesgo por opcion",
    pf_action: "Plan de accion personalizado paso a paso",
    pf_library: "Biblioteca Premium de Bienestar",
    pf_audio_guides: "Guia visual de respiracion 4-7-8",
    pf_programs: "Programas estructurados de 7/14/21 dias",
    pf_routines: "Tecnica grounding 5-4-3-2-1 contra la ansiedad",
    pf_smart_recs: "Desafio de descanso digital con control de pantalla",
    pf_regulation: "Herramientas practicas de regulacion emocional",
    pf_diary_ai_desc: "Tu Diario IA personal: escribe, habla y entiende tus emociones",
    pf_avatar: "Avatar dinamico personalizable",
    pf_avatar_challenges: "Micro-retos diarios con tu avatar",
    pf_checkin_free: "Check-in emocional diario gratuito",
    pf_avatar_levels: "Sistema de niveles del avatar (1-10)",

    // Missing features
    pmiss_history: "Historial completo",
    pmiss_pdf: "Descarga en PDF",
    pmiss_comparator: "Comparador de escenarios",
    pmiss_premium: "Informe premium",
    pmiss_emotional: "Seguimiento emocional",
    pmiss_library: "Herramientas interactivas",
    pmiss_diary_ai: "Diario IA personal",
    pmiss_smart_ai: "IA avanzada",

    // Simulation counter
    sim_counter_daily: "Hoy",
    sim_counter_monthly: "Este mes",
    sim_counter_unlimited: "Ilimitadas",
    sim_counter_available: "disponible",
    sim_counter_available_pl: "disponibles",
    sim_counter_next_reset: "Se renueva",
    sim_counter_next_reset_in: "en",
    sim_counter_hours: "h",
    sim_counter_upgrade: "Desbloquea mas simulaciones",

    // Landing Diario IA
    landing_diary_badge: "Exclusivo Plan Avanza",
    landing_diary_title: "Tu Diario IA: el espacio donde todo empieza a tener sentido",
    landing_diary_subtitle: "Escribe lo que sientes, hablale por voz, y deja que la IA te ayude a entenderte. No es un diario comun. Es tu espacio emocional inteligente.",
    landing_diary_f1: "Escribe o habla: expresa tus emociones como prefieras",
    landing_diary_f2: "La IA detecta tus patrones y te ayuda a verlos",
    landing_diary_f3: "Analisis de crisis: si estas pasandolo mal, FUTURA lo detecta",
    landing_diary_f4: "Tu evolucion emocional visible semana a semana",
    landing_diary_cta: "Quiero mi Diario IA",

    // Comparador
    comp_title: "Comparador de Escenarios",
    comp_subtitle: "Selecciona 2 a 4 consultas para comparar sus resultados",
    comp_gate_title: "Comparador de Escenarios",
    comp_gate_desc: "Esta función está disponible en el plan Avanza",
    comp_gate_btn: "Ver plan Avanza",
    comp_no_consultations: "No tienes consultas para comparar. Haz tu primera consulta.",
    comp_compare_btn: "Comparar {count} consultas",
    comp_best: "Mejor opción",
    comp_new: "Nueva comparación",
    comp_success: "Éxito",
    comp_recommendation: "Recomendación",
    comp_stress: "Estrés",
    comp_happiness: "Bienestar",
    comp_rec_label: "Recomendación",

    // PaymentSuccess
    pay_checking: "Verificando pago...",
    pay_checking_sub: "Por favor espera mientras confirmamos tu transacción",
    pay_attempt: "Intento {n} de 5",
    pay_success: "Pago éxitoso!",
    pay_go_dashboard: "Ir al Dashboard",
    pay_error: "Error en el pago",
    pay_retry: "Intentar de nuevo",
    pay_back_dashboard: "Volver al Dashboard",
    pay_no_session: "No se encontró información del pago",
    pay_timeout: "No pudimos verificar el pago. Por favor contacta soporte.",
    pay_expired: "La sesión de pago ha expirado. Por favor intenta de nuevo.",

    // Dashboard
    dash_hello: "Hola",
    dash_what: "¿Qué decisión quieres resolver hoy?",
    dash_simulations: "Simulaciones",
    dash_used_month: "usadas este mes",
    dash_decisions: "Decisiones",
    dash_in_history: "en tu historial",
    dash_plan: "Plan",
    dash_upgrade: "Mejorar plan",
    dash_new_sim: "Nueva consulta",
    dash_new_sim_desc: "Describe tu decisión y obtén orientación práctica con recomendaciones personalizadas",
    dash_create_sim: "Crear consulta",
    dash_limit: "Has alcanzado el limite de consultas. Mejora tu plan para continuar.",
    dash_recent: "Consultas recientes",
    dash_view_all: "Ver todas",
    dash_completed: "Completada",
    dash_pending: "Pendiente",
    dash_no_decisions: "Sin consultas aun",
    dash_no_decisions_hint: "Crea tu primera consulta para ver resultados aqui",
    dash_first_sim: "Crear mi primera consulta",
    dash_used_today: "usada hoy",
    dash_unlimited: "simulaciones ilimitadas",
    dash_resets: "Se renueva:",
    dash_limit_reached: "Has alcanzado el limite de consultas. Mejora tu plan para continuar.",
    dash_question: "¿Que decision quieres simular hoy?",
    dash_history: "Historial",
    dash_plans: "Planes",
    dash_wellbeing: "Bienestar",
    dash_library: "Herramientas",
    dash_emotional_tracking: "Seguimiento Emocional",
    dash_emotional_desc: "Registra tu estado y obtiene insights",
    dash_premium_library: "Herramientas interactivas",
    dash_premium_desc: "Respiracion, grounding y descanso digital",
    dash_screenbreak_label: "Descanso digital",
    dash_screenbreak_min_week: "min sin pantalla esta semana",

    loading: "Cargando...",
    lang_es: "Español",
    lang_en: "English",
    lang_de: "Deutsch",
    lang_it: "Italiano",

    // Nav (new)
    nav_wellbeing: "Bienestar",
    nav_library: "Biblioteca",
    nav_diary: "Diario IA",
    nav_profile: "Perfil",
    nav_logout: "Cerrar sesión",
    pricing_module1_title: "Modulo 1: Herramientas interactivas",
    pricing_module2_title: "Modulo 2: Seguimiento Emocional",
    pf_favorites: "Guardar consultas favoritas",
    pf_diary_ai: "Diario IA personal",

    // Mood Tracker
    mood_title: "Seguimiento Emocional",
    mood_subtitle: "Registra cómo te sientes y descubre cómo tu estado influye en tus decisiones",
    mood_checkin_title: "Check-in de hoy",
    mood_checkin_sub: "¿Cómo te encuentras ahora mismo?",
    mood_today_done: "Check-in completado",
    mood_today_done_sub: "Ya registraste tu estado de hoy. Vuelve mañana.",
    mood_label: "Estado de ánimo",
    energy_label: "Energía",
    stress_label: "Estrés",
    mood_1: "Muy bajo",
    mood_2: "Bajo",
    mood_3: "Normal",
    mood_4: "Bien",
    mood_5: "Muy bien",
    energy_1: "Agotado",
    energy_2: "Cansado",
    energy_3: "Normal",
    energy_4: "Activo",
    energy_5: "Lleno de energía",
    stress_1: "Muy relajado",
    stress_2: "Tranquilo",
    stress_3: "Normal",
    stress_4: "Estrésado",
    stress_5: "Muy estresado",
    mood_note_placeholder: "Nota opcional: ¿algo que quieras anotar?",
    mood_save: "Guardar check-in",
    mood_weekly_title: "Últimos 7 días",
    mood_averages_title: "Promedios semanales",
    mood_checkins_count: "check-ins esta semana",
    mood_insight_title: "Insight personalizado",
    mood_insight_loading: "Calculando tu resumen semanal...",
    mood_empty: "Haz tu primer check-in para empezar a ver tus patrones emocionales",
    mood_history_title: "Historial reciente",
    mood_disclaimer: "El seguimiento emocional de FUTURA es orientativo y no clínico. No sustituye atención profesional.",
    mood_gate_title: "Seguimiento Emocional",
    mood_gate_desc: "Esta función está disponible en el plan Avanza",
    mood_gate_btn: "Ver plan Avanza",

    // AI Diary
    diary_title: "Diario IA",
    diary_empty_title: "Tu espacio seguro",
    diary_empty_desc: "Escribe cómo te sientes hoy. Estoy aquí para escucharte, sin juicios.",
    diary_placeholder: "¿Cómo te sientes hoy?",
    diary_recording: "Grabando...",
    diary_stop: "Detener",
    diary_transcribing: "Transcribiendo audio...",
    diary_voice_transcribed: "Transcrito de audio",
    diary_weekly_summary: "Resumen semanal",
    diary_challenge_label: "Micro-reto sugerido",
    diary_gate_title: "Diario IA",
    diary_gate_desc: "Accede a tu diario emocional con IA con el plan Avanza",
    diary_gate_btn: "Ver plan Avanza",

    // Premium Library
    lib_title: "Herramientas interactivas",
    lib_subtitle: "3 herramientas visuales para calmarte, enraizarte y descansar de la pantalla",
    lib_tab_programs: "Programas",
    lib_tab_audios: "Audios guiados",
    lib_tab_routines: "Rutinas",
    lib_days: "días",
    lib_sessions: "sesiones",
    lib_steps: "pasos",
    lib_prog_stress7_title: "Reduce tu estrés en 7 días",
    lib_prog_stress7_desc: "Un programa diario con ejercicios prácticos de respiración, pausas activas y reflexión para reducir el estrés acumulado.",
    lib_prog_energy14_title: "Recupera tu energía en 14 días",
    lib_prog_energy14_desc: "Actividades progresivas para mejorar tu nivel de energía, descanso y vitalidad a lo largo de dos semanas.",
    lib_prog_balance21_title: "21 días de equilibrio personal",
    lib_prog_balance21_desc: "Un recorrido completo que combina hábitos de bienestar, autocuidado y regulación emocional para transformar tu día a día.",
    lib_prog_sleep7_title: "Mejora tu descanso en 7 días",
    lib_prog_sleep7_desc: "Técnicas y rutinas nocturnas para conseguir un sueño más reparador y despertar con más energía.",
    lib_audio_breathing_title: "Respiración guiada",
    lib_audio_breathing_desc: "Técnica de respiración 4-7-8 para calma inmediata",
    lib_audio_relax_title: "Relajación profunda",
    lib_audio_relax_desc: "Ejercicio de relajación muscular progresiva",
    lib_audio_focus_title: "Enfoque y concentración",
    lib_audio_focus_desc: "Meditación guiada para mejorar tu atención",
    lib_audio_sleep_title: "Preparación para dormir",
    lib_audio_sleep_desc: "Visualización guiada para un descanso reparador",
    lib_audio_morning_title: "Despertar con energía",
    lib_audio_morning_desc: "Rutina matutina de activación mente-cuerpo",
    lib_audio_pause_title: "Pausa rápida",
    lib_audio_pause_desc: "Descanso mental express para momentos de tensión",
    lib_audio_intro: "Pulsa play para escuchar los audios guiados generados con IA. La primera reproducción puede tardar unos segundos.",
    lib_audio_coming_soon: "Nuevos audios guiados disponibles próximamente",
    lib_routine_morning_title: "Rutina matutina de bienestar",
    lib_routine_morning_desc: "Empieza el día con más claridad: hidratación, respiración, intención del día y movimiento suave.",
    lib_routine_stress_title: "Rutina anti-estrés",
    lib_routine_stress_desc: "Cuando sientas tensión: respiración profunda, estiramientos, desconexión digital y nota de agradecimiento.",
    lib_routine_night_title: "Rutina nocturna de descanso",
    lib_routine_night_desc: "Prepara tu cuerpo y mente para dormir: sin pantallas, respiración, reflexión del día y relajación.",
    lib_disclaimer: "Las herramientas son orientativas y no sustituyen atención profesional.",
    lib_gate_title: "Herramientas interactivas",
    lib_gate_desc: "Accede a respiración guiada, grounding y desafíos de pantalla con los planes Decide o Avanza",
    lib_gate_btn: "Ver planes",
    lib_back_to_list: "Volver",
    lib_day: "Día",
    lib_step: "Paso",
    lib_start_audio: "Escuchar audio guiado",
    lib_program_intro: "Sigue cada sesión en orden para obtener los mejores resultados. Cada día incluye un audio guiado.",
    lib_routine_intro: "Sigue cada paso en orden. Tómate tu tiempo.",
    lib_duration_min: "min",
    lib_prog_stress7_d1: "Respiración profunda 4-7-8",
    lib_prog_stress7_d2: "Escaneo corporal de tensiones",
    lib_prog_stress7_d3: "Pausa activa y estiramientos",
    lib_prog_stress7_d4: "Diario rápido de emociones",
    lib_prog_stress7_d5: "Meditación de enfoque",
    lib_prog_stress7_d6: "Desconexión digital guiada",
    lib_prog_stress7_d7: "Reflexión y cierre de semana",
    lib_prog_energy14_d1: "Despertar con intención",
    lib_prog_energy14_d2: "Movimiento matutino suave",
    lib_prog_energy14_d3: "Hidratación y nutrición consciente",
    lib_prog_energy14_d4: "Pausas activas durante el día",
    lib_prog_energy14_d5: "Respiración energizante",
    lib_prog_energy14_d6: "Siesta consciente o descanso",
    lib_prog_energy14_d7: "Revisión de la primera semana",
    lib_prog_energy14_d8: "Establecer rutina de sueño",
    lib_prog_energy14_d9: "Ejercicio de gratitud matutina",
    lib_prog_energy14_d10: "Gestión de energía emocional",
    lib_prog_energy14_d11: "Activación cuerpo y mente",
    lib_prog_energy14_d12: "Conexión con la naturaleza",
    lib_prog_energy14_d13: "Descanso restaurativo profundo",
    lib_prog_energy14_d14: "Celebración de progreso",
    lib_prog_balance21_d1: "Intención y autocuidado",
    lib_prog_balance21_d2: "Respiración equilibrante",
    lib_prog_balance21_d3: "Identifica tus detonantes",
    lib_prog_balance21_d4: "Regulación con pausa",
    lib_prog_balance21_d5: "Ejercicio de aceptación",
    lib_prog_balance21_d6: "Comunicación consciente",
    lib_prog_balance21_d7: "Revisión semanal",
    lib_prog_balance21_d8: "Límites saludables",
    lib_prog_balance21_d9: "Autocompasión",
    lib_prog_balance21_d10: "Gestión de expectativas",
    lib_prog_balance21_d11: "Gratitud activa",
    lib_prog_balance21_d12: "Resilencia emocional",
    lib_prog_balance21_d13: "Descanso sin culpa",
    lib_prog_balance21_d14: "Revisión quincenal",
    lib_prog_balance21_d15: "Relaciones y bienestar",
    lib_prog_balance21_d16: "Creatividad y expresión",
    lib_prog_balance21_d17: "Movimiento consciente",
    lib_prog_balance21_d18: "Espacio personal",
    lib_prog_balance21_d19: "Celebración de pequeños logros",
    lib_prog_balance21_d20: "Visualización de futuro",
    lib_prog_balance21_d21: "Integración y compromiso",
    lib_prog_sleep7_d1: "Apagar pantallas una hora antes",
    lib_prog_sleep7_d2: "Respiración relajante para dormir",
    lib_prog_sleep7_d3: "Visualización del lugar seguro",
    lib_prog_sleep7_d4: "Escaneo corporal nocturno",
    lib_prog_sleep7_d5: "Diario de gratitud nocturno",
    lib_prog_sleep7_d6: "Relajación muscular progresiva",
    lib_prog_sleep7_d7: "Cierre de semana y descanso profundo",
    lib_routine_morning_s1: "Bebe un vaso de agua al despertar",
    lib_routine_morning_s2: "Haz 3 respiraciones profundas con los ojos cerrados",
    lib_routine_morning_s3: "Establece tu intención para hoy en una frase",
    lib_routine_morning_s4: "Realiza 5 minutos de estiramientos suaves",
    lib_routine_stress_s1: "Detente y haz 5 respiraciones profundas",
    lib_routine_stress_s2: "Estira cuello, hombros y espalda durante 3 minutos",
    lib_routine_stress_s3: "Aparta el móvil y mira por la ventana 2 minutos",
    lib_routine_stress_s4: "Escribe algo por lo que estés agradecido hoy",
    lib_routine_stress_s5: "Escucha el audio de pausa rápida",
    lib_routine_night_s1: "Apaga todas las pantallas 30 minutos antes de dormir",
    lib_routine_night_s2: "Haz 5 respiraciones lentas y profundas",
    lib_routine_night_s3: "Piensa en 3 cosas buenas que pasaron hoy",
    lib_routine_night_s4: "Escucha el audio de preparación para dormir",
    lib_completed: "Completado",
    lib_mark_complete: "Marcar como completado",
    detail_back_history: "Historial",
    detail_not_found: "Consulta no encontrada",
    detail_error: "Error al cargar la consulta",
    detail_qa_title: "Preguntas y respuestas",
    detail_metrics: "Metricas del analisis",
    detail_success: "Probabilidad de exito",
    detail_recommendation: "Nivel de recomendacion",
    detail_stress: "Nivel de estres",
    detail_happiness: "Nivel de felicidad",
    detail_recommendation_title: "Recomendacion",
    detail_motives: "Motivos a favor",
    detail_risks: "Riesgos identificados",
    detail_alternative: "Alternativa",
    detail_top3: "Top 3 caminos recomendados",
    detail_confidence: "Confianza",
    detail_risk: "Riesgo",
    detail_action_plan: "Plan de accion",
    detail_premium_summary: "Resumen premium",

    // Legal footer
    legal_privacy: "Privacidad",
    legal_cookies: "Cookies",
    legal_terms: "Terminos",
    legal_delete_account: "Eliminar cuenta",
    legal_cookie_settings: "Configurar cookies",
    legal_rights: "Todos los derechos reservados.",

    // Cookie banner
    cookie_title: "Este sitio usa cookies",
    cookie_description: "Usamos cookies esenciales para el funcionamiento del servicio. Puedes aceptar o rechazar las cookies opcionales de analisis.",
    cookie_accept: "Aceptar",
    cookie_reject: "Rechazar",
    cookie_configure: "Configurar",
    cookie_config_title: "Preferencias de cookies",
    cookie_essential: "Esenciales",
    cookie_essential_desc: "Necesarias para autenticacion y funcionamiento basico",
    cookie_analytics: "Analisis",
    cookie_analytics_desc: "Nos ayudan a entender como se usa la plataforma",
    cookie_always_active: "Siempre activas",
    cookie_save: "Guardar preferencias",

    // Cookie policy page
    cookiep_title: "Politica de Cookies",
    cookiep_updated: "Ultima actualizacion: abril 2026",
    cookiep_what_title: "1. Que son las cookies",
    cookiep_what_text: "Las cookies son pequenos archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Se utilizan para recordar preferencias, mantener sesiones activas y mejorar la experiencia del usuario.",
    cookiep_types_title: "2. Tipos de cookies que utilizamos",
    cookiep_types_text: "Cookies esenciales: necesarias para el funcionamiento basico de la plataforma (autenticacion, sesion, preferencias de idioma y consentimiento de cookies). Se activan automaticamente y no pueden deshabilitarse.\n\nCookies de analisis (opcionales): nos permiten entender como los usuarios interactuan con la plataforma para mejorar el servicio. Solo se activan si das tu consentimiento.",
    cookiep_essential_title: "3. Cookies esenciales",
    cookiep_essential_text: "- Token de autenticacion (JWT): mantiene tu sesion activa.\n- Preferencia de idioma: recuerda el idioma seleccionado.\n- Consentimiento de cookies: almacena tu eleccion sobre cookies.",
    cookiep_analytics_title: "4. Cookies de analisis",
    cookiep_analytics_text: "Actualmente no utilizamos servicios de analisis de terceros. Si en el futuro incorporamos herramientas como Google Analytics u otras, solo se activaran tras tu consentimiento explicito.\n\nEsta seccion se actualizara en ese caso.",
    cookiep_manage_title: "5. Como gestionar las cookies",
    cookiep_manage_text: "Puedes aceptar, rechazar o configurar las cookies cuando aparezca el banner de consentimiento. Tambien puedes cambiar tus preferencias en cualquier momento desde el enlace 'Configurar cookies' en el pie de pagina.",
    cookiep_revoke_title: "6. Como revocar el consentimiento",
    cookiep_revoke_text: "Puedes revocar tu consentimiento en cualquier momento:\n- Desde el enlace 'Configurar cookies' en el pie de pagina.\n- Eliminando las cookies de tu navegador.\n- El consentimiento se volvera a solicitar si cambian las categorias de cookies o si expira.",
    cookiep_changes_title: "7. Cambios en esta politica",
    cookiep_changes_text: "Esta politica puede actualizarse si se incorporan nuevas cookies o servicios. La fecha de actualizacion se indicara en la parte superior.",

    // Privacy policy (with placeholders)
    privacy_title: "Politica de Privacidad",
    privacy_updated: "Ultima actualizacion: abril 2026",
    privacy_s1_title: "1. Responsable del tratamiento",
    privacy_s1_text: "FUTURA DECISIONS APP, persona fisica, con domicilio en España.\n\nContacto: soporte@futura-app.com\nWeb: www.futura-app.com",
    privacy_s2_title: "2. Datos que recopilamos",
    privacy_s2_text: "Recopilamos los siguientes datos:\n- Datos de registro: nombre, correo electronico y contrasena cifrada.\n- Datos de uso: consultas realizadas, simulaciones, registro de estado emocional y preferencias.\n- Datos de pago: procesados de forma segura por Stripe. No almacenamos datos de tarjetas.\n- Datos tecnicos: direccion IP, tipo de navegador y dispositivo para el funcionamiento del servicio.",
    privacy_s3_title: "3. Finalidad del tratamiento",
    privacy_s3_text: "Utilizamos tus datos para:\n- Proporcionar el servicio de simulacion de decisiones y bienestar emocional.\n- Gestionar tu cuenta y suscripcion.\n- Personalizar la experiencia dentro de la plataforma.\n- Enviar comunicaciones relacionadas con el servicio (no enviamos publicidad).",
    privacy_s4_title: "4. Base legal",
    privacy_s4_text: "El tratamiento de tus datos se basa en:\n- Ejecucion del contrato: para prestarte el servicio solicitado.\n- Consentimiento: para cookies de analisis opcionales.\n- Interes legitimo: para mejorar la seguridad y el funcionamiento del servicio.",
    privacy_s5_title: "5. Terceros y proveedores",
    privacy_s5_text: "Utilizamos los siguientes proveedores:\n- Stripe: procesamiento de pagos (PCI-DSS).\n- OpenAI: procesamiento de consultas mediante IA. Los datos se envian para generar respuestas y no se utilizan para entrenar modelos.\n- Proveedor de infraestructura cloud: alojamiento del servicio.\n\nNo vendemos ni compartimos tus datos personales con terceros para fines comerciales.",
    privacy_s6_title: "6. Conservacion de datos",
    privacy_s6_text: "Conservamos tus datos mientras mantengas una cuenta activa. Si solicitas la eliminacion de tu cuenta, eliminaremos tus datos de forma permanente, salvo obligacion legal de conservarlos.",
    privacy_s7_title: "7. Derechos del usuario",
    privacy_s7_text: "Tienes derecho a:\n- Acceso: solicitar una copia de tus datos.\n- Rectificacion: corregir datos inexactos.\n- Supresion: solicitar la eliminacion de tu cuenta y datos.\n- Portabilidad: recibir tus datos en formato estructurado.\n- Oposicion: oponerte al tratamiento en determinadas circunstancias.\n- Limitacion: solicitar la limitacion del tratamiento.",
    privacy_s8_title: "8. Como ejercer tus derechos",
    privacy_s8_text: "Puedes ejercer tus derechos:\n- Eliminando tu cuenta desde la seccion de perfil dentro de la aplicacion.\n- Contactando a soporte@futura-app.com.\n- Visitando la pagina /eliminar-cuenta para mas informacion.\n\nResponderemos a tu solicitud en un plazo maximo de 30 dias.",
    privacy_s9_title: "9. Seguridad",
    privacy_s9_text: "Implementamos medidas de seguridad para proteger tus datos:\n- Cifrado de contrasenas mediante bcrypt.\n- Comunicaciones cifradas mediante HTTPS/TLS.\n- Tokens de autenticacion seguros (JWT).\n- Procesamiento de pagos certificado PCI-DSS a traves de Stripe.",
    privacy_s10_title: "10. Cambios en esta politica",
    privacy_s10_text: "Podemos actualizar esta Politica de Privacidad. Te notificaremos sobre cambios significativos. La fecha de actualizacion se indica en la parte superior.",

    // Terms (new sections for existing page)
    terms_s9_title: "9. Eliminacion de cuenta",
    terms_s9_text: "El usuario puede solicitar la eliminacion de su cuenta y datos asociados en cualquier momento desde la seccion de perfil de la aplicacion. La eliminacion es irreversible y se ejecuta de forma inmediata.",
    terms_s10_title: "10. Ley aplicable",
    terms_s10_text: "Estos terminos se rigen por la legislacion de España. Para cualquier controversia, las partes se someteran a los juzgados y tribunales competentes de España.",
    terms_s11_title: "11. Avatar dinamico y funcionalidades asociadas",
    terms_s11_text: "FUTURA incluye un avatar visual personalizable que refleja de forma orientativa la actividad del usuario en la plataforma. El avatar evoluciona segun el uso de herramientas como simulaciones de decisiones, check-ins emocionales y el diario IA.\n\nFuncionamiento: El avatar calcula un 'nivel de claridad' (0-100) basado en la actividad reciente del usuario (ultimos 7 dias). Este nivel determina el estado visual del avatar (Disperso, Enfocado, Preciso, Poderoso). Los datos utilizados son exclusivamente los generados por el propio usuario dentro de la plataforma.\n\nMicro-retos diarios: El avatar sugiere actividades opcionales (check-in emocional, pausa consciente, escritura en diario). Estos micro-retos son siempre voluntarios, no generan penalizacion por no realizarse, y no utilizan lenguaje que induzca culpa o dependencia emocional.\n\nRacha de actividad: Se muestra un contador de dias consecutivos con actividad. Este indicador es puramente informativo y no implica obligacion de uso continuado.\n\nNotificaciones: El usuario puede activar voluntariamente notificaciones push para recibir recordatorios de micro-retos. Estas notificaciones pueden desactivarse en cualquier momento desde el navegador.\n\nProteccion de datos emocionales: Los datos de bienestar emocional (mood check-ins, niveles de estres, energia) se almacenan de forma cifrada y se utilizan exclusivamente para calcular el estado del avatar y generar insights dentro de la plataforma. No se comparten con terceros ni se utilizan con fines publicitarios.\n\nLimitaciones: Esta representacion visual NO es un diagnostico clinico, NO mide estados de salud mental, NO sustituye la evaluacion de un profesional cualificado y NO debe interpretarse como asesoramiento medico o psicologico.",

    // Delete account page
    delaccount_title: "Eliminar cuenta",
    delaccount_subtitle: "Informacion sobre como eliminar tu cuenta de FUTURA",
    delaccount_how_title: "Como eliminar tu cuenta",
    delaccount_how_text: "Para eliminar tu cuenta:\n1. Inicia sesion en tu cuenta de FUTURA.\n2. Ve a tu perfil (icono de usuario).\n3. Desplazate hasta la parte inferior.\n4. Pulsa 'Eliminar cuenta'.\n5. Introduce tu contrasena para confirmar.\n6. Tu cuenta y todos los datos asociados seran eliminados de forma permanente.",
    delaccount_what_title: "Que datos se eliminan",
    delaccount_what_text: "Al eliminar tu cuenta, se borran permanentemente del servidor:\n- Tu perfil y datos de registro.\n- Todas tus consultas y simulaciones.\n- Tu historial de estados emocionales.\n- Tus entradas del diario.\n- Preferencias y configuracion.\n\nEsta accion es irreversible. Los datos de pago gestionados por Stripe se conservan segun su propia politica.",
    delaccount_contact_title: "Contacto",
    delaccount_contact_text: "Si no puedes acceder a tu cuenta o necesitas ayuda para eliminarla, contacta con soporte@futura-app.com.",
    delaccount_cta_text: "Para eliminar tu cuenta, inicia sesion primero.",
    delaccount_cta_button: "Iniciar sesion",

    // Profile delete account
    profile_delete_account: "Eliminar cuenta",
    profile_delete_warning_title: "Esta accion es irreversible",
    profile_delete_warning_text: "Se eliminaran permanentemente tu cuenta, simulaciones, historial emocional, diario y todos los datos asociados. Esta accion no se puede deshacer.",
    profile_delete_password_label: "Introduce tu contrasena para confirmar",
    profile_delete_confirm: "Eliminar mi cuenta permanentemente",

    // Avatar System
    avatar_setup_title: "Personaliza tu avatar",
    avatar_setup_subtitle: "Elige un color para tu avatar. Evolucionara contigo segun tu actividad y claridad emocional.",
    avatar_setup_save: "Activar mi avatar",
    avatar_choose_color: "Elige tu color",
    avatar_state_dormant: "Disperso",
    avatar_state_awakening: "Enfocado",
    avatar_state_clear: "Preciso",
    avatar_state_radiant: "Poderoso",
    avatar_widget_title: "Tu avatar",
    avatar_clarity_score: "Nivel de claridad",
    avatar_insight_dormant: "Tu avatar refleja menor actividad reciente. Parece un buen momento para una pausa consciente.",
    avatar_insight_awakening: "Estas en camino. Sigue explorando tus emociones y tomando decisiones conscientes.",
    avatar_insight_clear: "Tu enfoque es cada vez mayor. Tus decisiones y tu bienestar estan alineados.",
    avatar_insight_radiant: "Un momento de gran energia. Tu avatar refleja tu compromiso contigo mismo.",
    avatar_metric_checkins: "Check-ins",
    avatar_metric_consults: "Consultas",
    avatar_metric_diary: "Diario",
    avatar_deep_analysis_title: "Analisis profundo",
    avatar_deep_analysis_desc: "Desbloquea insights avanzados y patrones emocionales con el plan Avanza.",
    avatar_upgrade_cta: "Ver plan Avanza",
    avatar_deep_insight_title: "Tu insight",
    avatar_deep_insight_desc: "Tu actividad reciente muestra un patron positivo de autoconocimiento. Sigue asi.",
    avatar_disclaimer: "El avatar es una representacion visual orientativa de tu actividad en FUTURA. No constituye un diagnostico clinico ni sustituye atencion profesional.",
    avatar_landing_badge: "Tu avatar te espera",
    avatar_landing_title: "Siente claridad. Decide mejor. Evoluciona contigo.",
    avatar_landing_subtitle: "Tu avatar no es una funcion. Es el reflejo vivo de como te sientes cuando empiezas a tomar decisiones con claridad.",
    avatar_landing_desc: "No se trata de hacer mas.\nSe trata de sentirte mejor mientras decides.\n\nTu avatar evoluciona contigo, en silencio. Sin juicios. Sin presion.\nSolo progreso visible.",
    avatar_landing_f1: "Evoluciona en tiempo real segun tu bienestar",
    avatar_landing_f2: "Personalizalo: hazlo verdaderamente tuyo",
    avatar_landing_f3: "Micro-retos diarios para reconectar contigo",
    avatar_landing_f4: "Insights claros para entender(te), sin ruido",
    avatar_landing_cta: "Empieza a sentir la diferencia",
    hero_main_title: "Simula tus decisiones con IA. Tu avatar evoluciona contigo.",
    hero_main_subtitle: "FUTURA analiza cada decision que te preocupa y te da escenarios, probabilidades y alternativas reales. Mientras decides, tu avatar refleja tu progreso emocional.",
    hero_sim_title: "Simulacion de decisiones",
    hero_sim_desc: "IA que analiza tus decisiones cotidianas",
    hero_sim_example: "\"Estoy pensando en cambiar de trabajo...\"",
    hero_sim_result_desc: "Analisis con motivos, riesgos y alternativas personalizadas",
    hero_sim_risks: "Riesgos",
    hero_sim_alternatives: "Alternativas",
    hero_sim_footer: "Cada simulacion analiza tu situacion real con IA avanzada",
    hero_avatar_title: "Tu avatar personal",
    hero_avatar_desc: "Refleja tu bienestar mientras decides",
    hero_step1_title: "Describe tu decision",
    hero_step1_desc: "Cuentanos que te preocupa. La IA te hara preguntas para entender tu contexto.",
    hero_step2_title: "Recibe tu analisis",
    hero_step2_desc: "Probabilidad de exito, motivos, riesgos y alternativas personalizadas.",
    hero_step3_title: "Evoluciona con tu avatar",
    hero_step3_desc: "Tu avatar refleja tu claridad. Micro-retos diarios para reconectar contigo.",
    avatar_disclaimer: "El avatar es una representacion visual orientativa de tu actividad en FUTURA. No constituye un diagnostico clinico ni sustituye atencion profesional de salud mental.",
    avatar_fullscreen_title: "Tu avatar",
    avatar_fullscreen_close: "Cerrar",
    avatar_challenge_title: "Tu micro-reto de hoy",
    avatar_challenge_accept: "Acepto el reto",
    avatar_challenge_done: "Reto completado",
    avatar_challenge_skip: "Quizas manana",
    avatar_fullscreen_btn: "Ver grande",
    avatar_fullscreen_hint: "Abrir vista ampliada de tu avatar",
    avatar_widget_hint: "Toca para ver tu avatar y tu progreso",
    avatar_tap_hint: "Toca tu avatar",
    avatar_notif_title: "Notificaciones",
    avatar_notif_enable: "Activar notificaciones",
    avatar_notif_enabled: "Notificaciones activas",
    avatar_notif_instructions_title: "Activar notificaciones",
    avatar_notif_instructions_app: "En la app de FUTURA: ve a Ajustes de tu movil -> Apps -> FUTURA -> Notificaciones y activalas. Despues vuelve a la app.",
    avatar_notif_instructions_web: "Las notificaciones estan bloqueadas en tu navegador. Para activarlas, haz clic en el icono del candado junto a la URL y permite las notificaciones.",
    avatar_notif_instructions_ok: "Entendido",
    avatar_notif_desc: "Recibe micro-retos diarios de tu avatar",
    avatar_ethical_banner: "Esta herramienta no sustituye asesoramiento profesional de salud mental.",
    avatar_level: "Nivel",
    avatar_level_locked: "Desbloquea niveles con Decide o Avanza",
    avatar_streak: "dias consecutivos",
    avatar_streak_msg: "Cada dia cuenta. Tu constancia se refleja en tu avatar.",
    streak_recovery_title: "Recuperar racha",
    streak_recovery_available: "Detectamos un dia sin actividad. Puedes recuperar tu racha (1 vez/mes, plan Decide/Avanza).",
    streak_recovery_apply: "Recuperar mi racha",
    streak_recovery_used_month: "Ya usaste tu recuperacion este mes. Disponible de nuevo el proximo mes.",
    streak_recovery_no_gap: "No hay racha que recuperar. Tu constancia sigue intacta.",
    avatar_timeline_btn: "Tu historia",
    avatar_timeline_btn_desc: "Ve como has evolucionado en el tiempo",
    timeline_title: "Tu linea temporal",
    timeline_empty: "Tu historia empieza aqui",
    timeline_empty_hint: "Haz una consulta, un check-in o escribe en tu diario para empezar.",
    timeline_type_consultation: "Simulacion",
    timeline_type_mood: "Check-in emocional",
    timeline_type_diary: "Diario",
    timeline_type_challenge: "Micro-reto completado",
    mood_label: "Animo",
    energy_label: "Energia",
    stress_label: "Estres",
    avatar_checkin_reminder: "Tu check-in diario te espera",
    avatar_weekly_title: "Tu semana",
    avatar_weekly_no_data: "Empieza la semana registrando como te sientes.",
    ach_title: "Tus logros",
    ach_first_checkin: "Primer check-in",
    ach_streak_3: "3 dias seguidos",
    ach_streak_7: "7 dias seguidos",
    ach_streak_30: "30 dias seguidos",
    ach_checkins_10: "10 check-ins",
    ach_checkins_50: "50 check-ins",
    ach_first_consult: "Primera simulacion",
    ach_consults_10: "10 simulaciones",
    ach_first_diary: "Primera entrada de diario",
    ach_challenges_7: "7 micro-retos",
    ach_challenges_30: "30 micro-retos",
    ach_unlocked: "desbloqueados",
    ach_new: "Nuevo logro",
    avatar_challenge_checkin: "Podria ser un buen momento para registrar como te sientes hoy.",
    avatar_challenge_consult: "Si tienes alguna decision pendiente, quizas hoy sea buen dia para explorarla.",
    avatar_challenge_breathe: "3 respiraciones profundas pueden marcar la diferencia. Solo si te apetece.",
    avatar_challenge_gratitude: "Piensa en algo bueno que te haya pasado hoy. Solo un momento para ti.",
    avatar_challenge_pause: "Una pausa de 5 minutos puede ayudarte a reconectar. Tu decides cuando.",
    avatar_challenge_diary: "Escribir lo que sientes puede aportar claridad. Sin prisa, sin presion.",
    avatar_challenge_walk: "Un paseo corto puede cambiar tu perspectiva. Cuando tu quieras.",

    // Interactive Premium Tools
    tool_done: "Hecho",
    tool_close: "Cerrar",
    tool_breathing_title: "Respiración 4-7-8",
    tool_breathing_subtitle: "Técnica guiada sin sonido para calmar cuerpo y mente",
    tool_breathing_card_desc: "Un círculo luminoso guía tu respiración. Inhala 4s, mantén 7s, exhala 8s.",
    tool_breathing_duration: "2-5 min",
    tool_breathing_ready: "Prepárate",
    tool_breathing_inhale: "Inhala",
    tool_breathing_hold: "Mantén",
    tool_breathing_exhale: "Exhala",
    tool_breathing_hint: "Sigue el círculo. Cuanto más practiques, más rápido notarás la calma.",
    tool_breathing_cycles: "ciclos completados",
    tool_breathing_start: "Empezar",
    tool_breathing_stop: "Terminar",
    tool_grounding_title: "Grounding 5-4-3-2-1",
    tool_grounding_subtitle: "Técnica sensorial contra la ansiedad en momentos de agobio",
    tool_grounding_card_desc: "Identifica 5 cosas que ves, 4 que tocas, 3 que oyes, 2 que hueles, 1 que saboreas.",
    tool_grounding_duration: "3-5 min",
    tool_grounding_see_title: "cosas que VES",
    tool_grounding_see_hint: "Mira a tu alrededor y nombra lo que ves con detalle.",
    tool_grounding_see_placeholder: "Algo que veas ahora",
    tool_grounding_touch_title: "cosas que TOCAS",
    tool_grounding_touch_hint: "Nota texturas, temperaturas, pesos al alcance.",
    tool_grounding_touch_placeholder: "Algo que puedes tocar",
    tool_grounding_hear_title: "cosas que OYES",
    tool_grounding_hear_hint: "Presta atención a los sonidos, incluso los más sutiles.",
    tool_grounding_hear_placeholder: "Un sonido a tu alrededor",
    tool_grounding_smell_title: "cosas que HUELES",
    tool_grounding_smell_hint: "Identifica olores cercanos o recordados.",
    tool_grounding_smell_placeholder: "Un olor que detectas",
    tool_grounding_taste_title: "cosa que SABOREAS",
    tool_grounding_taste_hint: "Nota el sabor en tu boca o el último que probaste.",
    tool_grounding_taste_placeholder: "Un sabor presente",
    tool_grounding_next: "Siguiente",
    tool_grounding_finish: "Terminar",
    tool_grounding_done_title: "Estás aquí, presente",
    tool_grounding_done_msg: "Has vuelto a tu cuerpo y a este momento. La ansiedad pierde fuerza cuando enraizas.",
    tool_grounding_restart: "Repetir",
    tool_screenbreak_title: "Desafío sin pantalla",
    tool_screenbreak_subtitle: "Comprométete a no usar el móvil durante X minutos",
    tool_screenbreak_card_desc: "Elige un tiempo, deja el móvil. Si sales de la app, el reto falla.",
    tool_screenbreak_duration: "5-45 min",
    tool_screenbreak_streak: "Racha",
    tool_screenbreak_total_min: "Min sin pantalla",
    tool_screenbreak_pick_time: "¿Cuánto tiempo te comprometes a descansar?",
    tool_screenbreak_min: "min",
    tool_screenbreak_rules: "Puedes bloquear el móvil: el cronómetro sigue activo. Pero si sales de la app a otro sitio, el reto fallará.",
    tool_screenbreak_warning: "Puedes bloquear el móvil: el cronómetro sigue activo. Pero si sales de la app a otro sitio, el reto fallará.",
    tool_screenbreak_hint: "Puedes bloquear el móvil: el cronómetro sigue activo. Pero si sales de la app a otro sitio, el reto fallará.",
    tool_screenbreak_start: "Empezar reto",
    tool_screenbreak_remaining: "Restante",
    tool_screenbreak_keep_here: "Déjalo boca abajo y haz algo analógico.",
    tool_screenbreak_leave_fails: "Si sales de la app el reto fallará.",
    tool_screenbreak_lock_ok: "Puedes bloquear el móvil tranquilamente: el tiempo sigue contando.",
    tool_screenbreak_week_min: "min esta semana",
    tool_screenbreak_fail_title: "Desconexión digital no superada",
    tool_screenbreak_fail_msg: "Saliste de la app o cancelaste antes de tiempo. Sin presión: inténtalo cuando estés preparad@.",
    tool_screenbreak_cancel: "Cancelar reto",
    tool_screenbreak_success_title: "¡Lo conseguiste!",
    tool_screenbreak_success_msg: "Has descansado {minutes} minutos de la pantalla. Tu cerebro te lo agradece.",
    tool_screenbreak_again: "Otro reto",
    tool_screenbreak_retry: "Intentar de nuevo",

  },

  en: {
    nav_features: "Features",
    nav_how_it_works: "How it works",
    nav_pricing: "Plans",
    nav_login: "Log in",
    nav_login_short: "Log in",
    nav_register: "Get started",
    nav_register_short: "Start",
    nav_history: "History",
    nav_improve: "Upgrade",
    nav_compare: "Compare",
    nav_back: "Back",
    nav_plans: "Plans",

    landing_badge: "Your smart guide to better decisions",
    landing_h1_1: "Stop doubting, ",
    landing_h1_2: "start making confident decisions",
    landing_p: "With FUTURA, resolving important and everyday decisions with AI is easier, and you can also discover how your emotions influence every choice. Decide and move forward.",
    landing_cta: "Get started",
    landing_cta_plans: "View plans",
    landing_cta_plans_hint: "from $5.99/mo",
    landing_trust_free: "Free, no card",
    landing_trust_cancel: "Cancel anytime",
    landing_trust_secure: "Secure payment · Stripe",
    landing_social_proof: "+2,500 decisions simulated",
    landing_social_sub: "In the last 30 days",

    features_title: "Everything you need to decide with more clarity",
    features_subtitle: "Practical AI guidance for your everyday decisions, complemented with emotional wellbeing tools",
    feat_ai: "AI Guidance",
    feat_ai_desc: "Receive contextualised and personalised recommendations to resolve your everyday decisions with more confidence",
    feat_prob: "Clear recommendations",
    feat_prob_desc: "Visualise scenarios and probabilities based on your specific situation to choose with more confidence",
    feat_risk: "Context and risks",
    feat_risk_desc: "Identify potential obstacles and key factors before making any decisión",
    feat_time: "Emotional clarity",
    feat_time_desc: "Understand how your energy, stress or emotional state may influence your daily decisions",
    feat_rec: "Personalised insights",
    feat_rec_desc: "Receive observations based on your patterns to make decisions with more awareness",
    feat_impact: "Complementary wellbeing",
    feat_impact_desc: "Guided tools and práctical resources to accompany your daily life with more balance",

    how_title: "How it works",
    how_subtitle: "In three steps, you'll get práctical guidance and clarity to decide better",
    how_step1_title: "State your decisión",
    how_step1_desc: "Get práctical, contextual help to resolve everyday decisions like what to wear, what to choose, or how to act in day-to-day situations.",
    how_step2_title: "Get a smart recommendation",
    how_step2_desc: "FUTURA analyses your context and offers useful, fast and personalised guidance to decide with more confidence.",
    how_step3_title: "Decide with more clarity",
    how_step3_desc: "With the emotional tracking layer, you can also understand how your energy, stress or emotional state may influence your decisions.",

    dm_title: "Decide better inside and out",
    dm_subtitle: "Your decisions don't just depend on context. They also depend on how you feel. FUTURA combines práctical guidance + emotional clarity to help you decide with more awareness.",
    dm_card1_title: "Everyday decisions with AI",
    dm_card1_desc: "The essence of FUTURA: práctical help to resolve real day-to-day choices, from small doubts to everyday decisions with more context and less mental noise.",
    dm_card1_b1: "Contextualised recommendations",
    dm_card1_b2: "Day-to-day simulations",
    dm_card1_b3: "Practical and immediate help",
    dm_card1_b4: "Less overthinking",
    dm_card1_b5: "More clarity to choose",
    dm_card2_title: "Complementary emotional clarity",
    dm_card2_desc: "A non-clínical emotional tracking layer that helps you understand how your energy, stress or emotional state may influence your decisions and daily wellbeing.",
    dm_card2_b1: "Daily check-ins",
    dm_card2_b2: "Personal patterns",
    dm_card2_b3: "Guiding insights",
    dm_card2_b4: "More self-awareness",
    dm_card2_b5: "More conscious decisions",

    trust_title: "Designed to help you with clarity and responsibility",
    trust1_title: "Everyday decisions, práctical guidance",
    trust1_desc: "FUTURA is designed to help you with day-to-day decisions and offer non-clínical, guiding emotional wellbeing tools.",
    trust2_title: "Guiding and transparent AI",
    trust2_desc: "Recommendations and insights are designed to provide clarity, context and self-awareness, not to replace a professional evaluation.",
    trust3_title: "Responsible use",
    trust3_desc: "If you need specialised help, we always recommend consulting a qualified professional. FUTURA is a complement, not a substitute.",

    cta_title: "Ready to make better decisions?",
    cta_subtitle: "Try FUTURA for free and discover how AI can help you decide with more clarity every day.",
    cta_button: "Get started",

    mod_badge: "Discover what FUTURA includes",
    mod_title: "More than decisions: your wellbeing matters too",
    mod_subtitle: "FUTURA goes beyond decisions. It integrates emotional wellbeing tools to help you decide more clearly and feel better in your daily life.",
    mod1_tag: "Module 1",
    mod1_name: "Interactive tools",
    mod1_desc: "3 visual tools to support you when you need them most: guided breathing, 5-4-3-2-1 grounding, and screen-break challenges.",
    mod1_f1: "Visual 4-7-8 breathing",
    mod1_f2: "5-4-3-2-1 grounding",
    mod1_f3: "Digital rest challenge",
    mod1_f4: "Completely audio-free",
    mod1_plans: "Available on Decide and Avanza plans",
    mod2_tag: "Module 2",
    mod2_name: "Smart Emotional Tracking",
    mod2_desc: "Log your daily emotional state, discover patterns that influence your decisions, and count on your personal AI Diary as an empathetic companion.",
    mod2_f1: "Daily emotional check-in",
    mod2_f2: "Weekly charts and AI insights",
    mod2_f3: "Personal AI Diary",
    mod2_f4: "Emotional patterns and summary",
    mod2_plans: "Exclusive to the Avanza plan",


    footer_terms: "Terms and Conditions",
    footer_privacy: "Privacy Policy",
    footer_support: "Support",
    footer_rights: "2026 FUTURA. All rights reserved.",
    webview_sub_managed: "Subscriptions are managed from the website",
    webview_limit_modal: "You have reached today's free limit. Come back tomorrow or unlock unlimited access from our website in your browser.",
    webview_limit_accept: "OK",
    footer_disclaimer: "FUTURA is a platform for everyday decisión support and non-clínical emotional wellbeing guidance. It does not offer clínical diagnosis, psychological treatment or emergency care. If you need specialised help, we recommend consulting a qualified professional.",

    login_title: "Welcome back",
    login_subtitle: "Enter your credentials to continue",
    login_email: "Email",
    login_password: "Password",
    login_submit: "Log in",
    login_remember_me: "Remember my details",
    login_or: "or continue with",
    login_no_account: "Don't have an account?",
    login_register_link: "Sign up free",
    login_forgot_password: "Forgot your password?",
    login_right_title: "Smarter decisions",
    login_right_subtitle: "Practical AI guidance for your everyday decisions, complemented with emotional clarity",

    register_title: "Create your account",
    register_subtitle: "Start deciding with more clarity today",
    register_name: "Name",
    register_name_placeholder: "Your name",
    register_email: "Email",
    register_password: "Password",
    register_password_placeholder: "Minimum 6 characters",
    register_submit: "Create account",
    register_or: "or sign up with",
    register_has_account: "Already have an account?",
    register_login_link: "Log in",
    register_right_title: "Your first consultation is free",
    register_right_subtitle: "Discover how AI can help you make better decisions in your daily life",
    register_password_error: "Password must be at least 6 characters",
    register_password_alphanumeric: "Password can only contain letters and numbers (no symbols or spaces)",
    register_password_hint: "Letters and numbers only. Minimum 6 characters.",
    register_security_question: "Security question",
    register_select_question: "Select a question",
    register_security_answer: "Secret answer",
    register_security_answer_placeholder: "Your answer (cannot be changed)",
    register_security_required: "You must choose a question and write your secret answer",
    register_security_warning: "Remember this answer. It is the only way to recover your account if you forget your password.",

    // Forgot Password
    login_forgot_password: "Forgot your password?",
    forgot_title: "Recover your account",
    forgot_subtitle_email: "Enter your email and we will send you a link to reset your password.",
    forgot_email_label: "Email",
    forgot_send_link: "Send link",
    forgot_sent_title: "Email sent!",
    forgot_sent_text: "We have sent a password reset link to:",
    forgot_sent_check_spam: "Check your spam folder if you can't find it.",
    forgot_min_password: "Password must be at least 6 characters",
    forgot_passwords_mismatch: "Passwords do not match",
    forgot_confirm_password: "Confirm password",
    reset_title: "New password",
    reset_subtitle: "Choose a secure password of at least 6 characters.",
    reset_new_password: "New password",
    reset_new_placeholder: "Minimum 6 characters",
    reset_confirm_password: "Confirm password",
    reset_confirm_placeholder: "Repeat the password",
    reset_btn: "Change password",
    reset_done_title: "Password updated!",
    reset_done_subtitle: "Your password has been changed successfully. You can now log in.",
    reset_go_login: "Log in",
    reset_invalid_link: "Invalid link",
    reset_invalid_desc: "This recovery link is invalid or has expired.",
    reset_request_new: "Request new link",
    verify_title: "Verify your email",
    verify_subtitle: "We have sent a verification code to:",
    verify_code_label: "Verification code",
    verify_btn: "Verify",
    verify_resend: "Resend code",
    verify_resent: "Code resent successfully",
    verify_back_login: "Back to login",
    register_gdpr_required: "You must accept the terms and privacy policy",
    register_gdpr_text: "I accept the",
    register_gdpr_terms: "Terms and Conditions",
    register_gdpr_and: "and the",
    register_gdpr_privacy: "Privacy Policy",
    sq_pet: "What is the name of your first pet?",
    sq_city: "In which city were you born?",
    sq_teacher: "What is the name of your favourite teacher?",
    sq_food: "What is your favourite food?",
    sq_friend: "What is the name of your best childhood friend?",
    profile_security_title: "Security question",
    profile_security_set: "Configured",
    profile_security_not_set: "Not configured",
    profile_security_btn: "Set up security question",
    profile_security_update: "Update question",
    profile_security_save: "Save",
    security_prompt_subtitle: "Set up your question to be able to recover your account",
    profile_email: "Email",
    profile_auth_method: "Access method",
    profile_auth_email: "Email and password",
    profile_plan: "Current plan",
    profile_upgrade: "Upgrade plan",
    profile_member_since: "Member since",
    profile_change_password: "Change password",
    profile_change_password_sub: "Update your access password",
    profile_current_password: "Current password",
    profile_pw_min: "New password must be at least 6 characters",
    profile_pw_success: "Password updated successfully",
    profile_save_password: "Save new password",
    profile_manage_subscription: "Manage subscription",
    profile_cancel_warning: "If you cancel your subscription, you will lose access to premium features at the end of your current period. Your plan will revert to Descubre (free).",
    profile_cancel_confirm_label: "Type CANCEL to confirm",
    profile_cancel_button: "Cancel subscription",
    pricing_cancel_anytime: "Cancel anytime",
    pf_diary_ai: "Personal AI Diary",
    diary_gate_title: "AI Diary",
    diary_gate_desc: "Access your AI emotional diary with the Avanza plan",
    diary_gate_btn: "View Avanza plan",

    consulta_h1_1: "What decisión do you need",
    consulta_h1_2: "to make today?",
    consulta_subtitle: "I'll ask you some questions to understand your situation and give you the best recommendation.",
    consulta_placeholder: "Describe your dilemma or decisión...",
    consulta_start: "Start",
    consulta_examples_title: "Example questions",
    consulta_question_of: "Question {current} of {total}",
    consulta_answer_placeholder: "Write your answer...",
    consulta_generating: "Perfect! I have all the information. Generating your personalised analysis...",
    consulta_analyzing: "Analysing your situation...",
    consulta_loading_estimate: "We're processing your simulation, this can take up to 1 minute.",
    consulta_loading_phrase_1: "Your simulation is in progress, this may take a few seconds.",
    consulta_loading_phrase_2: "Considering scenarios, risks and opportunities...",
    consulta_loading_phrase_3: "Reviewing your emotional and rational signals.",
    consulta_loading_phrase_4: "We're looking for what really matters to you.",
    consulta_loading_phrase_5: "Almost there. It's worth the wait.",
    consulta_footer: "FUTURA offers práctical and complementary guidance for your everyday decisions. It does not replace professional advice.",

    example_q1: "Should I change jobs?",
    example_q2: "Should I buy this or save?",
    example_q3: "Should I move to another city?",
    example_q4: "What should I wear today?",
    example_q5: "Should I invest or wait?",
    example_q6: "Should I study this or that?",

    result_analysis_title: "Analysis of your decisión",
    result_success: "Probability of success",
    result_recommendation_level: "Recommendation level",
    result_stress: "Stress level",
    result_happiness: "Wellbeing level",
    result_recommendation: "RECOMMENDATION",
    result_why: "Why this recommendation?",
    result_motives: "REASONS",
    result_risks: "ASPECTS TO CONSIDER",
    result_alternative: "ALTERNATIVE",
    result_top3: "TOP 3 RECOMMENDED PATHS",
    result_confidence: "confidence",
    result_risk: "risk",
    result_action_plan: "ACTION PLAN",
    result_premium_summary: "PREMIUM SUMMARY",
    result_premium_tag: "PREMIUM",
    result_upsell: "Want more? With the",
    result_upsell_features: "Top 3 recommended paths - Action plan - Premium summary - Comparator",
    result_upsell_btn: "View Avanza plan",
    result_new_consultation: "New consultation",
    result_limit_reached: "You've reached your consultation limit. Upgrade your plan to continue.",
    result_view_plans: "View plans",

    history_title: "Consultation history",
    history_subtitle: "Review all your past consultations",
    history_compare_btn: "Compare scenarios",
    history_search: "Search consultations...",
    history_no_results: "No results",
    history_no_consultations: "No consultations yet",
    history_no_results_hint: "Try different search terms",
    history_no_consultations_hint: "Make your first consultation to see it here",
    history_first_btn: "Make my first consultation",
    history_motives: "Reasons",
    history_risks: "Aspects",
    history_alternative: "Alternative",
    history_reasons: "reasons",
    history_identified: "identified",
    history_delete_title: "Delete consultation",
    history_delete_confirm: "Are you sure you want to delete this consultation? This action cannot be undone.",
    history_delete_cancel: "Cancel",
    history_delete_yes: "Delete",

    pricing_title: "Choose your plan",
    pricing_subtitle: "Better decisions, more clarity. Choose the plan that suits you.",
    pricing_monthly: "Monthly",
    pricing_annual: "Annual",
    pricing_forever: "forever",
    pricing_month: "/month",
    pricing_year: "/year",
    pricing_your_plan: "Your current plan",
    pricing_free: "Free",
    pricing_subscribe: "Choose plan",
    pricing_secure: "Secure payments processed by Stripe. Cancel anytime.",
    pricing_cancel: "Cancel my subscription",
    pricing_cancel_confirm: "Are you sure you want to cancel? You'll return to the Descubre plan.",

    plan_descubre: "Descubre",
    plan_descubre_badge: "Free",
    plan_descubre_desc: "A first look at what FUTURA can do for you",
    plan_decide: "Decide",
    plan_decide_badge: "Popular",
    plan_decide_desc: "Stop doubting. Start living with clarity and confidence in every decision.",
    plan_avanza: "Avanza",
    plan_avanza_badge: "Transformative",
    plan_avanza_desc: "Feel the difference of making every decision with total clarity, understanding your emotions and with a personalised action plan. A unique experience that transforms the way you live.",
    plan_saves: "You save",
    plan_per_month: "/month",
    plan_start_free: "Start free",
    plan_choose_decide: "Choose Decide",
    plan_choose_avanza: "Choose Avanza",
    pricing_popular: "Most popular",
    pricing_annual_hint: "Annual plans available with a discount — secure payment via Stripe. Cancel anytime.",
    plan_descubre_feat1: "1 simulation per day",
    plan_descubre_feat2: "Daily emotional check-in",
    plan_descubre_feat3: "Customisable avatar",
    plan_decide_feat1: "50 simulations per month",
    plan_decide_feat2: "Full decision history",
    plan_decide_feat3: "Avatar levels (1-10) and achievements",
    plan_decide_feat4: "Recover streak once per month",
    plan_avanza_feat1: "Unlimited simulations",
    plan_avanza_feat2: "Personal AI Journal + premium report",
    plan_avanza_feat3: "Advanced decision comparator",
    plan_avanza_feat4: "Everything in Decide included",
    plan_intent_banner: "You are one step away from activating {plan} for {price}/month. Complete your subscription whenever you like.",
    plan_intent_continue: "Activate",
    plan_intent_dismiss: "Dismiss",

    plan_descubre_emotion: "Try free, no commitment",
    plan_decide_emotion: "The clarity you deserve, every day",
    plan_decide_hook: "Imagine making 50 decisions a month knowing each one was deeply analysed. No more sleepless nights. No more paralysing doubts.",
    plan_avanza_emotion: "Transform your life from within",
    plan_avanza_hook: "Unlimited decisions + your personal AI Diary. Because the best decisions come when you understand what you feel. Your evolution starts here.",

    pf_1sim: "1 simulation per day",
    pf_ai_rec: "Basic guiding recommendation",
    pf_basic_motives: "Simplified general analysis",
    pf_50sim: "50 simulations per month",
    pf_5sim: "5 simulations per month",
    pf_detailed_motives: "Deep analysis with personal context",
    pf_full_history: "Full decision history",
    pf_emotional_tracking: "Smart Emotional Tracking",
    pf_checkin: "Daily emotional check-in",
    pf_mood_tracker: "Smart mood tracker",
    pf_journal: "Guided emotional journal",
    pf_energy_log: "Energy, rest and stress log",
    pf_weekly_charts: "Weekly wellbeing charts",
    pf_ai_insights: "Personalised AI insights",
    pf_patterns: "Emotional pattern summary",
    pf_smart_ai: "Advanced AI that understands your real context",
    pf_unlimited: "Unlimited simulations",
    pf_premium_ai: "Premium AI: deep, empathic and transformative analysis",
    pf_pdf: "Download results as PDF",
    pf_comparator: "Scenario comparator",
    pf_premium_report: "Premium report with final recommendation",
    pf_top3: "Top 3 recommended paths",
    pf_confidence: "Confidence / risk level per option",
    pf_action: "Personalised step-by-step action plan",
    pf_library: "Premium Wellbeing Library",
    pf_audio_guides: "Visual 4-7-8 breathing guide",
    pf_programs: "Structured 7/14/21 day programmes",
    pf_routines: "5-4-3-2-1 grounding for anxiety",
    pf_smart_recs: "Screen-break challenge with device tracking",
    pf_regulation: "Practical emotional regulation tools",
    pf_diary_ai_desc: "Your personal AI Diary: write, speak and understand your emotions",
    pf_avatar: "Customisable dynamic avatar",
    pf_avatar_challenges: "Daily micro-challenges with your avatar",
    pf_checkin_free: "Free daily emotional check-in",
    pf_avatar_levels: "Avatar level system (1-10)",

    pmiss_history: "Full history",
    pmiss_pdf: "PDF download",
    pmiss_comparator: "Scenario comparator",
    pmiss_premium: "Premium report",
    pmiss_emotional: "Emotional tracking",
    pmiss_library: "Premium interactive tools",
    pmiss_diary_ai: "Personal AI Diary",
    pmiss_smart_ai: "Advanced AI",

    sim_counter_daily: "Today",
    sim_counter_monthly: "This month",
    sim_counter_unlimited: "Unlimited",
    sim_counter_available: "available",
    sim_counter_available_pl: "available",
    sim_counter_next_reset: "Renews",
    sim_counter_next_reset_in: "in",
    sim_counter_hours: "h",
    sim_counter_upgrade: "Unlock more simulations",

    landing_diary_badge: "Exclusive to Avanza Plan",
    landing_diary_title: "Your AI Diary: where everything starts making sense",
    landing_diary_subtitle: "Write what you feel, talk to it by voice, and let the AI help you understand yourself. It's not an ordinary diary. It's your intelligent emotional companion.",
    landing_diary_f1: "Write or speak: express your emotions your way",
    landing_diary_f2: "AI detects your patterns and helps you see them",
    landing_diary_f3: "Crisis analysis: if you're going through a hard time, FUTURA detects it",
    landing_diary_f4: "Your emotional evolution visible week by week",
    landing_diary_cta: "I want my AI Diary",

    comp_title: "Scenario Comparator",
    comp_subtitle: "Select 2 to 4 consultations to compare their results",
    comp_gate_title: "Scenario Comparator",
    comp_gate_desc: "This feature is available on the Avanza plan",
    comp_gate_btn: "View Avanza plan",
    comp_no_consultations: "You have no consultations to compare. Make your first consultation.",
    comp_compare_btn: "Compare {count} consultations",
    comp_best: "Best option",
    comp_new: "New comparison",
    comp_success: "Success",
    comp_recommendation: "Recommendation",
    comp_stress: "Stress",
    comp_happiness: "Wellbeing",
    comp_rec_label: "Recommendation",

    pay_checking: "Verifying payment...",
    pay_checking_sub: "Please wait while we confirm your transaction",
    pay_attempt: "Attempt {n} of 5",
    pay_success: "Payment successful!",
    pay_go_dashboard: "Go to Dashboard",
    pay_error: "Payment error",
    pay_retry: "Try again",
    pay_back_dashboard: "Back to Dashboard",
    pay_no_session: "No payment information found",
    pay_timeout: "We couldn't verify the payment. Please contact support.",
    pay_expired: "The payment session has expired. Please try again.",

    dash_hello: "Hello",
    dash_what: "What decisión do you want to resolve today?",
    dash_simulations: "Simulations",
    dash_used_month: "used this month",
    dash_decisions: "Decisions",
    dash_in_history: "in your history",
    dash_plan: "Plan",
    dash_upgrade: "Upgrade plan",
    dash_new_sim: "New consultation",
    dash_new_sim_desc: "Describe your decisión and get práctical guidance with personalised recommendations",
    dash_create_sim: "Create consultation",
    dash_limit: "You've reached your simulation limit. Upgrade your plan to continue.",
    dash_recent: "Recent consultations",
    dash_view_all: "View all",
    dash_completed: "Completed",
    dash_pending: "Pending",
    dash_no_decisions: "No consultations yet",
    dash_no_decisions_hint: "Create your first consultation to see results here",
    dash_first_sim: "Create my first consultation",
    dash_used_today: "used today",
    dash_unlimited: "unlimited simulations",
    dash_resets: "Resets:",
    dash_limit_reached: "You have reached your consultation limit. Upgrade your plan to continue.",
    dash_question: "What decision do you want to simulate today?",
    dash_history: "History",
    dash_plans: "Plans",
    dash_wellbeing: "Wellbeing",
    dash_library: "Tools",
    dash_emotional_tracking: "Emotional Tracking",
    dash_emotional_desc: "Track your mood and get insights",
    dash_premium_library: "Interactive tools",
    dash_premium_desc: "Breathing, grounding and digital rest",
    dash_screenbreak_label: "Digital rest",
    dash_screenbreak_min_week: "screen-free min this week",

    loading: "Loading...",
    lang_es: "Español",
    lang_en: "English",
    lang_de: "Deutsch",
    lang_it: "Italiano",

    nav_wellbeing: "Wellbeing",
    nav_library: "Library",
    nav_diary: "AI Diary",
    nav_profile: "Profile",
    nav_logout: "Log out",
    pricing_module1_title: "Module 1: Interactive tools",
    pricing_module2_title: "Module 2: Emotional Tracking",
    pf_favorites: "Save favourite consultations",

    mood_title: "Emotional Tracking",
    mood_subtitle: "Log how you feel and discover how your state influences your decisions",
    mood_checkin_title: "Today's check-in",
    mood_checkin_sub: "How are you feeling right now?",
    mood_today_done: "Check-in complete",
    mood_today_done_sub: "You already logged today's state. Come back tomorrow.",
    mood_label: "Mood",
    energy_label: "Energy",
    stress_label: "Stress",
    mood_1: "Very low",
    mood_2: "Low",
    mood_3: "Normal",
    mood_4: "Good",
    mood_5: "Very good",
    energy_1: "Exhausted",
    energy_2: "Tired",
    energy_3: "Normal",
    energy_4: "Active",
    energy_5: "Full of energy",
    stress_1: "Very relaxed",
    stress_2: "Calm",
    stress_3: "Normal",
    stress_4: "Stressed",
    stress_5: "Very stressed",
    mood_note_placeholder: "Optional note: anything you want to write down?",
    mood_save: "Save check-in",
    mood_weekly_title: "Last 7 days",
    mood_averages_title: "Weekly averages",
    mood_checkins_count: "check-ins this week",
    mood_insight_title: "Personalised insight",
    mood_insight_loading: "Calculating your weekly summary...",
    mood_empty: "Do your first check-in to start seeing your emotional patterns",
    mood_history_title: "Recent history",
    mood_disclaimer: "FUTURA's emotional tracking is for guidance only and is non-clínical. It does not replace professional care.",
    mood_gate_title: "Emotional Tracking",
    mood_gate_desc: "This feature is available on the Avanza plan",
    mood_gate_btn: "View Avanza plan",

    diary_title: "AI Diary",
    diary_empty_title: "Your safe space",
    diary_empty_desc: "Write how you feel today. I'm here to listen, without judgement.",
    diary_placeholder: "How are you feeling today?",
    diary_recording: "Recording...",
    diary_stop: "Stop",
    diary_transcribing: "Transcribing audio...",
    diary_voice_transcribed: "Transcribed from audio",
    diary_weekly_summary: "Weekly summary",
    diary_challenge_label: "Suggested micro-challenge",

    lib_title: "Premium Library",
    lib_subtitle: "Guided audios and routines to support your daily wellbeing",
    lib_tab_programs: "Programmes",
    lib_tab_audios: "Guided audios",
    lib_tab_routines: "Routines",
    lib_days: "days",
    lib_sessions: "sessions",
    lib_steps: "steps",
    lib_prog_stress7_title: "Reduce stress in 7 days",
    lib_prog_stress7_desc: "A daily programme with práctical breathing exercises, active breaks and reflection to reduce accumulated stress.",
    lib_prog_energy14_title: "Recover energy in 14 days",
    lib_prog_energy14_desc: "Progressive activities to improve your energy level, rest and vitality over two weeks.",
    lib_prog_balance21_title: "21 days of personal balance",
    lib_prog_balance21_desc: "A complete journey combining wellbeing habits, self-care and emotional regulation to transform your daily life.",
    lib_prog_sleep7_title: "Improve sleep in 7 days",
    lib_prog_sleep7_desc: "Techniques and bedtime routines for more restorative sleep and waking with more energy.",
    lib_audio_breathing_title: "Guided breathing",
    lib_audio_breathing_desc: "4-7-8 breathing technique for instant calm",
    lib_audio_relax_title: "Deep relaxation",
    lib_audio_relax_desc: "Progressive muscle relaxation exercise",
    lib_audio_focus_title: "Focus and concentration",
    lib_audio_focus_desc: "Guided meditation to improve your attention",
    lib_audio_sleep_title: "Sleep preparation",
    lib_audio_sleep_desc: "Guided visualisation for restorative rest",
    lib_audio_morning_title: "Wake with energy",
    lib_audio_morning_desc: "Morning mind-body activation routine",
    lib_audio_pause_title: "Quick pause",
    lib_audio_pause_desc: "Express mental break for tense moments",
    lib_audio_intro: "Press play to listen to AI-generated guided audios. The first play may take a few seconds.",
    lib_audio_coming_soon: "New guided audios coming soon",
    lib_routine_morning_title: "Morning wellbeing routine",
    lib_routine_morning_desc: "Start the day with more clarity: hydration, breathing, daily intention and gentle movement.",
    lib_routine_stress_title: "Anti-stress routine",
    lib_routine_stress_desc: "When you feel tensión: deep breathing, stretching, digital disconnect and a gratitude note.",
    lib_routine_night_title: "Bedtime rest routine",
    lib_routine_night_desc: "Prepare your body and mind for sleep: no screens, breathing, daily reflection and relaxation.",
    lib_disclaimer: "These tools offer guidance and do not replace professional care.",
    lib_gate_title: "Interactive tools",
    lib_gate_desc: "Access guided breathing, grounding and screen-break challenges with the Decide or Avanza plan",
    lib_gate_btn: "View plans",
    lib_audio_error: "Audio loading error. Tap to retry.",
    lib_back_to_list: "Back",
    lib_day: "Day",
    lib_step: "Step",
    lib_start_audio: "Listen to guided audio",
    lib_program_intro: "Follow each session in order for best results. Each day includes a guided audio.",
    lib_routine_intro: "Follow each step in order. Take your time.",
    lib_duration_min: "min",
    lib_prog_stress7_d1: "Deep breathing 4-7-8",
    lib_prog_stress7_d2: "Body tension scan",
    lib_prog_stress7_d3: "Active pause and stretching",
    lib_prog_stress7_d4: "Quick emotion journal",
    lib_prog_stress7_d5: "Focus meditation",
    lib_prog_stress7_d6: "Guided digital disconnect",
    lib_prog_stress7_d7: "Week review and closure",
    lib_prog_energy14_d1: "Wake with intention",
    lib_prog_energy14_d2: "Gentle morning movement",
    lib_prog_energy14_d3: "Conscious hydration and nutrition",
    lib_prog_energy14_d4: "Active breaks during the day",
    lib_prog_energy14_d5: "Energising breathing",
    lib_prog_energy14_d6: "Conscious nap or rest",
    lib_prog_energy14_d7: "First week review",
    lib_prog_energy14_d8: "Establish sleep routine",
    lib_prog_energy14_d9: "Morning gratitude exercise",
    lib_prog_energy14_d10: "Emotional energy management",
    lib_prog_energy14_d11: "Body and mind activation",
    lib_prog_energy14_d12: "Nature connection",
    lib_prog_energy14_d13: "Deep restorative rest",
    lib_prog_energy14_d14: "Progress celebration",
    lib_prog_balance21_d1: "Intention and self-care",
    lib_prog_balance21_d2: "Balancing breathing",
    lib_prog_balance21_d3: "Identify your triggers",
    lib_prog_balance21_d4: "Pause regulation",
    lib_prog_balance21_d5: "Acceptance exercise",
    lib_prog_balance21_d6: "Conscious communication",
    lib_prog_balance21_d7: "Weekly review",
    lib_prog_balance21_d8: "Healthy boundaries",
    lib_prog_balance21_d9: "Self-compassion",
    lib_prog_balance21_d10: "Managing expectations",
    lib_prog_balance21_d11: "Active gratitude",
    lib_prog_balance21_d12: "Emotional resilience",
    lib_prog_balance21_d13: "Guilt-free rest",
    lib_prog_balance21_d14: "Fortnightly review",
    lib_prog_balance21_d15: "Relationships and wellbeing",
    lib_prog_balance21_d16: "Creativity and expression",
    lib_prog_balance21_d17: "Mindful movement",
    lib_prog_balance21_d18: "Personal space",
    lib_prog_balance21_d19: "Celebrating small wins",
    lib_prog_balance21_d20: "Future visualisation",
    lib_prog_balance21_d21: "Integration and commitment",
    lib_prog_sleep7_d1: "Turn off screens one hour before bed",
    lib_prog_sleep7_d2: "Relaxing bedtime breathing",
    lib_prog_sleep7_d3: "Safe place visualisation",
    lib_prog_sleep7_d4: "Bedtime body scan",
    lib_prog_sleep7_d5: "Bedtime gratitude journal",
    lib_prog_sleep7_d6: "Progressive muscle relaxation",
    lib_prog_sleep7_d7: "Week closure and deep rest",
    lib_routine_morning_s1: "Drink a glass of water upon waking",
    lib_routine_morning_s2: "Take 3 deep breaths with eyes closed",
    lib_routine_morning_s3: "Set your intention for today in one sentence",
    lib_routine_morning_s4: "Do 5 minutes of gentle stretching",
    lib_routine_stress_s1: "Stop and take 5 deep breaths",
    lib_routine_stress_s2: "Stretch neck, shoulders and back for 3 minutes",
    lib_routine_stress_s3: "Put your phone away and look out the window for 2 minutes",
    lib_routine_stress_s4: "Write something you are grateful for today",
    lib_routine_stress_s5: "Listen to the quick pause audio",
    lib_routine_night_s1: "Turn off all screens 30 minutes before bed",
    lib_routine_night_s2: "Take 5 slow, deep breaths",
    lib_routine_night_s3: "Think of 3 good things that happened today",
    lib_routine_night_s4: "Listen to the sleep preparation audio",
    lib_completed: "Completed",
    lib_mark_complete: "Mark as completed",
    detail_back_history: "History",
    detail_not_found: "Consultation not found",
    detail_error: "Error loading consultation",
    detail_qa_title: "Questions and answers",
    detail_metrics: "Analysis metrics",
    detail_success: "Success probability",
    detail_recommendation: "Recommendation level",
    detail_stress: "Stress level",
    detail_happiness: "Happiness level",
    detail_recommendation_title: "Recommendation",
    detail_motives: "Reasons in favour",
    detail_risks: "Identified risks",
    detail_alternative: "Alternative",
    detail_top3: "Top 3 recommended paths",
    detail_confidence: "Confidence",
    detail_risk: "Risk",
    detail_action_plan: "Action plan",
    detail_premium_summary: "Premium summary",

    // Legal footer
    legal_privacy: "Privacy",
    legal_cookies: "Cookies",
    legal_terms: "Terms",
    legal_delete_account: "Delete account",
    legal_cookie_settings: "Cookie settings",
    legal_rights: "All rights reserved.",

    // Cookie banner
    cookie_title: "This site uses cookies",
    cookie_description: "We use essential cookies for the service to work. You can accept or reject optional analytics cookies.",
    cookie_accept: "Accept",
    cookie_reject: "Reject",
    cookie_configure: "Configure",
    cookie_config_title: "Cookie preferences",
    cookie_essential: "Essential",
    cookie_essential_desc: "Required for authentication and basic functionality",
    cookie_analytics: "Analytics",
    cookie_analytics_desc: "Help us understand how the platform is used",
    cookie_always_active: "Always active",
    cookie_save: "Save preferences",

    // Cookie policy page
    cookiep_title: "Cookie Policy",
    cookiep_updated: "Last updated: April 2026",
    cookiep_what_title: "1. What are cookies",
    cookiep_what_text: "Cookies are small text files stored on your device when you visit a website. They are used to remember preferences, maintain active sessions and improve the user experience.",
    cookiep_types_title: "2. Types of cookies we use",
    cookiep_types_text: "Essential cookies: necessary for the basic operation of the platform (authentication, session, language preferences and cookie consent). They are activated automatically and cannot be disabled.\n\nAnalytics cookies (optional): allow us to understand how users interact with the platform to improve the service. They are only activated with your consent.",
    cookiep_essential_title: "3. Essential cookies",
    cookiep_essential_text: "- Authentication token (JWT): keeps your session active.\n- Language preference: remembers your selected language.\n- Cookie consent: stores your cookie choice.",
    cookiep_analytics_title: "4. Analytics cookies",
    cookiep_analytics_text: "We currently do not use third-party analytics services. If we incorporate tools such as Google Analytics in the future, they will only be activated with your explicit consent.\n\nThis section will be updated accordingly.",
    cookiep_manage_title: "5. How to manage cookies",
    cookiep_manage_text: "You can accept, reject or configure cookies when the consent banner appears. You can also change your preferences at any time from the 'Cookie settings' link in the footer.",
    cookiep_revoke_title: "6. How to revoke consent",
    cookiep_revoke_text: "You can revoke your consent at any time:\n- From the 'Cookie settings' link in the footer.\n- By deleting cookies from your browser.\n- Consent will be requested again if cookie categories change or if it expires.",
    cookiep_changes_title: "7. Changes to this policy",
    cookiep_changes_text: "This policy may be updated if new cookies or services are incorporated. The update date will be indicated at the top.",

    // Privacy policy
    privacy_title: "Privacy Policy",
    privacy_updated: "Last updated: April 2026",
    privacy_s1_title: "1. Data controller",
    privacy_s1_text: "FUTURA DECISIONS APP, individual, based in Spain.\n\nContact: soporte@futura-app.com\nWeb: www.futura-app.com",
    privacy_s2_title: "2. Data we collect",
    privacy_s2_text: "We collect the following data:\n- Registration data: name, email and encrypted password.\n- Usage data: consultations, simulations, mood tracking and preferences.\n- Payment data: securely processed by Stripe. We do not store card data.\n- Technical data: IP address, browser type and device for service operation.",
    privacy_s3_title: "3. Purpose of processing",
    privacy_s3_text: "We use your data to:\n- Provide the decision simulation and emotional wellbeing service.\n- Manage your account and subscription.\n- Personalise the experience within the platform.\n- Send service-related communications (we do not send advertising).",
    privacy_s4_title: "4. Legal basis",
    privacy_s4_text: "The processing of your data is based on:\n- Contract performance: to provide the requested service.\n- Consent: for optional analytics cookies.\n- Legitimate interest: to improve the security and operation of the service.",
    privacy_s5_title: "5. Third parties and providers",
    privacy_s5_text: "We use the following providers:\n- Stripe: payment processing (PCI-DSS).\n- OpenAI: processing consultations via AI. Data is sent to generate responses and is not used to train models.\n- Cloud infrastructure provider: service hosting.\n\nWe do not sell or share your personal data with third parties for commercial purposes.",
    privacy_s6_title: "6. Data retention",
    privacy_s6_text: "We retain your data while you maintain an active account. If you request account deletion, we will permanently delete your data, unless legally required to keep it.",
    privacy_s7_title: "7. User rights",
    privacy_s7_text: "You have the right to:\n- Access: request a copy of your data.\n- Rectification: correct inaccurate data.\n- Erasure: request deletion of your account and data.\n- Portability: receive your data in a structured format.\n- Objection: object to processing in certain circumstances.\n- Restriction: request restriction of processing.",
    privacy_s8_title: "8. How to exercise your rights",
    privacy_s8_text: "You can exercise your rights:\n- By deleting your account from the profile section within the app.\n- By contacting soporte@futura-app.com.\n- By visiting the /eliminar-cuenta page for more information.\n\nWe will respond to your request within a maximum of 30 days.",
    privacy_s9_title: "9. Security",
    privacy_s9_text: "We implement security measures to protect your data:\n- Password encryption via bcrypt.\n- Encrypted communications via HTTPS/TLS.\n- Secure authentication tokens (JWT).\n- PCI-DSS certified payment processing through Stripe.",
    privacy_s10_title: "10. Changes to this policy",
    privacy_s10_text: "We may update this Privacy Policy. We will notify you of significant changes. The update date is indicated at the top.",

    // Terms new sections
    terms_title: "Terms and Conditions",
    terms_updated: "Last updated: April 2026",
    terms_s1_title: "1. Nature of the service",
    terms_s1_text: "FUTURA is an artificial intelligence platform designed to support users in personal growth, emotional wellbeing, and everyday decision making. FUTURA is not a medical, psychological, psychiatric, or therapeutic service. We do not provide clinical diagnoses, prescribe treatments, or replace professional care of any kind.",
    terms_s2_title: "2. Scope of recommendations",
    terms_s2_text: "Recommendations, insights, and content generated by FUTURA are for guidance only. They are not professional medical, legal, financial, or psychological advice. The user is always ultimately responsible for their own decisions.",
    terms_s3_title: "3. Emotional tracking (Module 1)",
    terms_s3_text: "The Emotional Tracking module allows the user to voluntarily record their mood, energy, and stress levels. This data is used exclusively to generate personalized guidance. This tracking is not a clinical measurement tool or a substitute for professional psychological evaluation.",
    terms_s4_title: "4. Premium Library (Module 2)",
    terms_s4_text: "Guided audios, programs, and routines available in the Premium Library are tools to support the user's general wellbeing through breathing, relaxation, and mindfulness techniques. They do not replace therapy, medical treatment, or any psychological intervention.",
    terms_s5_title: "5. Professional help recommendation",
    terms_s5_text: "If the user experiences significant emotional distress, anxiety crises, persistent negative thoughts, or any situation requiring specialized attention, we strongly recommend consulting a qualified mental health professional. FUTURA is a complement to daily life, not a substitute for professional care.",
    terms_s6_title: "6. AI and data usage",
    terms_s6_text: "FUTURA uses artificial intelligence models to generate recommendations and insights. User data is stored securely and used exclusively to improve the personalized experience within the platform. We do not share personal data with third parties. The user can request data deletion at any time.",
    terms_s7_title: "7. Plans and subscriptions",
    terms_s7_text: "FUTURA offers free and paid plans. Subscriptions are managed through Stripe and can be cancelled at any time. Upon cancellation, the user retains access until the end of the already-paid period. Prices may vary and will be communicated in advance.",
    terms_s8_title: "8. Acceptance",
    terms_s8_text: "By using FUTURA, the user accepts these terms and conditions. FUTURA reserves the right to modify these terms, notifying changes to the user with reasonable advance notice.",
    terms_s9_title: "9. Account deletion",
    terms_s9_text: "The user may request the deletion of their account and associated data at any time from the profile section of the application. Deletion is irreversible and executed immediately.",
    terms_s10_title: "10. Applicable law",
    terms_s10_text: "These terms are governed by the laws of Spain. For any dispute, the parties shall submit to the competent courts of Spain.",
    terms_s11_title: "11. Dynamic avatar and associated features",
    terms_s11_text: "FUTURA includes a customisable visual avatar that reflects the user's activity on the platform in an orientative way. The avatar evolves based on the use of tools such as decision simulations, emotional check-ins and the AI diary.\n\nHow it works: The avatar calculates a 'clarity level' (0-100) based on recent user activity (last 7 days). This level determines the avatar's visual state (Scattered, Focused, Precise, Powerful). The data used is exclusively generated by the user within the platform.\n\nDaily micro-challenges: The avatar suggests optional activities. These are always voluntary, do not penalise non-completion, and do not use language that induces guilt or emotional dependency.\n\nActivity streak: A counter of consecutive active days is displayed. This is purely informational.\n\nNotifications: The user may voluntarily enable push notifications for micro-challenge reminders, which can be disabled at any time.\n\nEmotional data protection: Emotional wellbeing data is stored encrypted and used exclusively to calculate the avatar state. It is not shared with third parties or used for advertising.\n\nLimitations: This visual representation is NOT a clinical diagnosis, does NOT measure mental health states, does NOT replace evaluation by a qualified professional and should NOT be interpreted as medical or psychological advice.",

    // Delete account page
    delaccount_title: "Delete account",
    delaccount_subtitle: "Information about how to delete your FUTURA account",
    delaccount_how_title: "How to delete your account",
    delaccount_how_text: "To delete your account:\n1. Log in to your FUTURA account.\n2. Go to your profile (user icon).\n3. Scroll to the bottom.\n4. Tap 'Delete account'.\n5. Enter your password to confirm.\n6. Your account and all associated data will be permanently deleted.",
    delaccount_what_title: "What data is deleted",
    delaccount_what_text: "When you delete your account, the following is permanently erased from the server:\n- Your profile and registration data.\n- All your consultations and simulations.\n- Your mood tracking history.\n- Your diary entries.\n- Preferences and settings.\n\nThis action is irreversible. Payment data managed by Stripe is retained per their own policy.",
    delaccount_contact_title: "Contact",
    delaccount_contact_text: "If you cannot access your account or need help deleting it, contact soporte@futura-app.com.",
    delaccount_cta_text: "To delete your account, please log in first.",
    delaccount_cta_button: "Log in",

    // Profile delete account
    profile_delete_account: "Delete account",
    profile_delete_warning_title: "This action is irreversible",
    profile_delete_warning_text: "Your account, simulations, mood history, diary and all associated data will be permanently deleted. This action cannot be undone.",
    profile_delete_password_label: "Enter your password to confirm",
    profile_delete_confirm: "Permanently delete my account",

    // Avatar System
    avatar_setup_title: "Personalise your avatar",
    avatar_setup_subtitle: "Choose a colour for your avatar. It will evolve with you based on your activity and emotional clarity.",
    avatar_setup_save: "Activate my avatar",
    avatar_choose_color: "Choose your colour",
    avatar_state_dormant: "Scattered",
    avatar_state_awakening: "Focused",
    avatar_state_clear: "Precise",
    avatar_state_radiant: "Powerful",
    avatar_widget_title: "Your avatar",
    avatar_clarity_score: "Clarity level",
    avatar_insight_dormant: "Your avatar reflects less recent activity. It might be a good moment for a mindful pause.",
    avatar_insight_awakening: "You are on your way. Keep exploring your emotions and making conscious decisions.",
    avatar_insight_clear: "Your focus is growing. Your decisions and wellbeing are aligned.",
    avatar_insight_radiant: "A moment of great energy. Your avatar reflects your commitment to yourself.",
    avatar_metric_checkins: "Check-ins",
    avatar_metric_consults: "Consults",
    avatar_metric_diary: "Diary",
    avatar_deep_analysis_title: "Deep analysis",
    avatar_deep_analysis_desc: "Unlock advanced insights and emotional patterns with the Avanza plan.",
    avatar_upgrade_cta: "View Avanza plan",
    avatar_deep_insight_title: "Your insight",
    avatar_deep_insight_desc: "Your recent activity shows a positive pattern of self-awareness. Keep it up.",
    avatar_disclaimer: "The avatar is a visual representation of your activity in FUTURA. It does not constitute a clinical diagnosis or replace professional mental health advice.",
    avatar_landing_badge: "Your avatar awaits",
    avatar_landing_title: "Feel clarity. Decide better. Evolve with you.",
    avatar_landing_subtitle: "Your avatar is not a feature. It is the living reflection of how you feel when you start making decisions with clarity.",
    avatar_landing_desc: "It's not about doing more.\nIt's about feeling better while you decide.\n\nYour avatar evolves with you, quietly. No judgement. No pressure.\nJust visible progress.",
    avatar_landing_f1: "Evolves in real time based on your wellbeing",
    avatar_landing_f2: "Make it yours: truly personalise it",
    avatar_landing_f3: "Daily micro-challenges to reconnect with yourself",
    avatar_landing_f4: "Clear insights to understand yourself, without noise",
    avatar_landing_cta: "Start feeling the difference",
    hero_main_title: "Simulate your decisions with AI. Your avatar evolves with you.",
    hero_main_subtitle: "FUTURA analyses every decision that worries you and gives you scenarios, probabilities and real alternatives. While you decide, your avatar reflects your emotional progress.",
    hero_sim_title: "Decision simulation",
    hero_sim_desc: "AI that analyses your everyday decisions",
    hero_sim_example: "\"I'm thinking about changing jobs...\"",
    hero_sim_result_desc: "Analysis with reasons, risks and personalised alternatives",
    hero_sim_risks: "Risks",
    hero_sim_alternatives: "Alternatives",
    hero_sim_footer: "Each simulation analyses your real situation with advanced AI",
    hero_avatar_title: "Your personal avatar",
    hero_avatar_desc: "Reflects your wellbeing while you decide",
    hero_step1_title: "Describe your decision",
    hero_step1_desc: "Tell us what worries you. AI will ask questions to understand your context.",
    hero_step2_title: "Get your analysis",
    hero_step2_desc: "Success probability, reasons, risks and personalised alternatives.",
    hero_step3_title: "Evolve with your avatar",
    hero_step3_desc: "Your avatar reflects your clarity. Daily micro-challenges to reconnect with yourself.",
    avatar_disclaimer: "The avatar is a visual representation of your activity in FUTURA. It does not constitute a clinical diagnosis or replace professional mental health advice.",
    avatar_fullscreen_title: "Your avatar",
    avatar_fullscreen_close: "Close",
    avatar_challenge_title: "Your micro-challenge today",
    avatar_challenge_accept: "I accept the challenge",
    avatar_challenge_done: "Challenge completed",
    avatar_challenge_skip: "Maybe tomorrow",
    avatar_fullscreen_btn: "View large",
    avatar_fullscreen_hint: "Open expanded view of your avatar",
    avatar_widget_hint: "Tap to see your avatar and progress",
    avatar_tap_hint: "Tap your avatar",
    avatar_notif_title: "Notifications",
    avatar_notif_enable: "Enable notifications",
    avatar_notif_enabled: "Notifications active",
    avatar_notif_instructions_title: "Enable notifications",
    avatar_notif_instructions_app: "In the FUTURA app: go to your phone Settings -> Apps -> FUTURA -> Notifications and turn them on. Then come back to the app.",
    avatar_notif_instructions_web: "Notifications are blocked in your browser. To enable them, click the lock icon next to the URL and allow notifications.",
    avatar_notif_instructions_ok: "Got it",
    avatar_notif_desc: "Receive daily micro-challenges from your avatar",
    avatar_ethical_banner: "This tool does not replace professional mental health advice.",
    avatar_level: "Level",
    avatar_level_locked: "Unlock levels with Decide or Avanza",
    avatar_streak: "consecutive days",
    avatar_streak_msg: "Every day counts. Your consistency is reflected in your avatar.",
    streak_recovery_title: "Recover streak",
    streak_recovery_available: "We detected a day without activity. You can recover your streak (1x/month, Decide/Avanza plan).",
    streak_recovery_apply: "Recover my streak",
    streak_recovery_used_month: "You already used your recovery this month. Available again next month.",
    streak_recovery_no_gap: "No streak to recover. Your consistency is intact.",
    avatar_timeline_btn: "Your story",
    avatar_timeline_btn_desc: "See how you have evolved over time",
    timeline_title: "Your timeline",
    timeline_empty: "Your story starts here",
    timeline_empty_hint: "Make a consultation, a check-in or write in your diary to start.",
    timeline_type_consultation: "Simulation",
    timeline_type_mood: "Emotional check-in",
    timeline_type_diary: "Diary",
    timeline_type_challenge: "Micro-challenge completed",
    mood_label: "Mood",
    energy_label: "Energy",
    stress_label: "Stress",
    avatar_checkin_reminder: "Your daily check-in is waiting",
    avatar_weekly_title: "Your week",
    avatar_weekly_no_data: "Start the week by logging how you feel.",
    ach_title: "Your achievements",
    ach_first_checkin: "First check-in",
    ach_streak_3: "3 days in a row",
    ach_streak_7: "7 days in a row",
    ach_streak_30: "30 days in a row",
    ach_checkins_10: "10 check-ins",
    ach_checkins_50: "50 check-ins",
    ach_first_consult: "First simulation",
    ach_consults_10: "10 simulations",
    ach_first_diary: "First diary entry",
    ach_challenges_7: "7 micro-challenges",
    ach_challenges_30: "30 micro-challenges",
    ach_unlocked: "unlocked",
    ach_new: "New achievement",
    avatar_challenge_checkin: "It might be a good time to log how you feel today.",
    avatar_challenge_consult: "If you have a pending decision, today might be a good day to explore it.",
    avatar_challenge_breathe: "3 deep breaths can make a difference. Only if you feel like it.",
    avatar_challenge_gratitude: "Think of something good that happened today. Just a moment for yourself.",
    avatar_challenge_pause: "A 5-minute pause can help you reconnect. You decide when.",
    avatar_challenge_diary: "Writing what you feel can bring clarity. No rush, no pressure.",
    avatar_challenge_walk: "A short walk can change your perspective. Whenever you want.",

    // Interactive Premium Tools
    tool_done: "Done",
    tool_close: "Close",
    tool_breathing_title: "4-7-8 Breathing",
    tool_breathing_subtitle: "Guided technique without sound to calm body and mind",
    tool_breathing_card_desc: "A glowing circle guides your breath. Inhale 4s, hold 7s, exhale 8s.",
    tool_breathing_duration: "2-5 min",
    tool_breathing_ready: "Get ready",
    tool_breathing_inhale: "Inhale",
    tool_breathing_hold: "Hold",
    tool_breathing_exhale: "Exhale",
    tool_breathing_hint: "Follow the circle. The more you practice, the faster calm arrives.",
    tool_breathing_cycles: "cycles completed",
    tool_breathing_start: "Start",
    tool_breathing_stop: "Stop",
    tool_grounding_title: "5-4-3-2-1 Grounding",
    tool_grounding_subtitle: "A sensory technique for overwhelming anxiety",
    tool_grounding_card_desc: "Name 5 things you see, 4 you touch, 3 you hear, 2 you smell, 1 you taste.",
    tool_grounding_duration: "3-5 min",
    tool_grounding_see_title: "things you SEE",
    tool_grounding_see_hint: "Look around and name what you see in detail.",
    tool_grounding_see_placeholder: "Something you see now",
    tool_grounding_touch_title: "things you TOUCH",
    tool_grounding_touch_hint: "Notice textures, temperatures and weights in reach.",
    tool_grounding_touch_placeholder: "Something you can touch",
    tool_grounding_hear_title: "things you HEAR",
    tool_grounding_hear_hint: "Pay attention to sounds, even the subtle ones.",
    tool_grounding_hear_placeholder: "A sound around you",
    tool_grounding_smell_title: "things you SMELL",
    tool_grounding_smell_hint: "Identify nearby or remembered scents.",
    tool_grounding_smell_placeholder: "A scent you detect",
    tool_grounding_taste_title: "thing you TASTE",
    tool_grounding_taste_hint: "Notice the taste in your mouth or the last thing you tasted.",
    tool_grounding_taste_placeholder: "A taste present",
    tool_grounding_next: "Next",
    tool_grounding_finish: "Finish",
    tool_grounding_done_title: "You're here, present",
    tool_grounding_done_msg: "You came back to your body and this moment. Anxiety loses power when you ground yourself.",
    tool_grounding_restart: "Repeat",
    tool_screenbreak_title: "Screen-free Challenge",
    tool_screenbreak_subtitle: "Commit to not using your phone for X minutes",
    tool_screenbreak_card_desc: "Pick a time, put your phone down. If you leave the app, the challenge fails.",
    tool_screenbreak_duration: "5-45 min",
    tool_screenbreak_streak: "Streak",
    tool_screenbreak_total_min: "Screen-free min",
    tool_screenbreak_pick_time: "How long will you commit to rest?",
    tool_screenbreak_min: "min",
    tool_screenbreak_warning: "You can lock your phone — the timer keeps running. But if you switch to another app, the challenge will fail.",
    tool_screenbreak_hint: "You can lock your phone — the timer keeps running. But if you switch to another app, the challenge will fail.",
    tool_screenbreak_rules: "You can lock your phone — the timer keeps running. But if you switch to another app, the challenge will fail.",
    tool_screenbreak_start: "Start challenge",
    tool_screenbreak_remaining: "Remaining",
    tool_screenbreak_keep_here: "Put it face down and do something analog.",
    tool_screenbreak_leave_fails: "Leaving the app will fail the challenge.",
    tool_screenbreak_lock_ok: "It's safe to lock your phone — time keeps counting down.",
    tool_screenbreak_week_min: "min this week",
    tool_screenbreak_cancel: "Cancel challenge",
    tool_screenbreak_success_title: "You did it!",
    tool_screenbreak_success_msg: "You rested {minutes} screen-free minutes. Your brain thanks you.",
    tool_screenbreak_again: "Another challenge",
    tool_screenbreak_fail_title: "Digital break not achieved",
    tool_screenbreak_fail_msg: "You left the app or cancelled too soon. No pressure — try again when you're ready.",
    tool_screenbreak_retry: "Try again",

  },

  de: {
    nav_features: "Funktionen",
    nav_how_it_works: "So funktioniert's",
    nav_pricing: "Pläne",
    nav_login: "Anmelden",
    nav_login_short: "Login",
    nav_register: "Jetzt starten",
    nav_register_short: "Start",
    nav_history: "Verlauf",
    nav_improve: "Upgrade",
    nav_compare: "Vergleichen",
    nav_back: "Zurueck",
    nav_plans: "Pläne",

    landing_badge: "Dein intelligenter Ratgeber für bessere Entscheidungen",
    landing_h1_1: "Hoer auf zu zweifeln, ",
    landing_h1_2: "triff sichere Entscheidungen",
    landing_p: "Mit FUTURA ist es einfacher, wichtige und alltaegliche Entscheidungen mit KI zu loesen, und du kannst entdecken, wie deine Emotionen jede Wahl beeinflussen. Entscheide und gehe voran.",
    landing_cta: "Jetzt starten",
    landing_cta_plans: "Pläne ansehen",
    landing_cta_plans_hint: "ab 5,99 €/Monat",
    landing_trust_free: "Kostenlos, ohne Karte",
    landing_trust_cancel: "Jederzeit kuendbar",
    landing_trust_secure: "Sichere Zahlung · Stripe",
    landing_social_proof: "+2.500 simulierte Entscheidungen",
    landing_social_sub: "In den letzten 30 Tagen",

    features_title: "Alles was du brauchst, um klarer zu entscheiden",
    features_subtitle: "Praktische KI-Orientierung für deinen Alltag, ergaenzt durch emotionale Wohlbefinden-Tools",
    feat_ai: "KI-Orientierung",
    feat_ai_desc: "Erhalte kontextualisierte und personalisierte Empfehlungen für deine alltäglichen Entscheidungen",
    feat_prob: "Klare Empfehlungen",
    feat_prob_desc: "Visualisiere Szenarien und Wahrscheinlichkeiten basierend auf deiner spezifischen Situation",
    feat_risk: "Kontext und Risiken",
    feat_risk_desc: "Identifiziere moegliche Hindernisse und Schluesselfaktoren vor jeder Entscheidung",
    feat_time: "Emotionale Klarheit",
    feat_time_desc: "Verstehe, wie deine Energie, Stress oder emotionaler Zustand deine täglichen Entscheidungen beeinflussen",
    feat_rec: "Personalisierte Einblicke",
    feat_rec_desc: "Erhalte Beobachtungen basierend auf deinen Mustern für bewusstere Entscheidungen",
    feat_impact: "Ergaenzendes Wohlbefinden",
    feat_impact_desc: "Geführte Tools und praktische Ressourcen für mehr Balance in deinem Alltag",

    how_title: "So funktioniert's",
    how_subtitle: "In drei Schritten erhaeltst du praktische Orientierung und Klarheit",
    how_step1_title: "Stelle deine Entscheidung",
    how_step1_desc: "Erhalte praktische, kontextuelle Hilfe für alltägliche Entscheidungen.",
    how_step2_title: "Erhalte eine smarte Empfehlung",
    how_step2_desc: "FUTURA analysiert deinen Kontext und bietet nuetzliche, schnelle und personalisierte Orientierung.",
    how_step3_title: "Entscheide mit mehr Klarheit",
    how_step3_desc: "Mit dem emotionalen Tracking verstehst du auch, wie dein Zustand deine Entscheidungen beeinflusst.",

    dm_title: "Entscheide besser - innerlich und aeusserlich",
    dm_subtitle: "Deine Entscheidungen haengen nicht nur vom Kontext ab. Sie haengen auch davon ab, wie du dich fühlst. FUTURA vereint praktische Orientierung + emotionale Klarheit.",
    dm_card1_title: "Alltägliche Entscheidungen mit KI",
    dm_card1_desc: "Die Essenz von FUTURA: praktische Hilfe für reale Alltagsentscheidungen mit mehr Kontext und weniger mentalem Rauschen.",
    dm_card1_b1: "Kontextualisierte Empfehlungen",
    dm_card1_b2: "Alltags-Simulationen",
    dm_card1_b3: "Praktische und sofortige Hilfe",
    dm_card1_b4: "Weniger Überdenken",
    dm_card1_b5: "Mehr Klarheit beim Waehlen",
    dm_card2_title: "Ergaenzende emotionale Klarheit",
    dm_card2_desc: "Eine nicht-klinische emotionale Tracking-Ebene, die dir hilft zu verstehen, wie dein Zustand deine Entscheidungen beeinflusst.",
    dm_card2_b1: "Tägliche Check-ins",
    dm_card2_b2: "Persönliche Muster",
    dm_card2_b3: "Orientierende Einblicke",
    dm_card2_b4: "Mehr Selbsterkenntnis",
    dm_card2_b5: "Bewusstere Entscheidungen",

    trust_title: "Entwickelt, um dir mit Klarheit und Verantwortung zu helfen",
    trust1_title: "Alltägliche Entscheidungen, praktische Orientierung",
    trust1_desc: "FUTURA hilft dir bei Alltagsentscheidungen und bietet nicht-klinische, orientierende emotionale Wohlbefinden-Tools.",
    trust2_title: "Orientierende und transparente KI",
    trust2_desc: "Empfehlungen und Einblicke bieten Klarheit, Kontext und Selbsterkenntnis - kein Ersatz für professionelle Bewertung.",
    trust3_title: "Verantwortungsvolle Nutzung",
    trust3_desc: "Bei spezialisiertem Bedarf empfehlen wir immer einen qualifizierten Fachmann. FUTURA ist eine Ergaenzung, kein Ersatz.",

    cta_title: "Bereit für bessere Entscheidungen?",
    cta_subtitle: "Teste FUTURA kostenlos und entdecke, wie KI dir helfen kann, jeden Tag klarer zu entscheiden.",
    cta_button: "Jetzt starten",

    mod_badge: "Entdecke was FUTURA bietet",
    mod_title: "Mehr als Entscheidungen: dein Wohlbefinden zählt auch",
    mod_subtitle: "FUTURA geht über Entscheidungen hinaus. Es integriert emotionale Wohlbefinden-Tools für klarere Entscheidungen und ein besseres tägliches Leben.",
    mod1_tag: "Modul 1",
    mod1_name: "Interaktive Tools",
    mod1_desc: "3 visuelle Tools, die dich unterstützen, wenn du sie am meisten brauchst: geführte Atmung, 5-4-3-2-1 Grounding und Bildschirmpausen-Challenges.",
    mod1_f1: "Visuelle 4-7-8-Atmung",
    mod1_f2: "5-4-3-2-1 Grounding",
    mod1_f3: "Digitale Pausen-Challenge",
    mod1_f4: "Komplett ohne Audio",
    mod1_plans: "Verfügbar in den Plänen Decide und Avanza",
    mod2_tag: "Modul 2",
    mod2_name: "Intelligentes emotionales Tracking",
    mod2_desc: "Erfasse deinen täglichen emotionalen Zustand, entdecke Muster und nutze dein persönliches KI-Tagebuch als empathischen Begleiter.",
    mod2_f1: "Täglicher emotionaler Check-in",
    mod2_f2: "Wochendiagramme und KI-Einblicke",
    mod2_f3: "Persönliches KI-Tagebuch",
    mod2_f4: "Emotionale Muster und Zusammenfassung",
    mod2_plans: "Exklusiv im Avanza-Plan",


    footer_terms: "Allgemeine Geschaeftsbedingungen",
    footer_privacy: "Datenschutzrichtlinie",
    footer_support: "Support",
    footer_rights: "2026 FUTURA. Alle Rechte vorbehalten.",
    webview_sub_managed: "Abonnements werden über die Website verwaltet",
    webview_limit_modal: "Du hast das kostenlose Tageslimit erreicht. Komm morgen wieder oder schalte unbegrenzten Zugang über unsere Website in deinem Browser frei.",
    webview_limit_accept: "Akzeptieren",
    footer_disclaimer: "FUTURA ist eine Plattform für alltägliche Entscheidungshilfe und nicht-klinische emotionale Wohlbefinden-Begleitung. Sie bietet keine klinische Diagnose, psychologische Behandlung oder Notfallversorgung. Bei spezialisiertem Bedarf empfehlen wir einen qualifizierten Fachmann.",

    login_title: "Willkommen zurueck",
    login_subtitle: "Gib deine Zugangsdaten ein",
    login_email: "E-Mail",
    login_password: "Passwort",
    login_submit: "Anmelden",
    login_remember_me: "Meine Daten merken",
    login_or: "oder weiter mit",
    login_no_account: "Noch kein Konto?",
    login_register_link: "Kostenlos registrieren",
    login_forgot_password: "Passwort vergessen?",
    login_right_title: "Intelligentere Entscheidungen",
    login_right_subtitle: "Praktische KI-Orientierung für deinen Alltag, ergaenzt mit emotionaler Klarheit",

    register_title: "Erstelle dein Konto",
    register_subtitle: "Beginne heute, klarer zu entscheiden",
    register_name: "Name",
    register_name_placeholder: "Dein Name",
    register_email: "E-Mail",
    register_password: "Passwort",
    register_password_placeholder: "Mindestens 6 Zeichen",
    register_submit: "Konto erstellen",
    register_or: "oder registriere dich mit",
    register_has_account: "Bereits ein Konto?",
    register_login_link: "Anmelden",
    register_right_title: "Deine erste Beratung ist kostenlos",
    register_right_subtitle: "Entdecke, wie KI dir helfen kann, bessere Entscheidungen zu treffen",
    register_password_error: "Passwort muss mindestens 6 Zeichen haben",
    register_password_alphanumeric: "Passwort darf nur Buchstaben und Zahlen enthalten (keine Symbole oder Leerzeichen)",
    register_password_hint: "Nur Buchstaben und Zahlen. Mindestens 6 Zeichen.",
    register_security_question: "Sicherheitsfrage",
    register_select_question: "Waehle eine Frage",
    register_security_answer: "Geheime Antwort",
    register_security_answer_placeholder: "Deine Antwort (kann nicht geaendert werden)",
    register_security_required: "Du musst eine Frage waehlen und deine geheime Antwort schreiben",
    register_security_warning: "Merke dir diese Antwort. Sie ist die einzige Moeglichkeit, dein Konto wiederherzustellen.",

    // Forgot Password
    login_forgot_password: "Passwort vergessen?",
    forgot_title: "Konto wiederherstellen",
    forgot_subtitle_email: "Gib deine E-Mail ein und wir senden dir einen Link zum Zuruecksetzen deines Passworts.",
    forgot_email_label: "E-Mail",
    forgot_send_link: "Link senden",
    forgot_sent_title: "E-Mail gesendet!",
    forgot_sent_text: "Wir haben einen Link zum Zuruecksetzen an:",
    forgot_sent_check_spam: "Pruefe deinen Spam-Ordner, falls du es nicht findest.",
    forgot_min_password: "Passwort muss mindestens 6 Zeichen haben",
    forgot_passwords_mismatch: "Passwoerter stimmen nicht ueberein",
    forgot_confirm_password: "Passwort bestaetigen",
    reset_title: "Neues Passwort",
    reset_subtitle: "Waehle ein sicheres Passwort mit mindestens 6 Zeichen.",
    reset_new_password: "Neues Passwort",
    reset_new_placeholder: "Mindestens 6 Zeichen",
    reset_confirm_password: "Passwort bestaetigen",
    reset_confirm_placeholder: "Passwort wiederholen",
    reset_btn: "Passwort aendern",
    reset_done_title: "Passwort aktualisiert!",
    reset_done_subtitle: "Dein Passwort wurde erfolgreich geaendert. Du kannst dich jetzt anmelden.",
    reset_go_login: "Anmelden",
    reset_invalid_link: "Ungueltiger Link",
    reset_invalid_desc: "Dieser Wiederherstellungslink ist ungueltig oder abgelaufen.",
    reset_request_new: "Neuen Link anfordern",
    verify_title: "E-Mail verifizieren",
    verify_subtitle: "Wir haben einen Bestaetigungscode gesendet an:",
    verify_code_label: "Bestaetigungscode",
    verify_btn: "Verifizieren",
    verify_resend: "Code erneut senden",
    verify_resent: "Code erfolgreich erneut gesendet",
    verify_back_login: "Zurueck zum Login",
    register_gdpr_required: "Du musst die AGB und Datenschutzerklaerung akzeptieren",
    register_gdpr_text: "Ich akzeptiere die",
    register_gdpr_terms: "AGB",
    register_gdpr_and: "und die",
    register_gdpr_privacy: "Datenschutzerklaerung",
    sq_pet: "Wie heisst dein erstes Haustier?",
    sq_city: "In welcher Stadt wurdest du geboren?",
    sq_teacher: "Wie heisst dein Lieblingslehrer?",
    sq_food: "Was ist dein Lieblingsessen?",
    sq_friend: "Wie heisst dein bester Kindheitsfreund?",
    profile_security_title: "Sicherheitsfrage",
    profile_security_set: "Konfiguriert",
    profile_security_not_set: "Nicht konfiguriert",
    profile_security_btn: "Sicherheitsfrage einrichten",
    profile_security_update: "Frage aktualisieren",
    profile_security_save: "Speichern",
    security_prompt_subtitle: "Richte deine Frage ein, um dein Konto wiederherstellen zu koennen",
    profile_email: "E-Mail",
    profile_auth_method: "Zugangsart",
    profile_auth_email: "E-Mail und Passwort",
    profile_plan: "Aktueller Plan",
    profile_upgrade: "Plan upgraden",
    profile_member_since: "Mitglied seit",
    profile_change_password: "Passwort aendern",
    profile_change_password_sub: "Aktualisiere dein Zugangspasswort",
    profile_current_password: "Aktuelles Passwort",
    profile_pw_min: "Neues Passwort muss mindestens 6 Zeichen haben",
    profile_pw_success: "Passwort erfolgreich aktualisiert",
    profile_save_password: "Neues Passwort speichern",
    profile_manage_subscription: "Abonnement verwalten",
    profile_cancel_warning: "Wenn du dein Abo kuendigst, verlierst du am Ende des aktuellen Zeitraums den Zugang zu Premium-Funktionen. Dein Plan wird auf Descubre (kostenlos) zurueckgesetzt.",
    profile_cancel_confirm_label: "Schreibe CANCELAR zur Bestaetigung",
    profile_cancel_button: "Abonnement kuendigen",
    pricing_cancel_anytime: "Jederzeit kuendbar",

    consulta_h1_1: "Welche Entscheidung musst du",
    consulta_h1_2: "heute treffen?",
    consulta_subtitle: "Ich stelle dir Fragen, um deine Situation zu verstehen und die beste Empfehlung zu geben.",
    consulta_placeholder: "Beschreibe dein Dilemma oder deine Entscheidung...",
    consulta_start: "Starten",
    consulta_examples_title: "Beispielfragen",
    consulta_question_of: "Frage {current} von {total}",
    consulta_answer_placeholder: "Schreibe deine Antwort...",
    consulta_generating: "Perfekt! Erstelle deine personalisierte Analyse...",
    consulta_analyzing: "Analysiere deine Situation...",
    consulta_loading_estimate: "Wir verarbeiten deine Simulation, dies kann bis zu 1 Minute dauern.",
    consulta_loading_phrase_1: "Deine Simulation läuft, das kann einige Sekunden dauern.",
    consulta_loading_phrase_2: "Betrachte Szenarien, Risiken und Chancen...",
    consulta_loading_phrase_3: "Überprüfe deine emotionalen und rationalen Signale.",
    consulta_loading_phrase_4: "Wir suchen nach dem, was dir wirklich wichtig ist.",
    consulta_loading_phrase_5: "Fast fertig. Es ist das Warten wert.",
    consulta_footer: "FUTURA bietet praktische und ergaenzende Orientierung für deine Alltagsentscheidungen. Kein Ersatz für professionelle Beratung.",

    example_q1: "Soll ich den Job wechseln?",
    example_q2: "Kaufen oder sparen?",
    example_q3: "Soll ich umziehen?",
    example_q4: "Was soll ich heute anziehen?",
    example_q5: "Investieren oder warten?",
    example_q6: "Dies oder das studieren?",

    result_analysis_title: "Analyse deiner Entscheidung",
    result_success: "Erfolgswahrscheinlichkeit",
    result_recommendation_level: "Empfehlungsniveau",
    result_stress: "Stressniveau",
    result_happiness: "Wohlbefinden",
    result_recommendation: "EMPFEHLUNG",
    result_why: "Warum diese Empfehlung?",
    result_motives: "GRUENDE",
    result_risks: "ZU BEACHTEN",
    result_alternative: "ALTERNATIVE",
    result_top3: "TOP 3 EMPFOHLENE WEGE",
    result_confidence: "Vertrauen",
    result_risk: "Risiko",
    result_action_plan: "AKTIONSPLAN",
    result_premium_summary: "PREMIUM-ZUSAMMENFASSUNG",
    result_premium_tag: "PREMIUM",
    result_upsell: "Mehr gewuenscht? Mit dem",
    result_upsell_features: "Top 3 Wege - Aktionsplan - Premium-Zusammenfassung - Vergleicher",
    result_upsell_btn: "Avanza-Plan ansehen",
    result_new_consultation: "Neue Beratung",
    result_limit_reached: "Limit erreicht. Upgrade deinen Plan.",
    result_view_plans: "Pläne ansehen",

    history_title: "Beratungsverlauf",
    history_subtitle: "Alle vergangenen Beratungen",
    history_compare_btn: "Szenarien vergleichen",
    history_search: "Beratungen suchen...",
    history_no_results: "Keine Ergebnisse",
    history_no_consultations: "Noch keine Beratungen",
    history_no_results_hint: "Versuche andere Suchbegriffe",
    history_no_consultations_hint: "Starte deine erste Beratung",
    history_first_btn: "Erste Beratung starten",
    history_motives: "Gruende",
    history_risks: "Aspekte",
    history_alternative: "Alternative",
    history_reasons: "Gruende",
    history_identified: "identifiziert",
    history_delete_title: "Beratung loeschen",
    history_delete_confirm: "Bist du sicher, dass du diese Beratung loeschen moechtest? Diese Aktion kann nicht rueckgaengig gemacht werden.",
    history_delete_cancel: "Abbrechen",
    history_delete_yes: "Loeschen",

    pricing_title: "Waehle deinen Plan",
    pricing_subtitle: "Bessere Entscheidungen, mehr Klarheit. Waehle den passenden Plan.",
    pricing_monthly: "Monatlich",
    pricing_annual: "Jaehrlich",
    pricing_forever: "für immer",
    pricing_month: "/Monat",
    pricing_year: "/Jahr",
    pricing_your_plan: "Dein aktueller Plan",
    pricing_free: "Kostenlos",
    pricing_subscribe: "Plan waehlen",
    pricing_secure: "Sichere Zahlungen über Stripe. Jederzeit kuendbar.",
    pricing_cancel: "Abo kuendigen",
    pricing_cancel_confirm: "Sicher? Du kehrst zum Descubre-Plan zurueck.",

    plan_descubre: "Descubre",
    plan_descubre_badge: "Kostenlos",
    plan_descubre_desc: "Ein erster Blick auf das, was FUTURA fuer dich tun kann",
    plan_decide: "Decide",
    plan_decide_badge: "Beliebt",
    plan_decide_desc: "Hoer auf zu zweifeln. Lebe mit mehr Klarheit und Vertrauen in jede Entscheidung.",
    plan_avanza: "Avanza",
    plan_avanza_badge: "Transformativ",
    plan_avanza_desc: "Spuere den Unterschied, jede Entscheidung mit voller Klarheit zu treffen, deine Emotionen zu verstehen und mit einem massgeschneiderten Aktionsplan. Ein einzigartiges Erlebnis, das dein Leben veraendert.",
    plan_saves: "Du sparst",
    plan_per_month: "/Monat",
    plan_start_free: "Kostenlos starten",
    plan_choose_decide: "Decide waehlen",
    plan_choose_avanza: "Avanza waehlen",
    pricing_popular: "Am beliebtesten",
    pricing_annual_hint: "Jahresplaene mit Rabatt verfuegbar — sichere Zahlung ueber Stripe. Jederzeit kuendbar.",
    plan_descubre_feat1: "1 Simulation pro Tag",
    plan_descubre_feat2: "Taeglicher emotionaler Check-in",
    plan_descubre_feat3: "Anpassbarer Avatar",
    plan_decide_feat1: "50 Simulationen pro Monat",
    plan_decide_feat2: "Vollstaendiger Entscheidungsverlauf",
    plan_decide_feat3: "Avatar-Level (1-10) und Erfolge",
    plan_decide_feat4: "Serie einmal pro Monat wiederherstellen",
    plan_avanza_feat1: "Unbegrenzte Simulationen",
    plan_avanza_feat2: "Persoenliches KI-Tagebuch + Premium-Bericht",
    plan_avanza_feat3: "Erweiterter Entscheidungsvergleich",
    plan_avanza_feat4: "Alles aus Decide inklusive",
    plan_intent_banner: "Du bist nur einen Schritt von {plan} fuer {price}/Monat entfernt. Schliesse dein Abo ab, wann du willst.",
    plan_intent_continue: "Aktivieren",
    plan_intent_dismiss: "Schliessen",
    plan_saves: "Du sparst",

    plan_descubre_emotion: "Kostenlos testen, ohne Verpflichtung",
    plan_decide_emotion: "Die Klarheit, die du verdienst, jeden Tag",
    plan_decide_hook: "Stell dir vor, 50 Entscheidungen im Monat zu treffen und zu wissen, dass jede gruendlich analysiert wurde. Keine schlaflosen Naechte mehr. Keine laehmenden Zweifel mehr.",
    plan_avanza_emotion: "Transformiere dein Leben von innen",
    plan_avanza_hook: "Unbegrenzte Entscheidungen + dein persoenliches KI-Tagebuch. Weil die besten Entscheidungen entstehen, wenn du verstehst, was du fuehlst.",

    pf_1sim: "1 Simulation pro Tag",
    pf_ai_rec: "Grundlegende orientierende Empfehlung",
    pf_basic_motives: "Vereinfachte allgemeine Analyse",
    pf_50sim: "50 Simulationen pro Monat",
    pf_5sim: "5 Simulationen pro Monat",
    pf_detailed_motives: "Tiefgreifende Analyse mit persoenlichem Kontext",
    pf_full_history: "Vollstaendiger Entscheidungsverlauf",
    pf_emotional_tracking: "Intelligentes Emotionales Tracking",
    pf_checkin: "Taeglicher emotionaler Check-in",
    pf_mood_tracker: "Intelligenter Mood-Tracker",
    pf_journal: "Gefuehrtes emotionales Tagebuch",
    pf_energy_log: "Energie-, Ruhe- und Stressprotokoll",
    pf_weekly_charts: "Woechentliche Wohlbefinden-Grafiken",
    pf_ai_insights: "Personalisierte KI-Einblicke",
    pf_patterns: "Zusammenfassung emotionaler Muster",
    pf_smart_ai: "Fortgeschrittene KI, die deinen realen Kontext versteht",
    pf_unlimited: "Unbegrenzte Simulationen",
    pf_premium_ai: "Premium-KI: tiefgreifende, empathische und transformative Analyse",
    pf_pdf: "Ergebnisse als PDF",
    pf_comparator: "Szenariovergleicher",
    pf_premium_report: "Premium-Bericht",
    pf_top3: "Top 3 empfohlene Wege",
    pf_confidence: "Vertrauens-/Risikoniveau",
    pf_action: "Personalisierter Schritt-fuer-Schritt-Aktionsplan",
    pf_library: "Premium-Wohlbefinden-Bibliothek",
    pf_audio_guides: "Visuelle 4-7-8-Atemuebung",
    pf_programs: "Strukturierte 7/14/21-Tage-Programme",
    pf_routines: "5-4-3-2-1 Grounding gegen Angst",
    pf_smart_recs: "Bildschirm-Pause-Challenge mit Tracking",
    pf_regulation: "Praktische emotionale Regulierungstools",
    pf_diary_ai_desc: "Dein persoenliches KI-Tagebuch: schreibe, sprich und verstehe deine Emotionen",

    pmiss_history: "Vollstaendiger Verlauf",
    pmiss_pdf: "PDF-Download",
    pmiss_comparator: "Szenariovergleicher",
    pmiss_premium: "Premium-Bericht",
    pmiss_emotional: "Emotionales Tracking",
    pmiss_library: "Premium-Interaktive Tools",
    pmiss_diary_ai: "Persoenliches KI-Tagebuch",
    pmiss_smart_ai: "Fortgeschrittene KI",

    sim_counter_daily: "Heute",
    sim_counter_monthly: "Diesen Monat",
    sim_counter_unlimited: "Unbegrenzt",
    sim_counter_available: "verfuegbar",
    sim_counter_available_pl: "verfuegbar",
    sim_counter_next_reset: "Erneuert sich",
    sim_counter_next_reset_in: "in",
    sim_counter_hours: "h",
    sim_counter_upgrade: "Mehr Simulationen freischalten",

    landing_diary_badge: "Exklusiv im Avanza-Plan",
    landing_diary_title: "Dein KI-Tagebuch: wo alles anfaengt, Sinn zu ergeben",
    landing_diary_subtitle: "Schreibe, was du fuehlst, sprich per Stimme, und lass die KI dir helfen, dich selbst zu verstehen.",
    landing_diary_f1: "Schreibe oder sprich: druecke deine Emotionen aus",
    landing_diary_f2: "Die KI erkennt deine Muster und hilft dir, sie zu sehen",
    landing_diary_f3: "Krisenanalyse: wenn es dir schlecht geht, erkennt FUTURA es",
    landing_diary_f4: "Deine emotionale Entwicklung Woche fuer Woche sichtbar",
    landing_diary_cta: "Ich will mein KI-Tagebuch",

    comp_title: "Szenariovergleicher",
    comp_subtitle: "Waehle 2 bis 4 Beratungen",
    comp_gate_title: "Szenariovergleicher",
    comp_gate_desc: "Verfügbar im Avanza-Plan",
    comp_gate_btn: "Avanza-Plan ansehen",
    comp_no_consultations: "Keine Beratungen zum Vergleichen.",
    comp_compare_btn: "Vergleiche {count} Beratungen",
    comp_best: "Beste Option",
    comp_new: "Neuer Vergleich",
    comp_success: "Erfolg",
    comp_recommendation: "Empfehlung",
    comp_stress: "Stress",
    comp_happiness: "Wohlbefinden",
    comp_rec_label: "Empfehlung",

    pay_checking: "Zahlung wird überprueft...",
    pay_checking_sub: "Bitte warten",
    pay_attempt: "Versuch {n} von 5",
    pay_success: "Zahlung erfolgreich!",
    pay_go_dashboard: "Zum Dashboard",
    pay_error: "Zahlungsfehler",
    pay_retry: "Erneut versuchen",
    pay_back_dashboard: "Zurueck zum Dashboard",
    pay_no_session: "Keine Zahlungsinformationen",
    pay_timeout: "Zahlung konnte nicht verifiziert werden. Kontaktiere den Support.",
    pay_expired: "Zahlungssitzung abgelaufen.",

    dash_hello: "Hallo",
    dash_what: "Welche Entscheidung möchtest du heute loesen?",
    dash_simulations: "Simulationen",
    dash_used_month: "diesen Monat",
    dash_decisions: "Entscheidungen",
    dash_in_history: "im Verlauf",
    dash_plan: "Plan",
    dash_upgrade: "Plan upgraden",
    dash_new_sim: "Neue Beratung",
    dash_new_sim_desc: "Beschreibe deine Entscheidung und erhalte praktische Orientierung",
    dash_create_sim: "Beratung erstellen",
    dash_limit: "Limit erreicht. Upgrade deinen Plan.",
    dash_recent: "Letzte Beratungen",
    dash_view_all: "Alle ansehen",
    dash_completed: "Abgeschlossen",
    dash_pending: "Ausstehend",
    dash_no_decisions: "Noch keine Beratungen",
    dash_no_decisions_hint: "Erstelle deine erste Beratung",
    dash_first_sim: "Erste Beratung erstellen",
    dash_used_today: "heute genutzt",
    dash_unlimited: "unbegrenzte Simulationen",
    dash_resets: "Erneuert sich:",
    dash_limit_reached: "Du hast dein Beratungslimit erreicht. Upgrade deinen Plan.",
    dash_question: "Welche Entscheidung moechtest du heute simulieren?",
    dash_history: "Verlauf",
    dash_plans: "Plaene",
    dash_wellbeing: "Wohlbefinden",
    dash_library: "Tools",
    dash_emotional_tracking: "Emotionales Tracking",
    dash_emotional_desc: "Verfolge deine Stimmung und erhalte Einblicke",
    dash_premium_library: "Interaktive Tools",
    dash_premium_desc: "Atmung, Grounding und digitale Pause",
    dash_screenbreak_label: "Digitale Pause",
    dash_screenbreak_min_week: "bildschirmfreie Min diese Woche",

    loading: "Wird geladen...",
    lang_es: "Español",
    lang_en: "English",
    lang_de: "Deutsch",
    lang_it: "Italiano",

    nav_wellbeing: "Wohlbefinden",
    nav_library: "Bibliothek",
    nav_diary: "KI-Tagebuch",
    nav_profile: "Profil",
    nav_logout: "Abmelden",
    pricing_module1_title: "Modul 1: Interaktive Tools",
    pricing_module2_title: "Modul 2: Emotionales Tracking",
    pf_favorites: "Lieblingsberatungen speichern",
    pf_diary_ai: "Persoenliches KI-Tagebuch",

    mood_title: "Emotionales Tracking",
    mood_subtitle: "Erfasse wie du dich fühlst und entdecke wie dein Zustand deine Entscheidungen beeinflusst",
    mood_checkin_title: "Heutiger Check-in",
    mood_checkin_sub: "Wie fühlst du dich gerade?",
    mood_today_done: "Check-in abgeschlossen",
    mood_today_done_sub: "Du hast deinen heutigen Zustand bereits erfasst. Komm morgen wieder.",
    mood_label: "Stimmung",
    energy_label: "Energie",
    stress_label: "Stress",
    mood_1: "Sehr niedrig",
    mood_2: "Niedrig",
    mood_3: "Normal",
    mood_4: "Gut",
    mood_5: "Sehr gut",
    energy_1: "Erschöpft",
    energy_2: "Müde",
    energy_3: "Normal",
    energy_4: "Aktiv",
    energy_5: "Voller Energie",
    stress_1: "Sehr entspannt",
    stress_2: "Ruhig",
    stress_3: "Normal",
    stress_4: "Gestrésst",
    stress_5: "Sehr gestrésst",
    mood_note_placeholder: "Optionale Notiz: Möchtest du etwas festhalten?",
    mood_save: "Check-in speichern",
    mood_weekly_title: "Letzte 7 Tage",
    mood_averages_title: "Wochendurchschnitte",
    mood_checkins_count: "Check-ins diese Woche",
    mood_insight_title: "Personalisierter Einblick",
    mood_insight_loading: "Wochenzusammenfassung wird berechnet...",
    mood_empty: "Mache deinen ersten Check-in um deine emotionalen Muster zu sehen",
    mood_history_title: "Letzte Eintraege",
    mood_disclaimer: "FUTURAs emotionales Tracking ist orientierend und nicht klinisch. Es ersetzt keine professionelle Betreuung.",
    mood_gate_title: "Emotionales Tracking",
    mood_gate_desc: "Diese Funktion ist im Avanza-Plan verfügbar",
    mood_gate_btn: "Avanza-Plan ansehen",

    diary_title: "KI-Tagebuch",
    diary_empty_title: "Dein sicherer Raum",
    diary_empty_desc: "Schreibe, wie du dich heute fühlst. Ich bin hier, um zuzuhören, ohne Urteil.",
    diary_placeholder: "Wie fühlst du dich heute?",
    diary_recording: "Aufnahme...",
    diary_stop: "Stopp",
    diary_transcribing: "Audio wird transkribiert...",
    diary_voice_transcribed: "Aus Audio transkribiert",
    diary_weekly_summary: "Wochenzusammenfassung",
    diary_challenge_label: "Vorgeschlagene Mini-Herausforderung",
    diary_gate_title: "KI-Tagebuch",
    diary_gate_desc: "Greife auf dein KI-Emotionstagebuch mit dem Avanza-Plan zu",
    diary_gate_btn: "Avanza-Plan ansehen",

    lib_title: "Interaktive Tools",
    lib_subtitle: "3 visuelle Tools zum Entspannen, Erden und Bildschirmpause machen",
    lib_tab_programs: "Programme",
    lib_tab_audios: "Geführte Audios",
    lib_tab_routines: "Routinen",
    lib_audio_intro: "Druecke Play, um die KI-generierten gefuehrten Audios zu hoeren. Die erste Wiedergabe kann einige Sekunden dauern.",
    lib_days: "Tage",
    lib_sessions: "Sitzungen",
    lib_steps: "Schritte",
    lib_prog_stress7_title: "Stressabbau in 7 Tagen",
    lib_prog_stress7_desc: "Ein tägliches Programm mit praktischen Atemübungen, aktiven Pausen und Reflexión.",
    lib_prog_energy14_title: "Energie in 14 Tagen",
    lib_prog_energy14_desc: "Progressive Aktivitäten zur Verbesserung deines Energielevels.",
    lib_prog_balance21_title: "21 Tage persönliche Balance",
    lib_prog_balance21_desc: "Eine komplette Reise mit Wohlbefinden, Selbstfürsorge und emotionaler Regulation.",
    lib_prog_sleep7_title: "Besserer Schlaf in 7 Tagen",
    lib_prog_sleep7_desc: "Techniken und Abendroutinen für erholsameren Schlaf.",
    lib_audio_breathing_title: "Geführte Atmung",
    lib_audio_breathing_desc: "4-7-8 Atemtechnik für sofortige Ruhe",
    lib_audio_relax_title: "Tiefe Entspannung",
    lib_audio_relax_desc: "Progressive Muskelentspannung",
    lib_audio_focus_title: "Fokus und Konzentration",
    lib_audio_focus_desc: "Geführte Meditation für bessere Aufmerksamkeit",
    lib_audio_sleep_title: "Schlafvorbereitung",
    lib_audio_sleep_desc: "Geführte Visualisierung für erholsame Ruhe",
    lib_audio_morning_title: "Energisch aufwachen",
    lib_audio_morning_desc: "Morgendliche Aktivierungsroutine",
    lib_audio_pause_title: "Schnelle Pause",
    lib_audio_pause_desc: "Express-Mentalauszeit für angespannte Momente",
    lib_audio_coming_soon: "Neue geführte Audios bald verfügbar",
    lib_routine_morning_title: "Morgenroutine für Wohlbefinden",
    lib_routine_morning_desc: "Starte den Tag mit mehr Klarheit: Hydration, Atmung, Tagesabsicht und sanfte Bewegung.",
    lib_routine_stress_title: "Anti-Stress-Routine",
    lib_routine_stress_desc: "Bei Anspannung: Tiefatmung, Dehnung, digitale Pause und Dankbarkeitsnotiz.",
    lib_routine_night_title: "Abendroutine",
    lib_routine_night_desc: "Bereite Körper und Geist auf den Schlaf vor: keine Bildschirme, Atmung, Tagesreflexión.",
    lib_disclaimer: "Die Tools sind orientierend und ersetzen keine professionelle Betreuung.",
    lib_gate_title: "Interaktive Tools",
    lib_gate_desc: "Geführte Atmung, Grounding und Bildschirmpausen in den Plänen Decide oder Avanza",
    lib_audio_error: "Fehler beim Laden. Erneut tippen.",
    lib_gate_btn: "Pläne ansehen",
    lib_back_to_list: "Zurück",
    lib_day: "Tag",
    lib_step: "Schritt",
    lib_start_audio: "Geführtes Audio anhören",
    lib_program_intro: "Folge jeder Sitzung der Reihe nach für die besten Ergebnisse. Jeder Tag enthält ein geführtes Audio.",
    lib_routine_intro: "Folge jedem Schritt der Reihe nach. Nimm dir Zeit.",
    lib_duration_min: "Min",
    lib_prog_stress7_d1: "Tiefatmung 4-7-8",
    lib_prog_stress7_d2: "Körperspannung scannen",
    lib_prog_stress7_d3: "Aktive Pause und Dehnung",
    lib_prog_stress7_d4: "Schnelles Emotionstagebuch",
    lib_prog_stress7_d5: "Fokusmeditation",
    lib_prog_stress7_d6: "Geführte digitale Pause",
    lib_prog_stress7_d7: "Wochenrückblick und Abschluss",
    lib_prog_energy14_d1: "Mit Intention aufwachen",
    lib_prog_energy14_d2: "Sanfte Morgenbewegung",
    lib_prog_energy14_d3: "Bewusstes Trinken und Ernährung",
    lib_prog_energy14_d4: "Aktive Pausen am Tag",
    lib_prog_energy14_d5: "Energieatmung",
    lib_prog_energy14_d6: "Bewusster Mittagsschlaf",
    lib_prog_energy14_d7: "Erste Woche Rückblick",
    lib_prog_energy14_d8: "Schlafroutine aufbauen",
    lib_prog_energy14_d9: "Morgendliche Dankbarkeit",
    lib_prog_energy14_d10: "Emotionale Energieverwaltung",
    lib_prog_energy14_d11: "Körper-Geist-Aktivierung",
    lib_prog_energy14_d12: "Naturverbindung",
    lib_prog_energy14_d13: "Tiefe Erholung",
    lib_prog_energy14_d14: "Fortschritt feiern",
    lib_prog_balance21_d1: "Intention und Selbstfürsorge",
    lib_prog_balance21_d2: "Ausgleichende Atmung",
    lib_prog_balance21_d3: "Auslöser erkennen",
    lib_prog_balance21_d4: "Regulierung mit Pause",
    lib_prog_balance21_d5: "Akzeptanzübung",
    lib_prog_balance21_d6: "Bewusste Kommunikation",
    lib_prog_balance21_d7: "Wochenrückblick",
    lib_prog_balance21_d8: "Gesunde Grenzen",
    lib_prog_balance21_d9: "Selbstmitgefühl",
    lib_prog_balance21_d10: "Erwartungen verwalten",
    lib_prog_balance21_d11: "Aktive Dankbarkeit",
    lib_prog_balance21_d12: "Emotionale Resilienz",
    lib_prog_balance21_d13: "Erholung ohne Schuldgefühle",
    lib_prog_balance21_d14: "Zweiwöchentlicher Rückblick",
    lib_prog_balance21_d15: "Beziehungen und Wohlbefinden",
    lib_prog_balance21_d16: "Kreativität und Ausdruck",
    lib_prog_balance21_d17: "Achtsame Bewegung",
    lib_prog_balance21_d18: "Persönlicher Raum",
    lib_prog_balance21_d19: "Kleine Erfolge feiern",
    lib_prog_balance21_d20: "Zukunftsvisualisierung",
    lib_prog_balance21_d21: "Integration und Engagement",
    lib_prog_sleep7_d1: "Bildschirme eine Stunde vorher ausschalten",
    lib_prog_sleep7_d2: "Entspannende Schlafatmung",
    lib_prog_sleep7_d3: "Visualisierung des sicheren Ortes",
    lib_prog_sleep7_d4: "Abendlicher Kör",
    lib_prog_balance21_d12: "Emotionale Resilienz",
    lib_prog_balance21_d13: "Erholung ohne Schuldgefühle",
    lib_prog_balance21_d14: "Zweiwöchentlicher Rückblick",
    lib_prog_balance21_d15: "Beziehungen und Wohlbefinden",
    lib_prog_balance21_d16: "Kreativität und Ausdruck",
    lib_prog_balance21_d17: "Achtsame Bewegung",
    lib_prog_balance21_d18: "Persönlicher Raum",
    lib_prog_balance21_d19: "Kleine Erfolge feiern",
    lib_prog_balance21_d20: "Zukunftsvisualisierung",
    lib_prog_balance21_d21: "Integration und Engagement",
    lib_prog_sleep7_d1: "Bildschirme eine Stunde vorher ausschalten",
    lib_prog_sleep7_d2: "Entspannende Schlafatmung",
    lib_prog_sleep7_d3: "Visualisierung des sicheren Ortes",
    lib_prog_sleep7_d4: "Abendlicher Körperscan",
    lib_prog_sleep7_d5: "Abendliches Dankbarkeitstagebuch",
    lib_prog_sleep7_d6: "Progressive Muskelentspannung",
    lib_prog_sleep7_d7: "Wochenabschluss und tiefe Erholung",
    lib_routine_morning_s1: "Trinke ein Glas Wasser beim Aufwachen",
    lib_routine_morning_s2: "Mache 3 tiefe Atemzüge mit geschlossenen Augen",
    lib_routine_morning_s3: "Setze deine Tagesintention in einem Satz",
    lib_routine_morning_s4: "Mache 5 Minuten sanftes Dehnen",
    lib_routine_stress_s1: "Halte inne und mache 5 tiefe Atemzüge",
    lib_routine_stress_s2: "Dehne Nacken, Schultern und Rücken 3 Minuten",
    lib_routine_stress_s3: "Lege das Handy weg und schaue 2 Minuten aus dem Fenster",
    lib_routine_stress_s4: "Schreibe etwas, wofür du heute dankbar bist",
    lib_routine_stress_s5: "Höre das Schnellpausen-Audio",
    lib_routine_night_s1: "Schalte alle Bildschirme 30 Minuten vor dem Schlafen aus",
    lib_routine_night_s2: "Mache 5 langsame, tiefe Atemzüge",
    lib_routine_night_s3: "Denke an 3 gute Dinge, die heute passiert sind",
    lib_routine_night_s4: "Höre das Schlafvorbereitungs-Audio",
    lib_completed: "Abgeschlossen",
    lib_mark_complete: "Als abgeschlossen markieren",
    detail_back_history: "Verlauf",
    detail_not_found: "Beratung nicht gefunden",
    detail_error: "Fehler beim Laden der Beratung",
    detail_qa_title: "Fragen und Antworten",
    detail_metrics: "Analysekennzahlen",
    detail_success: "Erfolgswahrscheinlichkeit",
    detail_recommendation: "Empfehlungsniveau",
    detail_stress: "Stressniveau",
    detail_happiness: "Zufriedenheitsniveau",
    detail_recommendation_title: "Empfehlung",
    detail_motives: "Grunde dafur",
    detail_risks: "Identifizierte Risiken",
    detail_alternative: "Alternative",
    detail_top3: "Top 3 empfohlene Wege",
    detail_confidence: "Vertrauen",
    detail_risk: "Risiko",
    detail_action_plan: "Aktionsplan",
    detail_premium_summary: "Premium-Zusammenfassung",

    // Legal footer
    legal_privacy: "Datenschutz",
    legal_cookies: "Cookies",
    legal_terms: "Nutzungsbedingungen",
    legal_delete_account: "Konto loeschen",
    legal_cookie_settings: "Cookie-Einstellungen",
    legal_rights: "Alle Rechte vorbehalten.",

    cookie_title: "Diese Seite verwendet Cookies",
    cookie_description: "Wir verwenden essentielle Cookies fuer den Betrieb des Dienstes. Du kannst optionale Analyse-Cookies akzeptieren oder ablehnen.",
    cookie_accept: "Akzeptieren",
    cookie_reject: "Ablehnen",
    cookie_configure: "Konfigurieren",
    cookie_config_title: "Cookie-Einstellungen",
    cookie_essential: "Essenziell",
    cookie_essential_desc: "Erforderlich fuer Authentifizierung und grundlegende Funktionen",
    cookie_analytics: "Analyse",
    cookie_analytics_desc: "Helfen uns zu verstehen, wie die Plattform genutzt wird",
    cookie_always_active: "Immer aktiv",
    cookie_save: "Einstellungen speichern",

    cookiep_title: "Cookie-Richtlinie",
    cookiep_updated: "Letzte Aktualisierung: April 2026",
    cookiep_what_title: "1. Was sind Cookies",
    cookiep_what_text: "Cookies sind kleine Textdateien, die auf deinem Geraet gespeichert werden, wenn du eine Website besuchst.",
    cookiep_types_title: "2. Arten von Cookies",
    cookiep_types_text: "Essentielle Cookies: notwendig fuer den grundlegenden Betrieb der Plattform. Sie werden automatisch aktiviert.\n\nAnalyse-Cookies (optional): Helfen uns zu verstehen, wie Nutzer mit der Plattform interagieren. Werden nur mit deiner Zustimmung aktiviert.",
    cookiep_essential_title: "3. Essentielle Cookies",
    cookiep_essential_text: "- Authentifizierungs-Token (JWT): haelt deine Sitzung aktiv.\n- Spracheinstellung: merkt sich die gewaehlte Sprache.\n- Cookie-Zustimmung: speichert deine Cookie-Wahl.",
    cookiep_analytics_title: "4. Analyse-Cookies",
    cookiep_analytics_text: "Wir verwenden derzeit keine Analyse-Dienste von Drittanbietern. Sollten wir in Zukunft Tools einbinden, werden diese nur mit deiner ausdruecklichen Zustimmung aktiviert.",
    cookiep_manage_title: "5. Cookies verwalten",
    cookiep_manage_text: "Du kannst Cookies akzeptieren, ablehnen oder konfigurieren, wenn das Zustimmungsbanner erscheint. Du kannst deine Einstellungen jederzeit ueber den Link 'Cookie-Einstellungen' in der Fusszeile aendern.",
    cookiep_revoke_title: "6. Zustimmung widerrufen",
    cookiep_revoke_text: "Du kannst deine Zustimmung jederzeit widerrufen:\n- Ueber den Link 'Cookie-Einstellungen' in der Fusszeile.\n- Durch Loeschen der Cookies in deinem Browser.",
    cookiep_changes_title: "7. Aenderungen",
    cookiep_changes_text: "Diese Richtlinie kann aktualisiert werden. Das Aktualisierungsdatum wird oben angegeben.",

    privacy_title: "Datenschutzrichtlinie",
    privacy_updated: "Letzte Aktualisierung: April 2026",
    privacy_s1_title: "1. Verantwortlicher",
    privacy_s1_text: "FUTURA DECISIONS APP, Privatperson, mit Sitz in Spanien.\n\nKontakt: soporte@futura-app.com\nWeb: www.futura-app.com",
    privacy_s2_title: "2. Erhobene Daten",
    privacy_s2_text: "Wir erheben folgende Daten:\n- Registrierungsdaten: Name, E-Mail und verschluesseltes Passwort.\n- Nutzungsdaten: Beratungen, Simulationen, Stimmungsverfolgung und Einstellungen.\n- Zahlungsdaten: sicher verarbeitet durch Stripe.\n- Technische Daten: IP-Adresse, Browsertyp und Geraet.",
    privacy_s3_title: "3. Zweck der Verarbeitung",
    privacy_s3_text: "Wir verwenden deine Daten um:\n- Den Entscheidungssimulations- und Wohlbefindensservice bereitzustellen.\n- Dein Konto und Abonnement zu verwalten.\n- Die Erfahrung innerhalb der Plattform zu personalisieren.",
    privacy_s4_title: "4. Rechtsgrundlage",
    privacy_s4_text: "Die Verarbeitung deiner Daten basiert auf:\n- Vertragsdurchfuehrung: zur Erbringung des angeforderten Dienstes.\n- Einwilligung: fuer optionale Analyse-Cookies.\n- Berechtigtes Interesse: zur Verbesserung der Sicherheit.",
    privacy_s5_title: "5. Dritte und Anbieter",
    privacy_s5_text: "Wir nutzen folgende Anbieter:\n- Stripe: Zahlungsabwicklung (PCI-DSS).\n- OpenAI: Verarbeitung von Beratungen mittels KI.\n- Cloud-Infrastruktur-Anbieter: Hosting des Dienstes.\n\nWir verkaufen oder teilen deine Daten nicht mit Dritten.",
    privacy_s6_title: "6. Datenspeicherung",
    privacy_s6_text: "Wir bewahren deine Daten auf, solange du ein aktives Konto hast. Bei Kontoloeschung werden deine Daten dauerhaft geloescht.",
    privacy_s7_title: "7. Nutzerrechte",
    privacy_s7_text: "Du hast das Recht auf:\n- Auskunft: eine Kopie deiner Daten anzufordern.\n- Berichtigung: unrichtige Daten zu korrigieren.\n- Loeschung: Loeschung deines Kontos und deiner Daten zu beantragen.\n- Uebertragbarkeit: deine Daten in einem strukturierten Format zu erhalten.\n- Widerspruch: der Verarbeitung unter bestimmten Umstaenden zu widersprechen.",
    privacy_s8_title: "8. Rechte ausueben",
    privacy_s8_text: "Du kannst deine Rechte ausueben:\n- Indem du dein Konto im Profilbereich der App loeschst.\n- Indem du soporte@futura-app.com kontaktierst.",
    privacy_s9_title: "9. Sicherheit",
    privacy_s9_text: "Wir setzen Sicherheitsmassnahmen zum Schutz deiner Daten ein:\n- Passwortverschluesselung mittels bcrypt.\n- Verschluesselte Kommunikation ueber HTTPS/TLS.\n- Sichere Authentifizierungs-Token (JWT).\n- PCI-DSS-zertifizierte Zahlungsverarbeitung ueber Stripe.",
    privacy_s10_title: "10. Aenderungen",
    privacy_s10_text: "Wir koennen diese Datenschutzrichtlinie aktualisieren. Wir werden dich ueber wesentliche Aenderungen informieren.",

    terms_title: "Allgemeine Geschaeftsbedingungen",
    terms_updated: "Letzte Aktualisierung: April 2026",
    terms_s1_title: "1. Art des Dienstes",
    terms_s1_text: "FUTURA ist eine KI-Plattform fuer persoenliches Wachstum, emotionales Wohlbefinden und Entscheidungshilfe. FUTURA ist kein medizinischer, psychologischer oder therapeutischer Dienst.",
    terms_s2_title: "2. Umfang der Empfehlungen",
    terms_s2_text: "Empfehlungen und Inhalte von FUTURA dienen nur zur Orientierung. Sie ersetzen keine professionelle medizinische, rechtliche oder psychologische Beratung.",
    terms_s3_title: "3. Emotionales Tracking (Modul 1)",
    terms_s3_text: "Das emotionale Tracking-Modul ermoeglicht es Nutzern, freiwillig Stimmung, Energie und Stress aufzuzeichnen. Diese Daten werden ausschliesslich fuer personalisierte Einblicke verwendet.",
    terms_s4_title: "4. Premium-Bibliothek (Modul 2)",
    terms_s4_text: "Gefuehrte Audios und Routinen in der Premium-Bibliothek sind Werkzeuge zur Unterstuetzung des allgemeinen Wohlbefindens. Sie ersetzen keine Therapie oder medizinische Behandlung.",
    terms_s5_title: "5. Empfehlung professioneller Hilfe",
    terms_s5_text: "Bei erheblichem emotionalem Stress empfehlen wir dringend, einen qualifizierten Fachmann fuer psychische Gesundheit aufzusuchen. FUTURA ist eine Ergaenzung, kein Ersatz.",
    terms_s6_title: "6. KI und Datennutzung",
    terms_s6_text: "FUTURA nutzt KI-Modelle fuer Empfehlungen. Nutzerdaten werden sicher gespeichert und nicht an Dritte weitergegeben. Nutzer koennen jederzeit die Loeschung beantragen.",
    terms_s7_title: "7. Plaene und Abonnements",
    terms_s7_text: "FUTURA bietet kostenlose und kostenpflichtige Plaene. Abonnements werden ueber Stripe verwaltet und koennen jederzeit gekuendigt werden.",
    terms_s8_title: "8. Akzeptanz",
    terms_s8_text: "Durch die Nutzung von FUTURA akzeptiert der Nutzer diese Bedingungen. FUTURA behaelt sich das Recht vor, diese Bedingungen zu aendern.",
    terms_s9_title: "9. Kontoloeschung",
    terms_s9_text: "Der Nutzer kann die Loeschung seines Kontos und der zugehoerigen Daten jederzeit im Profilbereich der Anwendung beantragen. Die Loeschung ist unwiderruflich.",
    terms_s10_title: "10. Anwendbares Recht",
    terms_s10_text: "Diese Bedingungen unterliegen dem Recht von Spanien.",
    terms_s11_title: "11. Dynamischer Avatar und zugehoerige Funktionen",
    terms_s11_text: "FUTURA beinhaltet einen personalisierbaren visuellen Avatar, der die Aktivitaet des Nutzers auf der Plattform orientierend widerspiegelt.\n\nFunktionsweise: Der Avatar berechnet ein Klarheitslevel (0-100) basierend auf der juengsten Nutzeraktivitaet (letzte 7 Tage). Dieser Wert bestimmt den visuellen Zustand des Avatars (Zerstreut, Fokussiert, Praezise, Maechtig).\n\nTaegliche Micro-Challenges: Der Avatar schlaegt optionale Aktivitaeten vor. Diese sind immer freiwillig und verwenden keine Sprache, die Schuldgefuehle oder emotionale Abhaengigkeit erzeugt.\n\nAktivitaets-Streak: Ein Zaehler aufeinanderfolgender aktiver Tage wird angezeigt. Dieser ist rein informativ.\n\nBenachrichtigungen: Der Nutzer kann freiwillig Push-Benachrichtigungen aktivieren, die jederzeit deaktiviert werden koennen.\n\nSchutz emotionaler Daten: Emotionale Wohlbefindensdaten werden verschluesselt gespeichert und ausschliesslich zur Berechnung des Avatar-Zustands verwendet. Sie werden nicht an Dritte weitergegeben.\n\nEinschraenkungen: Diese visuelle Darstellung ist KEINE klinische Diagnose, misst KEINE psychischen Gesundheitszustaende, ersetzt NICHT die Bewertung durch einen qualifizierten Fachmann und sollte NICHT als medizinische oder psychologische Beratung interpretiert werden.",

    delaccount_title: "Konto loeschen",
    delaccount_subtitle: "Informationen zum Loeschen deines FUTURA-Kontos",
    delaccount_how_title: "So loeschst du dein Konto",
    delaccount_how_text: "So loeschst du dein Konto:\n1. Melde dich bei deinem FUTURA-Konto an.\n2. Gehe zu deinem Profil.\n3. Scrolle nach unten.\n4. Tippe auf 'Konto loeschen'.\n5. Gib dein Passwort zur Bestaetigung ein.\n6. Dein Konto und alle zugehoerigen Daten werden dauerhaft geloescht.",
    delaccount_what_title: "Welche Daten geloescht werden",
    delaccount_what_text: "Beim Loeschen deines Kontos werden dauerhaft vom Server entfernt:\n- Dein Profil und Registrierungsdaten.\n- Alle Beratungen und Simulationen.\n- Dein Stimmungsverlauf.\n- Deine Tagebucheintraege.\n- Einstellungen und Konfiguration.",
    delaccount_contact_title: "Kontakt",
    delaccount_contact_text: "Wenn du nicht auf dein Konto zugreifen kannst, kontaktiere soporte@futura-app.com.",
    delaccount_cta_text: "Um dein Konto zu loeschen, melde dich zuerst an.",
    delaccount_cta_button: "Anmelden",

    profile_delete_account: "Konto loeschen",
    profile_delete_warning_title: "Diese Aktion ist unwiderruflich",
    profile_delete_warning_text: "Dein Konto, Simulationen, Stimmungsverlauf, Tagebuch und alle zugehoerigen Daten werden dauerhaft geloescht.",
    profile_delete_password_label: "Gib dein Passwort zur Bestaetigung ein",
    profile_delete_confirm: "Mein Konto dauerhaft loeschen",

    // Avatar System
    avatar_setup_title: "Personalisiere deinen Avatar",
    avatar_setup_subtitle: "Waehle eine Farbe fuer deinen Avatar. Er entwickelt sich mit dir basierend auf deiner Aktivitaet und emotionalen Klarheit.",
    avatar_setup_save: "Meinen Avatar aktivieren",
    avatar_choose_color: "Waehle deine Farbe",
    avatar_state_dormant: "Zerstreut",
    avatar_state_awakening: "Fokussiert",
    avatar_state_clear: "Praezise",
    avatar_state_radiant: "Maechtig",
    avatar_widget_title: "Dein Avatar",
    avatar_clarity_score: "Klarheitslevel",
    avatar_insight_dormant: "Dein Avatar zeigt weniger aktuelle Aktivitaet. Vielleicht ein guter Moment fuer eine bewusste Pause.",
    avatar_insight_awakening: "Du bist auf dem Weg. Erforsche weiter deine Emotionen und triff bewusste Entscheidungen.",
    avatar_insight_clear: "Dein Fokus waechst. Deine Entscheidungen und dein Wohlbefinden sind aufeinander abgestimmt.",
    avatar_insight_radiant: "Ein Moment grosser Energie. Dein Avatar spiegelt dein Engagement fuer dich selbst wider.",
    avatar_metric_checkins: "Check-ins",
    avatar_metric_consults: "Beratungen",
    avatar_metric_diary: "Tagebuch",
    avatar_deep_analysis_title: "Tiefenanalyse",
    avatar_deep_analysis_desc: "Schalte erweiterte Einblicke und emotionale Muster mit dem Avanza-Plan frei.",
    avatar_upgrade_cta: "Avanza-Plan ansehen",
    avatar_deep_insight_title: "Dein Einblick",
    avatar_deep_insight_desc: "Deine juengste Aktivitaet zeigt ein positives Muster der Selbsterkenntnis. Weiter so.",
    avatar_disclaimer: "Der Avatar ist eine visuelle Darstellung deiner Aktivitaet in FUTURA. Er stellt keine klinische Diagnose dar und ersetzt keine professionelle psychische Gesundheitsberatung.",
    avatar_landing_badge: "Dein Avatar wartet",
    avatar_landing_title: "Spuere Klarheit. Entscheide besser. Entwickle dich.",
    avatar_landing_subtitle: "Dein Avatar ist keine Funktion. Er ist der lebendige Spiegel dessen, wie du dich fuehlst, wenn du mit Klarheit entscheidest.",
    avatar_landing_desc: "Es geht nicht darum, mehr zu tun.\nEs geht darum, dich besser zu fuehlen, waehrend du entscheidest.\n\nDein Avatar entwickelt sich leise mit dir. Ohne Urteil. Ohne Druck.\nNur sichtbarer Fortschritt.",
    avatar_landing_f1: "Entwickelt sich in Echtzeit mit deinem Wohlbefinden",
    avatar_landing_f2: "Mach ihn zu deinem: wirklich personalisierbar",
    avatar_landing_f3: "Taegliche Micro-Challenges, um dich wiederzufinden",
    avatar_landing_f4: "Klare Einblicke, um dich zu verstehen, ohne Laerm",
    avatar_landing_cta: "Spuere den Unterschied",
    hero_main_title: "Simuliere deine Entscheidungen mit KI. Dein Avatar entwickelt sich mit dir.",
    hero_main_subtitle: "FUTURA analysiert jede Entscheidung, die dich beschaeftigt, und gibt dir Szenarien, Wahrscheinlichkeiten und echte Alternativen.",
    hero_sim_title: "Entscheidungssimulation",
    hero_sim_desc: "KI, die deine taeglichen Entscheidungen analysiert",
    hero_sim_example: "\"Ich denke darueber nach, den Job zu wechseln...\"",
    hero_sim_result_desc: "Analyse mit Gruenden, Risiken und personalisierten Alternativen",
    hero_sim_risks: "Risiken",
    hero_sim_alternatives: "Alternativen",
    hero_sim_footer: "Jede Simulation analysiert deine reale Situation mit fortschrittlicher KI",
    hero_avatar_title: "Dein persoenlicher Avatar",
    hero_avatar_desc: "Spiegelt dein Wohlbefinden waehrend du entscheidest",
    hero_step1_title: "Beschreibe deine Entscheidung",
    hero_step1_desc: "Erzaehl uns, was dich beschaeftigt. Die KI stellt Fragen.",
    hero_step2_title: "Erhalte deine Analyse",
    hero_step2_desc: "Erfolgswahrscheinlichkeit, Gruende, Risiken und Alternativen.",
    hero_step3_title: "Entwickle dich mit deinem Avatar",
    hero_step3_desc: "Dein Avatar spiegelt deine Klarheit. Taegliche Micro-Challenges.",
    avatar_fullscreen_title: "Dein Avatar",
    avatar_fullscreen_close: "Schliessen",
    avatar_challenge_title: "Deine Micro-Challenge heute",
    avatar_challenge_accept: "Ich nehme die Challenge an",
    avatar_challenge_done: "Challenge geschafft",
    avatar_challenge_skip: "Vielleicht morgen",
    avatar_fullscreen_btn: "Groß anzeigen",
    avatar_fullscreen_hint: "Erweiterte Ansicht deines Avatars öffnen",
    avatar_widget_hint: "Tippe, um deinen Avatar und Fortschritt zu sehen",
    avatar_tap_hint: "Tippe deinen Avatar",
    avatar_notif_title: "Benachrichtigungen",
    avatar_notif_enable: "Benachrichtigungen aktivieren",
    avatar_notif_enabled: "Benachrichtigungen aktiv",
    avatar_notif_instructions_title: "Benachrichtigungen aktivieren",
    avatar_notif_instructions_app: "In der FUTURA-App: gehe zu Handy-Einstellungen -> Apps -> FUTURA -> Benachrichtigungen und aktiviere sie. Kehre dann zur App zurueck.",
    avatar_notif_instructions_web: "Benachrichtigungen sind in deinem Browser blockiert. Klicke auf das Schloss-Symbol neben der URL und erlaube Benachrichtigungen.",
    avatar_notif_instructions_ok: "Verstanden",
    avatar_notif_desc: "Erhalte taegliche Micro-Challenges von deinem Avatar",
    avatar_ethical_banner: "Dieses Tool ersetzt keine professionelle psychische Gesundheitsberatung.",
    avatar_streak: "aufeinanderfolgende Tage",
    avatar_streak_msg: "Jeder Tag zaehlt. Deine Bestaendigkeit spiegelt sich in deinem Avatar wider.",
    streak_recovery_title: "Serie wiederherstellen",
    streak_recovery_available: "Wir haben einen Tag ohne Aktivitaet erkannt. Du kannst deine Serie wiederherstellen (1x/Monat, Decide/Avanza-Plan).",
    streak_recovery_apply: "Serie wiederherstellen",
    streak_recovery_used_month: "Du hast deine Wiederherstellung diesen Monat bereits genutzt. Naechsten Monat wieder verfuegbar.",
    streak_recovery_no_gap: "Keine Serie zum Wiederherstellen. Deine Bestaendigkeit ist intakt.",
    avatar_timeline_btn: "Deine Geschichte",
    avatar_timeline_btn_desc: "Sieh, wie du dich im Laufe der Zeit entwickelt hast",
    timeline_title: "Deine Zeitleiste",
    timeline_empty: "Deine Geschichte beginnt hier",
    timeline_empty_hint: "Mache eine Beratung, ein Check-in oder schreibe in dein Tagebuch.",
    timeline_type_consultation: "Simulation",
    timeline_type_mood: "Emotionales Check-in",
    timeline_type_diary: "Tagebuch",
    timeline_type_challenge: "Micro-Challenge geschafft",
    mood_label: "Stimmung",
    energy_label: "Energie",
    stress_label: "Stress",
    avatar_challenge_checkin: "Vielleicht ein guter Moment, um festzuhalten, wie du dich heute fuehlst.",
    avatar_challenge_consult: "Wenn du eine offene Entscheidung hast, koennte heute ein guter Tag sein.",
    avatar_challenge_breathe: "3 tiefe Atemzuege koennen einen Unterschied machen. Nur wenn du magst.",
    avatar_challenge_gratitude: "Denk an etwas Gutes, das dir heute passiert ist. Nur ein Moment fuer dich.",
    avatar_challenge_pause: "Eine 5-Minuten-Pause kann helfen. Du entscheidest wann.",
    avatar_challenge_diary: "Aufzuschreiben was du fuehlst kann Klarheit bringen. Ohne Eile.",
    avatar_challenge_walk: "Ein kurzer Spaziergang kann deine Perspektive aendern. Wann immer du willst.",

    // Interactive Premium Tools
    tool_done: "Fertig",
    tool_close: "Schliessen",
    tool_breathing_title: "4-7-8 Atmung",
    tool_breathing_subtitle: "Gefuehrte Technik ohne Ton, um Koerper und Geist zu beruhigen",
    tool_breathing_card_desc: "Ein leuchtender Kreis leitet deinen Atem. Einatmen 4s, Halten 7s, Ausatmen 8s.",
    tool_breathing_duration: "2-5 Min",
    tool_breathing_ready: "Bereit machen",
    tool_breathing_inhale: "Einatmen",
    tool_breathing_hold: "Halten",
    tool_breathing_exhale: "Ausatmen",
    tool_breathing_hint: "Folge dem Kreis. Je mehr du uebst, desto schneller kommt die Ruhe.",
    tool_breathing_cycles: "Zyklen abgeschlossen",
    tool_breathing_start: "Starten",
    tool_breathing_stop: "Stoppen",
    tool_grounding_title: "5-4-3-2-1 Grounding",
    tool_grounding_subtitle: "Sensorische Technik gegen Angst und Ueberforderung",
    tool_grounding_card_desc: "Nenne 5 Dinge die du siehst, 4 die du fuehlst, 3 die du hoerst, 2 die du riechst, 1 das du schmeckst.",
    tool_grounding_duration: "3-5 Min",
    tool_grounding_see_title: "Dinge die du SIEHST",
    tool_grounding_see_hint: "Schau dich um und benenne, was du siehst.",
    tool_grounding_see_placeholder: "Etwas das du siehst",
    tool_grounding_touch_title: "Dinge die du FUEHLST",
    tool_grounding_touch_hint: "Bemerke Texturen, Temperaturen und Gewichte.",
    tool_grounding_touch_placeholder: "Etwas das du beruehren kannst",
    tool_grounding_hear_title: "Dinge die du HOERST",
    tool_grounding_hear_hint: "Achte auf Geraeusche, auch leise.",
    tool_grounding_hear_placeholder: "Ein Geraeusch um dich",
    tool_grounding_smell_title: "Dinge die du RIECHST",
    tool_grounding_smell_hint: "Identifiziere Gerueche um dich oder in Erinnerung.",
    tool_grounding_smell_placeholder: "Ein Geruch den du bemerkst",
    tool_grounding_taste_title: "Ding das du SCHMECKST",
    tool_grounding_taste_hint: "Bemerke den Geschmack in deinem Mund.",
    tool_grounding_taste_placeholder: "Ein Geschmack jetzt",
    tool_grounding_next: "Weiter",
    tool_grounding_finish: "Abschliessen",
    tool_grounding_done_title: "Du bist hier, im Moment",
    tool_grounding_done_msg: "Du bist zurueck in deinem Koerper und im Hier und Jetzt. Angst verliert Kraft, wenn du dich erdest.",
    tool_grounding_restart: "Wiederholen",
    tool_screenbreak_title: "Bildschirmfreie Challenge",
    tool_screenbreak_subtitle: "Verpflichte dich, dein Handy X Minuten nicht zu nutzen",
    tool_screenbreak_card_desc: "Waehle eine Zeit, leg das Handy weg. Wenn du die App verlaesst, scheitert die Challenge.",
    tool_screenbreak_duration: "5-45 Min",
    tool_screenbreak_streak: "Serie",
    tool_screenbreak_total_min: "Bildschirmfreie Min",
    tool_screenbreak_pick_time: "Wie lange willst du pausieren?",
    tool_screenbreak_min: "Min",
    tool_screenbreak_warning: "Du kannst dein Handy sperren — der Timer laeuft weiter. Aber wenn du zu einer anderen App wechselst, scheitert die Challenge.",
    tool_screenbreak_hint: "Du kannst dein Handy sperren — der Timer laeuft weiter. Aber wenn du zu einer anderen App wechselst, scheitert die Challenge.",
    tool_screenbreak_rules: "Du kannst dein Handy sperren — der Timer laeuft weiter. Aber wenn du zu einer anderen App wechselst, scheitert die Challenge.",
    tool_screenbreak_start: "Challenge starten",
    tool_screenbreak_remaining: "Verbleibend",
    tool_screenbreak_keep_here: "Leg es mit dem Bildschirm nach unten und mach etwas Analoges.",
    tool_screenbreak_leave_fails: "Das Verlassen der App beendet die Challenge.",
    tool_screenbreak_lock_ok: "Du kannst dein Handy ruhig sperren, der Timer zaehlt weiter.",
    tool_screenbreak_week_min: "Min diese Woche",
    tool_screenbreak_cancel: "Challenge abbrechen",
    tool_screenbreak_success_title: "Geschafft!",
    tool_screenbreak_success_msg: "Du hast {minutes} Minuten ohne Bildschirm verbracht. Dein Gehirn dankt es dir.",
    tool_screenbreak_again: "Neue Challenge",
    tool_screenbreak_fail_title: "Digitale Pause nicht geschafft",
    tool_screenbreak_fail_msg: "Du hast die App zu frueh verlassen. Kein Druck, versuch es wieder, wenn du bereit bist.",
    tool_screenbreak_retry: "Erneut versuchen",

  },  it: {
    nav_features: "Funzionalita",
    nav_how_it_works: "Come funziona",
    nav_pricing: "Piani",
    nav_login: "Accedi",
    nav_login_short: "Accedi",
    nav_register: "Inizia ora",
    nav_register_short: "Inizia",
    nav_history: "Cronologia",
    nav_improve: "Upgrade",
    nav_compare: "Confronta",
    nav_back: "Indietro",
    nav_plans: "Piani",

    landing_badge: "La tua guida intelligente per decidere meglio",
    landing_h1_1: "Smetti di dubitare, ",
    landing_h1_2: "inizia a prendere decisioni sicure",
    landing_p: "Con FUTURA, risolvere decisioni importanti e quotidiane con l'IA e piu facile, e puoi anche scoprire come le tue emozioni influenzano ogni scelta. Decidi e vai avanti.",
    landing_cta: "Inizia ora",
    landing_cta_plans: "Vedi i piani",
    landing_cta_plans_hint: "da 5,99€/mese",
    landing_trust_free: "Gratis, senza carta",
    landing_trust_cancel: "Cancella quando vuoi",
    landing_trust_secure: "Pagamento sicuro · Stripe",
    landing_social_proof: "+2.500 decisioni simulate",
    landing_social_sub: "Negli ultimi 30 giorni",

    features_title: "Tutto cio che serve per decidere con piu chiarezza",
    features_subtitle: "Orientamento pratico con IA per le tue decisioni quotidiane, integrato da strumenti di benessere emotivo",
    feat_ai: "Orientamento con IA",
    feat_ai_desc: "Ricevi raccomandazioni contestualizzate e personalizzate per le tue decisioni quotidiane",
    feat_prob: "Raccomandazioni chiare",
    feat_prob_desc: "Visualizza scenari e probabilita basati sulla tua situazione specifica",
    feat_risk: "Contesto e rischi",
    feat_risk_desc: "Identifica potenziali ostacoli e fattori chiave prima di ogni decisione",
    feat_time: "Chiarezza emotiva",
    feat_time_desc: "Comprendi come la tua energía, stress o stato emotivo possono influenzare le tue decisioni",
    feat_rec: "Insight personalizzati",
    feat_rec_desc: "Ricevi osservazioni basate sui tuoi pattern per decisioni piu consapevoli",
    feat_impact: "Benessere complementare",
    feat_impact_desc: "Strumenti guidati e risorse pratiche per accompagnare la tua quotidianita con piu equilibrio",

    how_title: "Come funziona",
    how_subtitle: "In tre passaggi, otterrai orientamento pratico e chiarezza per decidere meglio",
    how_step1_title: "Presenta la tua decisione",
    how_step1_desc: "Ricevi aiuto pratico e contestuale per risolvere decisioni quotidiane.",
    how_step2_title: "Ottieni una raccomandazione intelligente",
    how_step2_desc: "FUTURA analizza il tuo contesto e offre orientamento útile, rápido e personalizzato.",
    how_step3_title: "Decidi con piu chiarezza",
    how_step3_desc: "Con il tracciamento emotivo, puoi anche capire come il tuo stato influenza le tue decisioni.",

    dm_title: "Decidi meglio dentro e fuori",
    dm_subtitle: "Le tue decisioni non dipendono solo dal contesto. Dipendono anche da come ti senti. FUTURA unisce orientamento pratico + chiarezza emotiva.",
    dm_card1_title: "Decisióni quotidiane con IA",
    dm_card1_desc: "L'essenza di FUTURA: aiuto pratico per risolvere scelte reali del quotidiaño con piu contesto e meno rumore mentale.",
    dm_card1_b1: "Raccomandazioni contestualizzate",
    dm_card1_b2: "Simulazioni quotidiane",
    dm_card1_b3: "Aiuto pratico e immediato",
    dm_card1_b4: "Meno sovrapensiero",
    dm_card1_b5: "Piu chiarezza per scegliere",
    dm_card2_title: "Chiarezza emotiva complementare",
    dm_card2_desc: "Un livello di tracciamento emotivo non clínico che ti aiuta a capire come il tuo stato puo influenzare le tue decisioni.",
    dm_card2_b1: "Check-in giornalieri",
    dm_card2_b2: "Pattern personali",
    dm_card2_b3: "Insight orientativi",
    dm_card2_b4: "Piu autoconsapevolezza",
    dm_card2_b5: "Decisióni piu consapevoli",

    trust_title: "Progettato per aiutarti con chiarezza e responsabilita",
    trust1_title: "Decisióni quotidiane, orientamento pratico",
    trust1_desc: "FUTURA e progettata per aiutarti nelle decisioni quotidiane e offre strumenti di benessere emotivo orientativo e non clínico.",
    trust2_title: "IA orientativa e trasparente",
    trust2_desc: "Le raccomandazioni e gli insight forniscono chiarezza, contesto e autoconsapevolezza, non sostituiscono una valutazione professionale.",
    trust3_title: "Uso responsabile",
    trust3_desc: "Se hai bisogno di aiuto specializzato, ti consigliamo sempre di rivolgerti a un professionista qualificato. FUTURA e un complemento, non un sostituto.",

    cta_title: "Pronto a prendere decisioni migliori?",
    cta_subtitle: "Prova FUTURA gratis e scopri come l'IA puo aiutarti a decidere con piu chiarezza ogni giorno.",
    cta_button: "Inizia ora",

    mod_badge: "Scopri cosa include FUTURA",
    mod_title: "Più che decisioni: anche il tuo benessere conta",
    mod_subtitle: "FUTURA va oltre le decisioni. Integra strumenti di benessere emotivo per aiutarti a decidere con più chiarezza e sentirti meglio.",
    mod1_tag: "Modulo 1",
    mod1_name: "Strumenti interattivi",
    mod1_desc: "3 strumenti visivi per supportarti quando ne hai più bisogno: respirazione guidata, grounding 5-4-3-2-1 e sfide di pausa dallo schermo.",
    mod1_f1: "Respirazione visiva 4-7-8",
    mod1_f2: "Grounding 5-4-3-2-1",
    mod1_f3: "Sfida di pausa digitale",
    mod1_f4: "Completamente senza audio",
    mod1_plans: "Disponibile nei piani Decide e Avanza",
    mod2_tag: "Modulo 2",
    mod2_name: "Tracciamento Emotivo Intelligente",
    mod2_desc: "Registra il tuo stato emotivo quotidiano, scopri pattern e conta sul tuo Diario IA personale come compagno empatico.",
    mod2_f1: "Check-in emotivo quotidiano",
    mod2_f2: "Grafici settimanali e insight con IA",
    mod2_f3: "Diario IA personale",
    mod2_f4: "Pattern e riepilogo emotivo",
    mod2_plans: "Esclusivo del piano Avanza",


    footer_terms: "Termini e Condizioni",
    footer_privacy: "Informativa sulla Privacy",
    footer_support: "Supporto",
    footer_rights: "2026 FUTURA. Tutti i diritti riservati.",
    webview_sub_managed: "Gli abbonamenti vengono gestiti dal sito web",
    webview_limit_modal: "Hai raggiunto il limite gratuito di oggi. Torna domani o sblocca l'accesso illimitato dal nostro sito web nel tuo browser.",
    webview_limit_accept: "Accetta",
    footer_disclaimer: "FUTURA e una piattaforma di supporto alle decisioni quotidiane e accompagnamento di benessere emotivo non clínico. Non offre diagnosi clínica, trattamento psicológico ne assistenza di emergenza. Se hai bisogno di aiuto specializzato, ti consigliamo di rivolgerti a un professionista qualificato.",

    login_title: "Bentornato",
    login_subtitle: "Inserisci le tue credenziali",
    login_email: "Email",
    login_password: "Password",
    login_submit: "Accedi",
    login_remember_me: "Ricorda i miei dati",
    login_or: "o continua con",
    login_no_account: "Non hai un account?",
    login_register_link: "Registrati gratis",
    login_forgot_password: "Hai dimenticato la password?",
    login_right_title: "Decisióni piu intelligenti",
    login_right_subtitle: "Orientamento pratico con IA per le tue decisioni quotidiane, integrato da chiarezza emotiva",

    register_title: "Crea il tuo account",
    register_subtitle: "Inizia a decidere con piu chiarezza oggi",
    register_name: "Nome",
    register_name_placeholder: "Il tuo nome",
    register_email: "Email",
    register_password: "Password",
    register_password_placeholder: "Minimo 6 caratteri",
    register_submit: "Crea account",
    register_or: "o registrati con",
    register_has_account: "Hai gia un account?",
    register_login_link: "Accedi",
    register_right_title: "La tua prima consulenza e gratuita",
    register_right_subtitle: "Scopri come l'IA puo aiutarti a prendere decisioni migliori",
    register_password_error: "La password deve avere almeno 6 caratteri",
    register_password_alphanumeric: "La password puo contenere solo lettere e numeri (niente simboli o spazi)",
    register_password_hint: "Solo lettere e numeri. Minimo 6 caratteri.",
    register_security_question: "Domanda di sicurezza",
    register_select_question: "Seleziona una domanda",
    register_security_answer: "Risposta segreta",
    register_security_answer_placeholder: "La tua risposta (non puo essere cambiata)",
    register_security_required: "Devi scegliere una domanda e scrivere la tua risposta segreta",
    register_security_warning: "Ricorda questa risposta. E l'unico modo per recuperare il tuo account se dimentichi la password.",

    // Forgot Password
    login_forgot_password: "Hai dimenticato la password?",
    forgot_title: "Recupera il tuo account",
    forgot_subtitle_email: "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
    forgot_email_label: "Email",
    forgot_send_link: "Invia link",
    forgot_sent_title: "Email inviata!",
    forgot_sent_text: "Abbiamo inviato un link di reimpostazione a:",
    forgot_sent_check_spam: "Controlla la cartella spam se non lo trovi.",
    forgot_min_password: "La password deve avere almeno 6 caratteri",
    forgot_passwords_mismatch: "Le password non coincidono",
    forgot_confirm_password: "Conferma password",
    reset_title: "Nuova password",
    reset_subtitle: "Scegli una password sicura di almeno 6 caratteri.",
    reset_new_password: "Nuova password",
    reset_new_placeholder: "Minimo 6 caratteri",
    reset_confirm_password: "Conferma password",
    reset_confirm_placeholder: "Ripeti la password",
    reset_btn: "Cambia password",
    reset_done_title: "Password aggiornata!",
    reset_done_subtitle: "La tua password e stata cambiata con successo. Ora puoi accedere.",
    reset_go_login: "Accedi",
    reset_invalid_link: "Link non valido",
    reset_invalid_desc: "Questo link di recupero non e valido o e scaduto.",
    reset_request_new: "Richiedi nuovo link",
    verify_title: "Verifica la tua email",
    verify_subtitle: "Abbiamo inviato un codice di verifica a:",
    verify_code_label: "Codice di verifica",
    verify_btn: "Verifica",
    verify_resend: "Reinvia codice",
    verify_resent: "Codice reinviato con successo",
    verify_back_login: "Torna al login",
    register_gdpr_required: "Devi accettare i termini e la privacy policy",
    register_gdpr_text: "Accetto i",
    register_gdpr_terms: "Termini e Condizioni",
    register_gdpr_and: "e la",
    register_gdpr_privacy: "Privacy Policy",
    sq_pet: "Qual e il nome del tuo primo animale domestico?",
    sq_city: "In quale citta sei nato/a?",
    sq_teacher: "Qual e il nome del tuo insegnante preferito/a?",
    sq_food: "Qual e il tuo cibo preferito?",
    sq_friend: "Qual e il nome del tuo migliore amico/a d'infanzia?",
    profile_security_title: "Domanda di sicurezza",
    profile_security_set: "Configurata",
    profile_security_not_set: "Non configurata",
    profile_security_btn: "Configura domanda di sicurezza",
    profile_security_update: "Aggiorna domanda",
    profile_security_save: "Salva",
    security_prompt_subtitle: "Configura la tua domanda per poter recuperare il tuo account",
    profile_email: "Email",
    profile_auth_method: "Metodo di accesso",
    profile_auth_email: "Email e password",
    profile_plan: "Piano attuale",
    profile_upgrade: "Aggiorna piano",
    profile_member_since: "Membro dal",
    profile_change_password: "Cambia password",
    profile_change_password_sub: "Aggiorna la tua password di accesso",
    profile_current_password: "Password attuale",
    profile_pw_min: "La nuova password deve avere almeno 6 caratteri",
    profile_pw_success: "Password aggiornata con successo",
    profile_save_password: "Salva nuova password",
    profile_manage_subscription: "Gestisci abbonamento",
    profile_cancel_warning: "Se annulli il tuo abbonamento, perderai l'accesso alle funzioni premium alla fine del periodo corrente. Il tuo piano tornera a Descubre (gratuito).",
    profile_cancel_confirm_label: "Scrivi CANCELAR per confermare",
    profile_cancel_button: "Annulla abbonamento",
    pricing_cancel_anytime: "Annulla in qualsiasi momento",

    consulta_h1_1: "Quale decisione devi",
    consulta_h1_2: "prendere oggi?",
    consulta_subtitle: "Ti faro alcune domande per capire la tua situazione e darti la migliore raccomandazione.",
    consulta_placeholder: "Descrivi il tuo dilemma o la tua decisione...",
    consulta_start: "Inizia",
    consulta_examples_title: "Domande di esempio",
    consulta_question_of: "Domanda {current} di {total}",
    consulta_answer_placeholder: "Scrivi la tua risposta...",
    consulta_generating: "Perfetto! Genero la tua analisi personalizzata...",
    consulta_analyzing: "Analizzo la tua situazione...",
    consulta_loading_estimate: "Stiamo elaborando la tua simulazione, questo può richiedere fino a 1 minuto.",
    consulta_loading_phrase_1: "La tua simulazione è in corso, può richiedere alcuni secondi.",
    consulta_loading_phrase_2: "Considerando scenari, rischi e opportunità...",
    consulta_loading_phrase_3: "Riviso i tuoi segnali emotivi e razionali.",
    consulta_loading_phrase_4: "Stiamo cercando ciò che conta davvero per te.",
    consulta_loading_phrase_5: "Quasi pronto. Ne vale la pena.",
    consulta_footer: "FUTURA offre orientamento pratico e complementare per le tue decisioni quotidiane. Non sostituisce la consulenza professionale.",

    example_q1: "Dovrei cambiare lavoro?",
    example_q2: "Compro o risparmio?",
    example_q3: "Dovrei trasferirmi?",
    example_q4: "Cosa mi metto oggi?",
    example_q5: "Investo o aspetto?",
    example_q6: "Studio questo o quello?",

    result_analysis_title: "Analisi della tua decisione",
    result_success: "Probabilita di successo",
    result_recommendation_level: "Livello di raccomandazione",
    result_stress: "Livello di stress",
    result_happiness: "Livello di benessere",
    result_recommendation: "RACCOMANDAZIONE",
    result_why: "Perche questa raccomandazione?",
    result_motives: "MOTIVI",
    result_risks: "ASPETTI DA CONSIDERARE",
    result_alternative: "ALTERNATIVA",
    result_top3: "TOP 3 PERCORSI RACCOMANDATI",
    result_confidence: "fiducia",
    result_risk: "rischio",
    result_action_plan: "PIANO D'AZIONE",
    result_premium_summary: "RIEPILOGO PREMIUM",
    result_premium_tag: "PREMIUM",
    result_upsell: "Vuoi di piu? Con il piano",
    result_upsell_features: "Top 3 percorsi - Piano d'azione - Riepilogo premium - Comparatore",
    result_upsell_btn: "Vedi piaño Avanza",
    result_new_consultation: "Nuova consulenza",
    result_limit_reached: "Limite raggiunto. Aggiorna il piano.",
    result_view_plans: "Vedi piani",

    history_title: "Cronologia consulenze",
    history_subtitle: "Tutte le tue consulenze passate",
    history_compare_btn: "Confronta scenari",
    history_search: "Cerca consulenze...",
    history_no_results: "Nessun risultato",
    history_no_consultations: "Nessuna consulenza ancora",
    history_no_results_hint: "Prova altri termini",
    history_no_consultations_hint: "Fai la tua prima consulenza",
    history_first_btn: "Prima consulenza",
    history_motives: "Motivi",
    history_risks: "Aspetti",
    history_alternative: "Alternativa",
    history_reasons: "motivi",
    history_identified: "identificati",
    history_delete_title: "Elimina consultazione",
    history_delete_confirm: "Sei sicuro di voler eliminare questa consultazione? Questa azione non puo essere annullata.",
    history_delete_cancel: "Annulla",
    history_delete_yes: "Elimina",

    pricing_title: "Scegli il tuo piano",
    pricing_subtitle: "Decisióni migliori, piu chiarezza. Scegli il piaño adatto a te.",
    pricing_monthly: "Mensile",
    pricing_annual: "Annuale",
    pricing_forever: "per sempre",
    pricing_month: "/mese",
    pricing_year: "/anno",
    pricing_your_plan: "Il tuo piaño attuale",
    pricing_free: "Gratuito",
    pricing_subscribe: "Scegli piano",
    pricing_secure: "Pagamenti sicuri con Stripe. Cancella quando vuoi.",
    pricing_cancel: "Cancella abbonamento",
    pricing_cancel_confirm: "Sei sicuro? Tornerai al piaño Descubre.",

    plan_descubre: "Descubre",
    plan_descubre_badge: "Gratuito",
    plan_descubre_desc: "Un primo sguardo a cio che FUTURA puo fare per te",
    plan_decide: "Decide",
    plan_decide_badge: "Popolare",
    plan_decide_desc: "Smetti di dubitare. Inizia a vivere con chiarezza e fiducia in ogni decisione.",
    plan_avanza: "Avanza",
    plan_avanza_badge: "Trasformativo",
    plan_avanza_desc: "Senti la differenza di prendere ogni decisione con totale chiarezza, comprendendo le tue emozioni e con un piano d'azione su misura. Un'esperienza unica che trasforma il tuo modo di vivere.",
    plan_saves: "Risparmi",
    plan_per_month: "/mese",
    plan_start_free: "Inizia gratis",
    plan_choose_decide: "Scegli Decide",
    plan_choose_avanza: "Scegli Avanza",
    pricing_popular: "Più popolare",
    pricing_annual_hint: "Piani annuali disponibili con sconto — pagamento sicuro tramite Stripe. Cancella quando vuoi.",
    plan_descubre_feat1: "1 simulazione al giorno",
    plan_descubre_feat2: "Check-in emotivo quotidiano",
    plan_descubre_feat3: "Avatar personalizzabile",
    plan_decide_feat1: "50 simulazioni al mese",
    plan_decide_feat2: "Cronologia completa delle decisioni",
    plan_decide_feat3: "Livelli avatar (1-10) e obiettivi",
    plan_decide_feat4: "Recupera la serie una volta al mese",
    plan_avanza_feat1: "Simulazioni illimitate",
    plan_avanza_feat2: "Diario IA personale + report premium",
    plan_avanza_feat3: "Comparatore avanzato di decisioni",
    plan_avanza_feat4: "Tutto di Decide incluso",
    plan_intent_banner: "Sei a un passo dall'attivare {plan} per {price}/mese. Completa l'abbonamento quando vuoi.",
    plan_intent_continue: "Attiva",
    plan_intent_dismiss: "Chiudi",
    plan_saves: "Risparmi",

    plan_descubre_emotion: "Prova gratis, senza impegno",
    plan_decide_emotion: "La chiarezza che meriti, ogni giorno",
    plan_decide_hook: "Immagina di prendere 50 decisioni al mese sapendo che ognuna e stata analizzata a fondo. Niente piu notti insonni. Niente piu dubbi paralizzanti.",
    plan_avanza_emotion: "Trasforma la tua vita dall'interno",
    plan_avanza_hook: "Decisioni illimitate + il tuo Diario IA personale. Perche le migliori decisioni nascono quando capisci cosa senti. La tua evoluzione inizia qui.",

    pf_1sim: "1 simulazione al giorno",
    pf_ai_rec: "Raccomandazione orientativa base",
    pf_basic_motives: "Analisi generale semplificata",
    pf_50sim: "50 simulazioni al mese",
    pf_5sim: "5 simulazioni al mese",
    pf_detailed_motives: "Analisi profonda con contesto personale",
    pf_full_history: "Cronologia completa delle decisioni",
    pf_emotional_tracking: "Tracciamento Emotivo Intelligente",
    pf_checkin: "Check-in emotivo giornaliero",
    pf_mood_tracker: "Mood tracker intelligente",
    pf_journal: "Diario emotivo guidato",
    pf_energy_log: "Registro energia, riposo e stress",
    pf_weekly_charts: "Grafici settimanali di benessere",
    pf_ai_insights: "Insight personalizzati con IA",
    pf_patterns: "Riepilogo pattern emotivi",
    pf_smart_ai: "IA avanzata che capisce il tuo contesto reale",
    pf_unlimited: "Simulazioni illimitate",
    pf_premium_ai: "IA premium: analisi profonda, empatica e trasformativa",
    pf_pdf: "Scarica risultati in PDF",
    pf_comparator: "Comparatore di scenari",
    pf_premium_report: "Report premium",
    pf_top3: "Top 3 percorsi raccomandati",
    pf_confidence: "Livello fiducia/rischio",
    pf_action: "Piano d'azione personalizzato passo dopo passo",
    pf_library: "Biblioteca Premium di Benessere",
    pf_audio_guides: "Guida visiva respirazione 4-7-8",
    pf_programs: "Programmi strutturati 7/14/21 giorni",
    pf_routines: "Tecnica grounding 5-4-3-2-1 contro l'ansia",
    pf_smart_recs: "Sfida di pausa digitale con tracking schermo",
    pf_regulation: "Strumenti pratici di regolazione emotiva",
    pf_diary_ai_desc: "Il tuo Diario IA personale: scrivi, parla e comprendi le tue emozioni",

    pmiss_history: "Cronologia completa",
    pmiss_pdf: "Download PDF",
    pmiss_comparator: "Comparatore scenari",
    pmiss_premium: "Report premium",
    pmiss_emotional: "Tracciamento emotivo",
    pmiss_library: "Strumenti interattivi premium",
    pmiss_diary_ai: "Diario IA personale",
    pmiss_smart_ai: "IA avanzata",

    sim_counter_daily: "Oggi",
    sim_counter_monthly: "Questo mese",
    sim_counter_unlimited: "Illimitate",
    sim_counter_available: "disponibile",
    sim_counter_available_pl: "disponibili",
    sim_counter_next_reset: "Si rinnova",
    sim_counter_next_reset_in: "tra",
    sim_counter_hours: "h",
    sim_counter_upgrade: "Sblocca piu simulazioni",

    landing_diary_badge: "Esclusivo Piano Avanza",
    landing_diary_title: "Il tuo Diario IA: dove tutto inizia ad avere senso",
    landing_diary_subtitle: "Scrivi cio che senti, parlagli a voce, e lascia che l'IA ti aiuti a capirti. Non e un diario comune. E il tuo compagno emotivo intelligente.",
    landing_diary_f1: "Scrivi o parla: esprimi le tue emozioni come preferisci",
    landing_diary_f2: "L'IA rileva i tuoi pattern e ti aiuta a vederli",
    landing_diary_f3: "Analisi delle crisi: se stai passando un brutto momento, FUTURA lo rileva",
    landing_diary_f4: "La tua evoluzione emotiva visibile settimana dopo settimana",
    landing_diary_cta: "Voglio il mio Diario IA",

    comp_title: "Comparatore di Scenari",
    comp_subtitle: "Seleziona 2-4 consulenze da confrontare",
    comp_gate_title: "Comparatore di Scenari",
    comp_gate_desc: "Disponibile nel piaño Avanza",
    comp_gate_btn: "Vedi piaño Avanza",
    comp_no_consultations: "Nessuna consulenza da confrontare.",
    comp_compare_btn: "Confronta {count} consulenze",
    comp_best: "Opzione migliore",
    comp_new: "Nuovo confronto",
    comp_success: "Successo",
    comp_recommendation: "Raccomandazione",
    comp_stress: "Stress",
    comp_happiness: "Benessere",
    comp_rec_label: "Raccomandazione",

    pay_checking: "Verifica pagamento...",
    pay_checking_sub: "Attendi la conferma",
    pay_attempt: "Tentativo {n} di 5",
    pay_success: "Pagamento riuscito!",
    pay_go_dashboard: "Vai alla Dashboard",
    pay_error: "Errore di pagamento",
    pay_retry: "Riprova",
    pay_back_dashboard: "Torna alla Dashboard",
    pay_no_session: "Nessuna info pagamento",
    pay_timeout: "Pagamento non verificato. Contatta il supporto.",
    pay_expired: "Sessione scaduta. Riprova.",

    dash_hello: "Ciao",
    dash_what: "Quale decisione vuoi risolvere oggi?",
    dash_simulations: "Simulazioni",
    dash_used_month: "questo mese",
    dash_decisions: "Decisióni",
    dash_in_history: "nella cronologia",
    dash_plan: "Piano",
    dash_upgrade: "Aggiorna piano",
    dash_new_sim: "Nuova consulenza",
    dash_new_sim_desc: "Descrivi la tua decisione e ottieni orientamento pratico personalizzato",
    dash_create_sim: "Crea consulenza",
    dash_limit: "Limite raggiunto. Aggiorna il piano.",
    dash_recent: "Consulenze recenti",
    dash_view_all: "Vedi tutte",
    dash_completed: "Completata",
    dash_pending: "In sospeso",
    dash_no_decisions: "Nessuna consulenza ancora",
    dash_no_decisions_hint: "Crea la tua prima consulenza",
    dash_first_sim: "Crea la prima consulenza",
    dash_used_today: "usata oggi",
    dash_unlimited: "simulazioni illimitate",
    dash_resets: "Si rinnova:",
    dash_limit_reached: "Hai raggiunto il limite. Aggiorna il tuo piano per continuare.",
    dash_question: "Quale decisione vuoi simulare oggi?",
    dash_history: "Cronologia",
    dash_plans: "Piani",
    dash_wellbeing: "Benessere",
    dash_library: "Strumenti",
    dash_emotional_tracking: "Tracciamento Emotivo",
    dash_emotional_desc: "Registra il tuo stato e ottieni approfondimenti",
    dash_premium_library: "Strumenti interattivi",
    dash_premium_desc: "Respirazione, grounding e pausa digitale",
    dash_screenbreak_label: "Pausa digitale",
    dash_screenbreak_min_week: "min senza schermo questa settimana",

    loading: "Caricamento...",
    lang_es: "Español",
    lang_en: "English",
    lang_de: "Deutsch",
    lang_it: "Italiano",

    nav_wellbeing: "Benessere",
    nav_library: "Biblioteca",
    nav_diary: "Diario IA",
    nav_profile: "Profilo",
    nav_logout: "Esci",
    pricing_module1_title: "Modulo 1: Strumenti interattivi",
    pricing_module2_title: "Modulo 2: Tracciamento Emotivo",
    pf_favorites: "Salva consulenze preferite",
    pf_diary_ai: "Diario IA personale",

    mood_title: "Tracciamento Emotivo",
    mood_subtitle: "Registra come ti senti e scopri come il tuo stato influenza le tue decisioni",
    mood_checkin_title: "Check-in di oggi",
    mood_checkin_sub: "Come ti senti adesso?",
    mood_today_done: "Check-in completato",
    mood_today_done_sub: "Hai gia registrato il tuo stato di oggi. Torna domani.",
    mood_label: "Umore",
    energy_label: "Energía",
    stress_label: "Stress",
    mood_1: "Molto basso",
    mood_2: "Basso",
    mood_3: "Normale",
    mood_4: "Bene",
    mood_5: "Molto bene",
    energy_1: "Esausto",
    energy_2: "Stanco",
    energy_3: "Normale",
    energy_4: "Attivo",
    energy_5: "Pieno di energía",
    stress_1: "Molto rilassato",
    stress_2: "Tranquillo",
    stress_3: "Normale",
    stress_4: "Stressato",
    stress_5: "Molto stressato",
    mood_note_placeholder: "Nota opzionale: vuoi annotare qualcosa?",
    mood_save: "Salva check-in",
    mood_weekly_title: "Ultimi 7 giorni",
    mood_averages_title: "Medie settimanali",
    mood_checkins_count: "check-in questa settimana",
    mood_insight_title: "Insight personalizzato",
    mood_insight_loading: "Calcolando il tuo riepilogo settimanale...",
    mood_empty: "Fai il tuo primo check-in per iniziare a vedere i tuoi pattern emotivi",
    mood_history_title: "Cronologia recente",
    mood_disclaimer: "Il tracciamento emotivo di FUTURA e orientativo e non clínico. Non sostituisce l'assistenza professionale.",
    mood_gate_title: "Tracciamento Emotivo",
    mood_gate_desc: "Questa funzione e disponibile nel piano Avanza",
    mood_gate_btn: "Vedi piano Avanza",

    diary_title: "Diario IA",
    diary_empty_title: "Il tuo spazio sicuro",
    diary_empty_desc: "Scrivi come ti senti oggi. Sono qui per ascoltarti, senza giudizi.",
    diary_placeholder: "Come ti senti oggi?",
    diary_recording: "Registrando...",
    diary_stop: "Ferma",
    diary_transcribing: "Trascrivendo audio...",
    diary_voice_transcribed: "Trascritto da audio",
    diary_weekly_summary: "Riepilogo settimanale",
    diary_challenge_label: "Micro-sfida suggerita",
    diary_gate_title: "Diario IA",
    diary_gate_desc: "Accedi al tuo diario emotivo con IA con il piano Avanza",
    diary_gate_btn: "Vedi piano Avanza",

    lib_title: "Strumenti interattivi",
    lib_subtitle: "3 strumenti visivi per calmarti, metterti a terra e staccare dallo schermo",
    lib_tab_programs: "Programmi",
    lib_tab_audios: "Audio guidati",
    lib_tab_routines: "Routine",
    lib_days: "giorni",
    lib_sessions: "sessioni",
    lib_steps: "passaggi",
    lib_prog_stress7_title: "Riduci lo stress in 7 giorni",
    lib_prog_stress7_desc: "Un programma quotidiaño con esercizi pratici di respirazione, pause attive e riflessione.",
    lib_prog_energy14_title: "Recupera energía in 14 giorni",
    lib_prog_energy14_desc: "Attivita progressive per migliorare il tuo livello di energía e vitalita.",
    lib_prog_balance21_title: "21 giorni di equilibrio personale",
    lib_prog_balance21_desc: "Un percorso completo con abitudini di benessere, autocura e regolazione emotiva.",
    lib_prog_sleep7_title: "Migliora il sonno in 7 giorni",
    lib_prog_sleep7_desc: "Tecniche e routine serali per un sonno piu riposante.",
    lib_audio_breathing_title: "Respirazione guidata",
    lib_audio_breathing_desc: "Técnica di respirazione 4-7-8 per calma immediata",
    lib_audio_relax_title: "Rilassamento profondo",
    lib_audio_relax_desc: "Esercizio di rilassamento muscolare progressivo",
    lib_audio_focus_title: "Focus e concentrazione",
    lib_audio_focus_desc: "Meditazione guidata per migliorare l'attenzione",
    lib_audio_sleep_title: "Preparazione al sonno",
    lib_audio_sleep_desc: "Visualizzazione guidata per un riposo ristoratore",
    lib_audio_morning_title: "Risveglio con energía",
    lib_audio_morning_desc: "Routine mattutina di attivazione mente-corpo",
    lib_audio_pause_title: "Pausa rápida",
    lib_audio_pause_desc: "Pausa mentale express per momenti di tensióne",
    lib_audio_intro: "Premi play per ascoltare gli audio guidati generati con IA. La prima riproduzione potrebbe richiedere alcuni secondi.",
    lib_audio_coming_soon: "Nuovi audio guidati in arrivo",
    lib_routine_morning_title: "Routine mattutina di benessere",
    lib_routine_morning_desc: "Inizia la giornata con chiarezza: idratazione, respirazione, intenzione e movimento.",
    lib_routine_stress_title: "Routine anti-stress",
    lib_routine_stress_desc: "Quando senti tensióne: respirazione profonda, stretching, disconnessione digitale e nota di gratitudine.",
    lib_routine_night_title: "Routine serale di riposo",
    lib_routine_night_desc: "Prepara corpo e mente per dormire: niente schermi, respirazione, riflessione e rilassamento.",
    lib_disclaimer: "Gli strumenti sono orientativi e non sostituiscono l'assistenza professionale.",
    lib_gate_title: "Strumenti interattivi",
    lib_gate_desc: "Respirazione guidata, grounding e sfide di pausa con i piani Decide o Avanza",
    lib_gate_btn: "Vedi i piani",
    lib_audio_error: "Errore nel caricamento. Riprova.",
    lib_back_to_list: "Indietro",
    lib_day: "Giorno",
    lib_step: "Passo",
    lib_start_audio: "Ascolta audio guidato",
    lib_program_intro: "Segui ogni sessione in ordine per i migliori risultati. Ogni giorno include un audio guidato.",
    lib_routine_intro: "Segui ogni passo in ordine. Prenditi il tuo tempo.",
    lib_duration_min: "min",
    lib_prog_stress7_d1: "Respirazione profonda 4-7-8",
    lib_prog_stress7_d2: "Scansione delle tensioni corporee",
    lib_prog_stress7_d3: "Pausa attiva e stretching",
    lib_prog_stress7_d4: "Diario rapido delle emozioni",
    lib_prog_stress7_d5: "Meditazione di concentrazione",
    lib_prog_stress7_d6: "Disconnessione digitale guidata",
    lib_prog_stress7_d7: "Revisione e chiusura settimanale",
    lib_prog_energy14_d1: "Risveglio con intenzione",
    lib_prog_energy14_d2: "Movimento mattutino leggero",
    lib_prog_energy14_d3: "Idratazione e nutrizione consapevole",
    lib_prog_energy14_d4: "Pause attive durante il giorno",
    lib_prog_energy14_d5: "Respirazione energizzante",
    lib_prog_energy14_d6: "Pisolino consapevole o riposo",
    lib_prog_energy14_d7: "Revisione prima settimana",
    lib_prog_energy14_d8: "Stabilire routine del sonno",
    lib_prog_energy14_d9: "Esercizio di gratitudine mattutina",
    lib_prog_energy14_d10: "Gestione dell'energia emotiva",
    lib_prog_energy14_d11: "Attivazione corpo e mente",
    lib_prog_energy14_d12: "Connessione con la natura",
    lib_prog_energy14_d13: "Riposo restaurativo profondo",
    lib_prog_energy14_d14: "Celebrazione dei progressi",
    lib_prog_balance21_d1: "Intenzione e autocura",
    lib_prog_balance21_d2: "Respirazione equilibrante",
    lib_prog_balance21_d3: "Identifica i tuoi trigger",
    lib_prog_balance21_d4: "Regolazione con pausa",
    lib_prog_balance21_d5: "Esercizio di accettazione",
    lib_prog_balance21_d6: "Comunicazione consapevole",
    lib_prog_balance21_d7: "Revisione settimanale",
    lib_prog_balance21_d8: "Confini sani",
    lib_prog_balance21_d9: "Autocompassione",
    lib_prog_balance21_d10: "Gestione delle aspettative",
    lib_prog_balance21_d11: "Gratitudine attiva",
    lib_prog_balance21_d12: "Resilienza emotiva",
    lib_prog_balance21_d13: "Riposo senza sensi di colpa",
    lib_prog_balance21_d14: "Revisione bisettimanale",
    lib_prog_balance21_d15: "Relazioni e benessere",
    lib_prog_balance21_d16: "Creativita e espressione",
    lib_prog_balance21_d17: "Movimento consapevole",
    lib_prog_balance21_d18: "Spazio personale",
    lib_prog_balance21_d19: "Celebrare le piccole vittorie",
    lib_prog_balance21_d20: "Visualizzazione del futuro",
    lib_prog_balance21_d21: "Integrazione e impegno",
    lib_prog_sleep7_d1: "Spegnere gli schermi un'ora prima",
    lib_prog_sleep7_d2: "Respirazione rilassante per dormire",
    lib_prog_sleep7_d3: "Visualizzazione del luogo sicuro",
    lib_prog_sleep7_d4: "Scansione corporea serale",
    lib_prog_sleep7_d5: "Diario di gratitudine serale",
    lib_prog_sleep7_d6: "Rilassamento muscolare progressivo",
    lib_prog_sleep7_d7: "Chiusura settimanale e riposo profondo",
    lib_routine_morning_s1: "Bevi un bicchiere d'acqua al risveglio",
    lib_routine_morning_s2: "Fai 3 respiri profondi con gli occhi chiusi",
    lib_routine_morning_s3: "Stabilisci la tua intenzione per oggi in una frase",
    lib_routine_morning_s4: "Fai 5 minuti di stretching leggero",
    lib_routine_stress_s1: "Fermati e fai 5 respiri profondi",
    lib_routine_stress_s2: "Stira collo, spalle e schiena per 3 minuti",
    lib_routine_stress_s3: "Metti via il telefono e guarda fuori dalla finestra per 2 minuti",
    lib_routine_stress_s4: "Scrivi qualcosa per cui sei grato oggi",
    lib_routine_stress_s5: "Ascolta l'audio di pausa rapida",
    lib_routine_night_s1: "Spegni tutti gli schermi 30 minuti prima di dormire",
    lib_routine_night_s2: "Fai 5 respiri lenti e profondi",
    lib_routine_night_s3: "Pensa a 3 cose belle successe oggi",
    lib_routine_night_s4: "Ascolta l'audio di preparazione al sonno",
    lib_completed: "Completato",
    lib_mark_complete: "Segna come completato",
    detail_back_history: "Cronologia",
    detail_not_found: "Consultazione non trovata",
    detail_error: "Errore nel caricamento della consultazione",
    detail_qa_title: "Domande e risposte",
    detail_metrics: "Metriche di analisi",
    detail_success: "Probabilita di successo",
    detail_recommendation: "Livello di raccomandazione",
    detail_stress: "Livello di stress",
    detail_happiness: "Livello di felicita",
    detail_recommendation_title: "Raccomandazione",
    detail_motives: "Motivi a favore",
    detail_risks: "Rischi identificati",
    detail_alternative: "Alternativa",
    detail_top3: "Top 3 percorsi consigliati",
    detail_confidence: "Fiducia",
    detail_risk: "Rischio",
    detail_action_plan: "Piano d'azione",
    detail_premium_summary: "Riepilogo premium",

    // Legal footer
    legal_privacy: "Privacy",
    legal_cookies: "Cookie",
    legal_terms: "Termini",
    legal_delete_account: "Elimina account",
    legal_cookie_settings: "Impostazioni cookie",
    legal_rights: "Tutti i diritti riservati.",

    cookie_title: "Questo sito utilizza i cookie",
    cookie_description: "Utilizziamo cookie essenziali per il funzionamento del servizio. Puoi accettare o rifiutare i cookie di analisi opzionali.",
    cookie_accept: "Accetta",
    cookie_reject: "Rifiuta",
    cookie_configure: "Configura",
    cookie_config_title: "Preferenze cookie",
    cookie_essential: "Essenziali",
    cookie_essential_desc: "Necessari per l'autenticazione e il funzionamento di base",
    cookie_analytics: "Analisi",
    cookie_analytics_desc: "Ci aiutano a capire come viene utilizzata la piattaforma",
    cookie_always_active: "Sempre attivi",
    cookie_save: "Salva preferenze",

    cookiep_title: "Politica sui Cookie",
    cookiep_updated: "Ultimo aggiornamento: aprile 2026",
    cookiep_what_title: "1. Cosa sono i cookie",
    cookiep_what_text: "I cookie sono piccoli file di testo memorizzati sul tuo dispositivo quando visiti un sito web.",
    cookiep_types_title: "2. Tipi di cookie utilizzati",
    cookiep_types_text: "Cookie essenziali: necessari per il funzionamento di base della piattaforma. Si attivano automaticamente.\n\nCookie di analisi (opzionali): ci permettono di capire come gli utenti interagiscono con la piattaforma. Si attivano solo con il tuo consenso.",
    cookiep_essential_title: "3. Cookie essenziali",
    cookiep_essential_text: "- Token di autenticazione (JWT): mantiene la tua sessione attiva.\n- Preferenza lingua: ricorda la lingua selezionata.\n- Consenso cookie: memorizza la tua scelta.",
    cookiep_analytics_title: "4. Cookie di analisi",
    cookiep_analytics_text: "Attualmente non utilizziamo servizi di analisi di terze parti. Se in futuro integreremo strumenti, saranno attivati solo con il tuo consenso esplicito.",
    cookiep_manage_title: "5. Come gestire i cookie",
    cookiep_manage_text: "Puoi accettare, rifiutare o configurare i cookie quando appare il banner di consenso. Puoi anche modificare le tue preferenze in qualsiasi momento dal link 'Impostazioni cookie' nel footer.",
    cookiep_revoke_title: "6. Come revocare il consenso",
    cookiep_revoke_text: "Puoi revocare il consenso in qualsiasi momento:\n- Dal link 'Impostazioni cookie' nel footer.\n- Eliminando i cookie dal tuo browser.",
    cookiep_changes_title: "7. Modifiche",
    cookiep_changes_text: "Questa politica puo essere aggiornata. La data di aggiornamento sara indicata in alto.",

    privacy_title: "Informativa sulla Privacy",
    privacy_updated: "Ultimo aggiornamento: aprile 2026",
    privacy_s1_title: "1. Titolare del trattamento",
    privacy_s1_text: "FUTURA DECISIONS APP, persona fisica, con sede in Spagna.\n\nContatto: soporte@futura-app.com\nWeb: www.futura-app.com",
    privacy_s2_title: "2. Dati raccolti",
    privacy_s2_text: "Raccogliamo i seguenti dati:\n- Dati di registrazione: nome, email e password cifrata.\n- Dati di utilizzo: consultazioni, simulazioni, monitoraggio dell'umore e preferenze.\n- Dati di pagamento: elaborati in modo sicuro da Stripe.\n- Dati tecnici: indirizzo IP, tipo di browser e dispositivo.",
    privacy_s3_title: "3. Finalita del trattamento",
    privacy_s3_text: "Utilizziamo i tuoi dati per:\n- Fornire il servizio di simulazione decisionale e benessere emotivo.\n- Gestire il tuo account e abbonamento.\n- Personalizzare l'esperienza all'interno della piattaforma.",
    privacy_s4_title: "4. Base giuridica",
    privacy_s4_text: "Il trattamento dei tuoi dati si basa su:\n- Esecuzione del contratto: per fornirti il servizio richiesto.\n- Consenso: per i cookie di analisi opzionali.\n- Interesse legittimo: per migliorare la sicurezza del servizio.",
    privacy_s5_title: "5. Terze parti e fornitori",
    privacy_s5_text: "Utilizziamo i seguenti fornitori:\n- Stripe: elaborazione pagamenti (PCI-DSS).\n- OpenAI: elaborazione consultazioni tramite IA.\n- Fornitore infrastruttura cloud: hosting del servizio.\n\nNon vendiamo ne condividiamo i tuoi dati con terze parti.",
    privacy_s6_title: "6. Conservazione dei dati",
    privacy_s6_text: "Conserviamo i tuoi dati finche mantieni un account attivo. Se richiedi l'eliminazione, i tuoi dati saranno eliminati permanentemente.",
    privacy_s7_title: "7. Diritti dell'utente",
    privacy_s7_text: "Hai diritto a:\n- Accesso: richiedere una copia dei tuoi dati.\n- Rettifica: correggere dati inesatti.\n- Cancellazione: richiedere l'eliminazione del tuo account e dei dati.\n- Portabilita: ricevere i tuoi dati in formato strutturato.\n- Opposizione: opporti al trattamento in determinate circostanze.",
    privacy_s8_title: "8. Come esercitare i tuoi diritti",
    privacy_s8_text: "Puoi esercitare i tuoi diritti:\n- Eliminando il tuo account dalla sezione profilo dell'app.\n- Contattando soporte@futura-app.com.",
    privacy_s9_title: "9. Sicurezza",
    privacy_s9_text: "Implementiamo misure di sicurezza per proteggere i tuoi dati:\n- Cifratura password tramite bcrypt.\n- Comunicazioni cifrate tramite HTTPS/TLS.\n- Token di autenticazione sicuri (JWT).\n- Elaborazione pagamenti certificata PCI-DSS tramite Stripe.",
    privacy_s10_title: "10. Modifiche",
    privacy_s10_text: "Potremmo aggiornare questa Informativa sulla Privacy. Ti informeremo di modifiche significative.",

    terms_title: "Termini e Condizioni",
    terms_updated: "Ultimo aggiornamento: Aprile 2026",
    terms_s1_title: "1. Natura del servizio",
    terms_s1_text: "FUTURA e una piattaforma di intelligenza artificiale progettata per supportare gli utenti nella crescita personale, nel benessere emotivo e nelle decisioni quotidiane. FUTURA non e un servizio medico, psicologico o terapeutico.",
    terms_s2_title: "2. Ambito delle raccomandazioni",
    terms_s2_text: "Le raccomandazioni e i contenuti generati da FUTURA sono solo a scopo orientativo. Non sostituiscono la consulenza medica, legale o psicologica professionale.",
    terms_s3_title: "3. Tracciamento emotivo (Modulo 1)",
    terms_s3_text: "Il modulo di tracciamento emotivo consente agli utenti di registrare volontariamente umore, energia e stress. I dati vengono utilizzati esclusivamente per generare approfondimenti personalizzati.",
    terms_s4_title: "4. Biblioteca Premium (Modulo 2)",
    terms_s4_text: "Audio guidati e routine nella Biblioteca Premium sono strumenti per supportare il benessere generale. Non sostituiscono terapie o trattamenti medici.",
    terms_s5_title: "5. Raccomandazione di aiuto professionale",
    terms_s5_text: "In caso di disagio emotivo significativo, raccomandiamo vivamente di consultare un professionista qualificato della salute mentale. FUTURA e un complemento, non un sostituto.",
    terms_s6_title: "6. IA e utilizzo dei dati",
    terms_s6_text: "FUTURA utilizza modelli di IA per le raccomandazioni. I dati degli utenti sono archiviati in modo sicuro e non vengono condivisi con terze parti. Gli utenti possono richiedere la cancellazione in qualsiasi momento.",
    terms_s7_title: "7. Piani e abbonamenti",
    terms_s7_text: "FUTURA offre piani gratuiti e a pagamento. Gli abbonamenti sono gestiti tramite Stripe e possono essere annullati in qualsiasi momento.",
    terms_s8_title: "8. Accettazione",
    terms_s8_text: "Utilizzando FUTURA, l'utente accetta questi termini e condizioni. FUTURA si riserva il diritto di modificare questi termini.",
    terms_s9_title: "9. Eliminazione account",
    terms_s9_text: "L'utente puo richiedere l'eliminazione del proprio account e dei dati associati in qualsiasi momento dalla sezione profilo dell'applicazione. L'eliminazione e irreversibile.",
    terms_s10_title: "10. Legge applicabile",
    terms_s10_text: "Questi termini sono regolati dalla legge di Spagna.",
    terms_s11_title: "11. Avatar dinamico e funzionalita associate",
    terms_s11_text: "FUTURA include un avatar visivo personalizzabile che riflette in modo orientativo l'attivita dell'utente sulla piattaforma.\n\nFunzionamento: L'avatar calcola un livello di chiarezza (0-100) basato sull'attivita recente dell'utente (ultimi 7 giorni). Questo livello determina lo stato visivo dell'avatar (Disperso, Focalizzato, Preciso, Potente).\n\nMicro-sfide quotidiane: L'avatar suggerisce attivita opzionali. Sono sempre volontarie e non utilizzano linguaggio che induca sensi di colpa o dipendenza emotiva.\n\nStreak di attivita: Viene mostrato un contatore di giorni consecutivi attivi. E puramente informativo.\n\nNotifiche: L'utente puo attivare volontariamente le notifiche push, che possono essere disattivate in qualsiasi momento.\n\nProtezione dei dati emotivi: I dati sul benessere emotivo sono memorizzati in modo cifrato e utilizzati esclusivamente per calcolare lo stato dell'avatar. Non vengono condivisi con terzi.\n\nLimitazioni: Questa rappresentazione visiva NON e una diagnosi clinica, NON misura stati di salute mentale, NON sostituisce la valutazione di un professionista qualificato e NON deve essere interpretata come consulenza medica o psicologica.",

    delaccount_title: "Elimina account",
    delaccount_subtitle: "Informazioni su come eliminare il tuo account FUTURA",
    delaccount_how_title: "Come eliminare il tuo account",
    delaccount_how_text: "Per eliminare il tuo account:\n1. Accedi al tuo account FUTURA.\n2. Vai al tuo profilo.\n3. Scorri fino in fondo.\n4. Tocca 'Elimina account'.\n5. Inserisci la tua password per confermare.\n6. Il tuo account e tutti i dati associati verranno eliminati permanentemente.",
    delaccount_what_title: "Quali dati vengono eliminati",
    delaccount_what_text: "Quando elimini il tuo account, vengono rimossi permanentemente dal server:\n- Il tuo profilo e i dati di registrazione.\n- Tutte le consultazioni e simulazioni.\n- La cronologia degli stati d'animo.\n- Le voci del diario.\n- Preferenze e impostazioni.",
    delaccount_contact_title: "Contatto",
    delaccount_contact_text: "Se non riesci ad accedere al tuo account, contatta soporte@futura-app.com.",
    delaccount_cta_text: "Per eliminare il tuo account, effettua prima l'accesso.",
    delaccount_cta_button: "Accedi",

    profile_delete_account: "Elimina account",
    profile_delete_warning_title: "Questa azione e irreversibile",
    profile_delete_warning_text: "Il tuo account, simulazioni, cronologia emotiva, diario e tutti i dati associati saranno eliminati permanentemente.",
    profile_delete_password_label: "Inserisci la tua password per confermare",
    profile_delete_confirm: "Elimina permanentemente il mio account",

    // Avatar System
    avatar_setup_title: "Personalizza il tuo avatar",
    avatar_setup_subtitle: "Scegli un colore per il tuo avatar. Si evolvera con te in base alla tua attivita e chiarezza emotiva.",
    avatar_setup_save: "Attiva il mio avatar",
    avatar_choose_color: "Scegli il tuo colore",
    avatar_state_dormant: "Disperso",
    avatar_state_awakening: "Focalizzato",
    avatar_state_clear: "Preciso",
    avatar_state_radiant: "Potente",
    avatar_widget_title: "Il tuo avatar",
    avatar_clarity_score: "Livello di chiarezza",
    avatar_insight_dormant: "Il tuo avatar riflette meno attivita recente. Potrebbe essere un buon momento per una pausa consapevole.",
    avatar_insight_awakening: "Sei sulla strada giusta. Continua a esplorare le tue emozioni e a prendere decisioni consapevoli.",
    avatar_insight_clear: "Il tuo focus sta crescendo. Le tue decisioni e il tuo benessere sono allineati.",
    avatar_insight_radiant: "Un momento di grande energia. Il tuo avatar riflette il tuo impegno verso te stesso.",
    avatar_metric_checkins: "Check-in",
    avatar_metric_consults: "Consulte",
    avatar_metric_diary: "Diario",
    avatar_deep_analysis_title: "Analisi approfondita",
    avatar_deep_analysis_desc: "Sblocca insight avanzati e pattern emotivi con il piano Avanza.",
    avatar_upgrade_cta: "Vedi piano Avanza",
    avatar_deep_insight_title: "Il tuo insight",
    avatar_deep_insight_desc: "La tua attivita recente mostra un pattern positivo di autoconsapevolezza. Continua cosi.",
    avatar_disclaimer: "L'avatar e una rappresentazione visiva della tua attivita in FUTURA. Non costituisce una diagnosi clinica ne sostituisce l'assistenza professionale.",
    avatar_landing_badge: "Il tuo avatar ti aspetta",
    avatar_landing_title: "Senti chiarezza. Decidi meglio. Evolvi con te.",
    avatar_landing_subtitle: "Il tuo avatar non e una funzionalita. E il riflesso vivo di come ti senti quando inizi a prendere decisioni con chiarezza.",
    avatar_landing_desc: "Non si tratta di fare di piu.\nSi tratta di sentirti meglio mentre decidi.\n\nIl tuo avatar si evolve con te, in silenzio. Senza giudizi. Senza pressione.\nSolo progresso visibile.",
    avatar_landing_f1: "Si evolve in tempo reale con il tuo benessere",
    avatar_landing_f2: "Rendilo tuo: personalizzalo davvero",
    avatar_landing_f3: "Micro-sfide quotidiane per riconnetterti con te stesso",
    avatar_landing_f4: "Insight chiari per capir(ti), senza rumore",
    avatar_landing_cta: "Inizia a sentire la differenza",
    hero_main_title: "Simula le tue decisioni con IA. Il tuo avatar si evolve con te.",
    hero_main_subtitle: "FUTURA analizza ogni decisione che ti preoccupa e ti offre scenari, probabilita e alternative reali.",
    hero_sim_title: "Simulazione decisioni",
    hero_sim_desc: "IA che analizza le tue decisioni quotidiane",
    hero_sim_example: "\"Sto pensando di cambiare lavoro...\"",
    hero_sim_result_desc: "Analisi con motivazioni, rischi e alternative personalizzate",
    hero_sim_risks: "Rischi",
    hero_sim_alternatives: "Alternative",
    hero_sim_footer: "Ogni simulazione analizza la tua situazione reale con IA avanzata",
    hero_avatar_title: "Il tuo avatar personale",
    hero_avatar_desc: "Riflette il tuo benessere mentre decidi",
    hero_step1_title: "Descrivi la tua decisione",
    hero_step1_desc: "Raccontaci cosa ti preoccupa. L'IA ti fara domande.",
    hero_step2_title: "Ricevi la tua analisi",
    hero_step2_desc: "Probabilita di successo, motivazioni, rischi e alternative.",
    hero_step3_title: "Evolvi con il tuo avatar",
    hero_step3_desc: "Il tuo avatar riflette la tua chiarezza. Micro-sfide quotidiane.",
    avatar_disclaimer: "L'avatar e una rappresentazione visiva della tua attivita in FUTURA. Non costituisce una diagnosi clinica ne sostituisce la consulenza professionale sulla salute mentale.",
    avatar_fullscreen_title: "Il tuo avatar",
    avatar_fullscreen_close: "Chiudi",
    avatar_challenge_title: "La tua micro-sfida di oggi",
    avatar_challenge_accept: "Accetto la sfida",
    avatar_challenge_done: "Sfida completata",
    avatar_challenge_skip: "Forse domani",
    avatar_fullscreen_btn: "Vista grande",
    avatar_fullscreen_hint: "Apri la vista ampliata del tuo avatar",
    avatar_widget_hint: "Tocca per vedere il tuo avatar e i progressi",
    avatar_tap_hint: "Tocca il tuo avatar",
    avatar_notif_title: "Notifiche",
    avatar_notif_enable: "Attiva notifiche",
    avatar_notif_enabled: "Notifiche attive",
    avatar_notif_instructions_title: "Attiva notifiche",
    avatar_notif_instructions_app: "Nell'app FUTURA: vai in Impostazioni del telefono -> App -> FUTURA -> Notifiche e attivale. Poi torna all'app.",
    avatar_notif_instructions_web: "Le notifiche sono bloccate nel tuo browser. Clicca sull'icona del lucchetto accanto all'URL e consenti le notifiche.",
    avatar_notif_instructions_ok: "Ho capito",
    avatar_notif_desc: "Ricevi micro-sfide quotidiane dal tuo avatar",
    avatar_ethical_banner: "Questo strumento non sostituisce la consulenza professionale sulla salute mentale.",
    avatar_streak: "giorni consecutivi",
    avatar_streak_msg: "Ogni giorno conta. La tua costanza si riflette nel tuo avatar.",
    streak_recovery_title: "Recupera serie",
    streak_recovery_available: "Abbiamo rilevato un giorno senza attivita. Puoi recuperare la tua serie (1x/mese, piano Decide/Avanza).",
    streak_recovery_apply: "Recupera la mia serie",
    streak_recovery_used_month: "Hai gia usato il tuo recupero questo mese. Disponibile di nuovo il prossimo mese.",
    streak_recovery_no_gap: "Nessuna serie da recuperare. La tua costanza e intatta.",
    avatar_timeline_btn: "La tua storia",
    avatar_timeline_btn_desc: "Guarda come ti sei evoluto nel tempo",
    timeline_title: "La tua linea temporale",
    timeline_empty: "La tua storia inizia qui",
    timeline_empty_hint: "Fai una consulta, un check-in o scrivi nel tuo diario per iniziare.",
    timeline_type_consultation: "Simulazione",
    timeline_type_mood: "Check-in emotivo",
    timeline_type_diary: "Diario",
    timeline_type_challenge: "Micro-sfida completata",
    mood_label: "Umore",
    energy_label: "Energia",
    stress_label: "Stress",
    avatar_challenge_checkin: "Potrebbe essere un buon momento per registrare come ti senti oggi.",
    avatar_challenge_consult: "Se hai una decisione in sospeso, oggi potrebbe essere il giorno giusto.",
    avatar_challenge_breathe: "3 respiri profondi possono fare la differenza. Solo se ti va.",
    avatar_challenge_gratitude: "Pensa a qualcosa di buono che ti e successo oggi. Solo un momento per te.",
    avatar_challenge_pause: "Una pausa di 5 minuti puo aiutarti. Decidi tu quando.",
    avatar_challenge_diary: "Scrivere cio che senti puo portare chiarezza. Senza fretta, senza pressione.",
    avatar_challenge_walk: "Una breve passeggiata puo cambiare la tua prospettiva. Quando vuoi.",

    // Interactive Premium Tools
    tool_done: "Fatto",
    tool_close: "Chiudi",
    tool_breathing_title: "Respirazione 4-7-8",
    tool_breathing_subtitle: "Tecnica guidata senza audio per calmare corpo e mente",
    tool_breathing_card_desc: "Un cerchio luminoso guida il tuo respiro. Inspira 4s, trattieni 7s, espira 8s.",
    tool_breathing_duration: "2-5 min",
    tool_breathing_ready: "Preparati",
    tool_breathing_inhale: "Inspira",
    tool_breathing_hold: "Trattieni",
    tool_breathing_exhale: "Espira",
    tool_breathing_hint: "Segui il cerchio. Piu pratichi, piu rapidamente senti la calma.",
    tool_breathing_cycles: "cicli completati",
    tool_breathing_start: "Inizia",
    tool_breathing_stop: "Ferma",
    tool_grounding_title: "Grounding 5-4-3-2-1",
    tool_grounding_subtitle: "Tecnica sensoriale contro l'ansia nei momenti di sovraccarico",
    tool_grounding_card_desc: "Identifica 5 cose che vedi, 4 che tocchi, 3 che senti, 2 che odori, 1 che assapori.",
    tool_grounding_duration: "3-5 min",
    tool_grounding_see_title: "cose che VEDI",
    tool_grounding_see_hint: "Guardati intorno e descrivi cio che vedi.",
    tool_grounding_see_placeholder: "Qualcosa che vedi ora",
    tool_grounding_touch_title: "cose che TOCCHI",
    tool_grounding_touch_hint: "Nota texture, temperature e pesi vicini.",
    tool_grounding_touch_placeholder: "Qualcosa che puoi toccare",
    tool_grounding_hear_title: "cose che SENTI",
    tool_grounding_hear_hint: "Presta attenzione ai suoni, anche i piu sottili.",
    tool_grounding_hear_placeholder: "Un suono intorno a te",
    tool_grounding_smell_title: "cose che ODORI",
    tool_grounding_smell_hint: "Identifica odori vicini o ricordati.",
    tool_grounding_smell_placeholder: "Un odore che percepisci",
    tool_grounding_taste_title: "cosa che ASSAPORI",
    tool_grounding_taste_hint: "Nota il sapore in bocca o l'ultimo assaggiato.",
    tool_grounding_taste_placeholder: "Un sapore presente",
    tool_grounding_next: "Avanti",
    tool_grounding_finish: "Termina",
    tool_grounding_done_title: "Sei qui, presente",
    tool_grounding_done_msg: "Sei tornato al tuo corpo e a questo momento. L'ansia perde forza quando ti radichi.",
    tool_grounding_restart: "Ripeti",
    tool_screenbreak_title: "Sfida senza schermo",
    tool_screenbreak_subtitle: "Impegnati a non usare il telefono per X minuti",
    tool_screenbreak_card_desc: "Scegli un tempo, posa il telefono. Se esci dall'app, la sfida fallisce.",
    tool_screenbreak_duration: "5-45 min",
    tool_screenbreak_streak: "Serie",
    tool_screenbreak_total_min: "Min senza schermo",
    tool_screenbreak_pick_time: "Quanto tempo ti impegni a riposare?",
    tool_screenbreak_min: "min",
    tool_screenbreak_warning: "Puoi bloccare il telefono — il cronometro continua. Ma se passi a un'altra app, la sfida fallirà.",
    tool_screenbreak_hint: "Puoi bloccare il telefono — il cronometro continua. Ma se passi a un'altra app, la sfida fallirà.",
    tool_screenbreak_rules: "Puoi bloccare il telefono — il cronometro continua. Ma se passi a un'altra app, la sfida fallirà.",
    tool_screenbreak_start: "Inizia sfida",
    tool_screenbreak_remaining: "Rimanente",
    tool_screenbreak_keep_here: "Posalo a faccia in giu e fai qualcosa di analogico.",
    tool_screenbreak_leave_fails: "Uscire dall'app farà fallire la sfida.",
    tool_screenbreak_lock_ok: "Puoi bloccare il telefono tranquillamente: il tempo continua a scorrere.",
    tool_screenbreak_week_min: "min questa settimana",
    tool_screenbreak_cancel: "Annulla sfida",
    tool_screenbreak_success_title: "Ce l'hai fatta!",
    tool_screenbreak_success_msg: "Hai riposato {minutes} minuti senza schermo. Il tuo cervello ti ringrazia.",
    tool_screenbreak_again: "Nuova sfida",
    tool_screenbreak_fail_title: "Pausa digitale non superata",
    tool_screenbreak_fail_msg: "Sei uscito dall'app o hai annullato troppo presto. Nessuna pressione, riprova quando sei pronto.",
    tool_screenbreak_retry: "Riprova",

  }
};

export default translations;
